import { t as Tt } from "./module.esm-CVhmt7qZ.js";
import { a as An, i as Nn, n as qr, r as Lr } from "./focus-CD3u82tH.js";
import { a as $t, i as Dn, n as Pr, r as $r, t as Fr } from "./giftMessage-BdVeE-oX.js";
import { t as _r } from "./queueBounce-BYbNS_fP.js";
import { t as wt } from "./morphNodes-D-0jCzKf.js";
import { n as Mr, r as Jr, t as Br } from "./searchStore-BMAUUWJk.js";
var Ur = {
  "x-transition:enter": "transition-opacity ease-linear duration-300",
  "x-transition:enter-start": "opacity-0",
  "x-transition:enter-end": "opacity-100",
  "x-transition:leave": "transition-opacity ease-linear duration-300",
  "x-transition:leave-start": "opacity-100",
  "x-transition:leave-end": "opacity-0"
}, qn = {
  "x-transition:enter": "transition ease-in-out duration-300 transform",
  "x-transition:enter-start": "-translate-x-full",
  "x-transition:enter-end": "translate-x-0",
  "x-transition:leave": "transition ease-in-out duration-300 transform",
  "x-transition:leave-start": "translate-x-0",
  "x-transition:leave-end": "-translate-x-full"
}, jr = (e) => e.data("addressSwitch", ({ addresses: t }) => ({
  addresses: t,
  slideTransition: qn,
  visibleForm: !1,
  currentlyEditedAddress: null,
  trigger: null,
  showForm() {
    this.trigger = document.activeElement, this.visibleForm = !0, this.focusHeading(this.scrollFormIntoView());
  },
  editAddress(n) {
    this.trigger = document.activeElement, this.visibleForm = !0, this.currentlyEditedAddress = this.addresses.find((r) => r.id === n), this.focusHeading(this.scrollFormIntoView());
  },
  cancelEdit() {
    this.visibleForm = !1, this.currentlyEditedAddress = null;
    const n = this.trigger;
    this.trigger = null, this.$nextTick(() => {
      n?.isConnected ? n.focus() : this.scrollFormIntoView();
    });
  },
  focusHeading(n) {
    this.$nextTick(() => this.$refs.formHeading?.focus({ preventScroll: n }));
  },
  scrollFormIntoView() {
    return window.matchMedia("(max-width: 1023px)").matches ? (document.querySelector(".address-form")?.scrollIntoView({ behavior: "smooth" }), !0) : !1;
  }
})), Vr = (e) => e.data("announcement", (t) => {
  const { settings: n } = t;
  return {
    current: 0,
    init() {
      n.auto_scroll && t.count > 0 && this.autoScroll(), this.$watch("current", (r) => this.autoScroll(r));
    },
    change(r) {
      this.current = r;
    },
    autoScroll(r = 0) {
      r >= t.count ? r = 0 : r += 1, setTimeout(() => this.change(r), n.delay * 1e3);
    },
    scrollThrough() {
      return {
        "x-transition:enter": "transition ease-in-out duration-300 transform absolute delay-300",
        "x-transition:enter-start": "-translate-y-full opacity-0",
        "x-transition:enter-end": "translate-y-0",
        "x-transition:leave": "transition ease-in-out duration-300 transform absolute",
        "x-transition:leave-start": "translate-y-0",
        "x-transition:leave-end": "translate-y-full opacity-0 "
      };
    }
  };
}), Hr = (e) => {
  e.data("backInStock", (t, n) => ({
    open: !1,
    sending: !1,
    sent: !1,
    query: {
      a: "Mtd5NY",
      g: "",
      email: "",
      variant: n,
      product: t,
      platform: "shopify",
      subscribe_for_newsletter: !1
    },
    get emailIsValid() {
      return /.+@.+\..+/.test(this.query.email);
    },
    get buttonLabel() {
      return this.sending ? "Sending..." : this.sent ? "Sent!" : "Notify Me When Available";
    },
    async submit() {
      if (!this.query.email) return;
      const r = "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", i = {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(this.query)
      };
      this.sending = !0;
      try {
        const s = await fetch(r, i);
        if (!s.ok) throw new Error("Failed to subscribe");
        if (!(await s.json()).success) throw new Error("Failed to subscribe");
      } catch (s) {
        console.error(s);
      }
      this.sending = !1, this.sent = !0, setTimeout(() => this.open = !1, 2e3);
    }
  }));
}, zr = (e) => {
  e.data("cardBadges", (t) => ({
    product: t,
    badgeRules: [],
    matched: null,
    init() {
      this.badgeRules = JSON.parse(this.$el.querySelector("script[data-badges]")?.textContent ?? "[]");
    },
    badgeFieldValue(n) {
      const r = this.product.additional_data || {};
      for (const i of n.keys || []) {
        const s = r[i], a = Array.isArray(s) ? s.find((o) => String(o).trim() !== "") : s;
        if (a != null && String(a).trim() !== "") return String(a).trim();
      }
      return "";
    },
    badgeLabel(n) {
      if (n.kind === "tag") return (this.product.tags || []).map((i) => String(i).trim().toLowerCase()).includes(n.tag) ? n.label : null;
      if (n.kind === "sold_out") return this.product.available === !1 ? n.label : null;
      const r = this.badgeFieldValue(n);
      return r === "" || r === "false" || r === "0" ? null : n.kind === "metafield_text" ? r : n.label;
    },
    resolveBadge() {
      for (const n of this.badgeRules) {
        const r = this.badgeLabel(n);
        if (r) return {
          ...n,
          label: r
        };
      }
      return null;
    }
  }));
}, Se = (e, t) => t instanceof e ? t : null, Kr = (e, t, n = 0) => Math.min(Math.max(e, n), t), $e = {}, Wr = async (e) => {
  const t = e.toString();
  if ($e[t]) return $e[t];
  const n = await fetch(e);
  return n.ok ? ($e[t] = await n.text(), $e[t]) : null;
}, Gr = () => new Promise((e) => queueMicrotask(() => setTimeout(e, 0))), Yr = (e, t, n = 0) => (e - n) % (t - n) + n, Xr = 5e3, Ft = /* @__PURE__ */ new Set(), Qr = (e) => e.data("cartDrawer", () => ({
  activeUpdates: 0,
  pending: !1,
  status: "",
  statusTimer: 0,
  giftDraft: null,
  pendingAdd: "",
  opener: null,
  init() {
    this.refresh = this.refresh.bind(this), this.debouncedUpdate = e.debounce(this.debouncedUpdate.bind(this), 500);
    const t = this.$el, n = this.$abortSignal;
    this.$store.cart.addEventListener("open", this.refresh, { signal: n }), this.$store.cart.addEventListener("load", this.refresh, { signal: n }), window.addEventListener("product-added", (r) => {
      const i = r.detail?.title;
      i && (this.pendingAdd = Dn(t.dataset.addedLabel ?? "", { variant: i }));
    }, { signal: n }), this.$store.cart.addEventListener("open", () => {
      this.opener = Nn(document.body);
    }, { signal: this.$abortSignal }), this.$store.cart.addEventListener("close", () => {
      const r = this.opener;
      this.opener = null, setTimeout(() => {
        r && !r.el.isConnected && setTimeout(() => An(document.body, r), 0);
      });
    }, { signal: n });
  },
  async refresh() {
    const t = new URL(window.location.href), n = _t();
    this.activeUpdates++, t.searchParams.set("sections", n.join(","));
    const r = await fetch(t);
    if (n.length && --this.activeUpdates == 0) {
      const i = await r.json();
      wt(Object.values(i).join(""), []), this.pendingAdd && (this.announce(this.pendingAdd), this.pendingAdd = "");
    }
  },
  close() {
    this.$store.cart.close();
  },
  async postCart(t, n, r = {}) {
    const i = r.swap !== !1, s = document.activeElement, a = s?.matches(":focus-visible"), o = "id" in n ? "quantity" in n && n.quantity === 0 ? Zr(n.id) : n.id : "", c = i ? _t() : [];
    i && this.activeUpdates++;
    const d = await fetch(t, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(c.length ? {
        ...n,
        sections: c.join(",")
      } : n)
    }), l = await d.json().catch(() => ({}));
    if (!d.ok)
      throw i && this.activeUpdates--, this.activeUpdates === 0 && this.refresh(), new Error(String(l.description ?? l.message ?? d.statusText));
    if (c.length && --this.activeUpdates == 0) {
      const u = wt(Object.values(l.sections ?? {}).join(""), []);
      if (o && (u === s || !u && qr())) {
        const m = ti(o);
        m && Lr(m, a);
      }
    }
    return l;
  },
  announce(t) {
    window.clearTimeout(this.statusTimer), this.status = "", this.$nextTick(() => {
      this.status = t, t && (this.statusTimer = window.setTimeout(() => {
        this.status = "";
      }, Xr));
    });
  },
  removeItem(t) {
    this.updateItem(t, 0);
  },
  updateItem(t, n) {
    this.pending = !0, this.debouncedUpdate(t, n);
  },
  async debouncedUpdate(t, n) {
    try {
      await this.changeQuantity(t, n);
    } finally {
      this.pending = !1;
    }
  },
  async changeQuantity(t, n) {
    const r = ei(t);
    r && await this.postCart("/cart/change.js", {
      id: r,
      quantity: n
    }, { swap: !1 }), await this.postCart("/cart/change.js", {
      id: t,
      quantity: n
    });
  },
  async fixPersonalization(t, n) {
    const r = `${t}:${n}`;
    if (!Ft.has(r)) {
      Ft.add(r);
      try {
        await this.postCart("/cart/change.js", {
          id: t,
          quantity: n
        }, { swap: !1 });
      } catch (i) {
        console.error("Personalization fix failed:", i);
        return;
      }
      await this.refresh();
    }
  },
  async changeItem(t, n) {
    await this.postCart("/cart/change.js", {
      id: t,
      properties: n
    });
  },
  async changeSellingPlan(t, n, r = 1) {
    await this.postCart("/cart/change.js", {
      id: t,
      selling_plan: n,
      quantity: r
    });
  }
})), Ln = (e) => `#cart-drawer [data-line-key="${CSS.escape(e)}"]`, Zr = (e) => {
  const t = Array.from(document.querySelectorAll("#cart-drawer [data-line-key]")), n = t.findIndex((r) => r.dataset.lineKey === e);
  return n < 0 ? null : (t[n + 1] ?? t[n - 1])?.dataset.lineKey ?? null;
}, ei = (e) => {
  const { personalizationKey: t, personalizationQuantity: n, quantity: r } = document.querySelector(Ln(e))?.dataset ?? {};
  return t && n === r ? t : null;
}, ti = (e) => {
  const t = e ? document.querySelector(Ln(e)) : null;
  return t?.querySelector(".line-item-title a") ?? t?.querySelector("a[href], button") ?? document.querySelector("#cart-drawer [data-cart-empty]") ?? document.querySelector("#cart-drawer button");
}, _t = () => {
  const e = Array.from(document.querySelectorAll(".shopify-section:has([data-oob-swap])"), (t) => t?.id.replace("shopify-section-", "") ?? "");
  return Array.from(new Set(e));
}, Z = (e) => e, Mt = () => !!window.Shopify?.designMode, ni = (e) => e.data("cartGiftMessage", (t) => ({
  open: !1,
  editing: !t.saved,
  card: t.cardInCart,
  saving: !1,
  error: "",
  values: {},
  errors: {},
  fields: [],
  lastAnnounced: {},
  counterTimer: 0,
  init() {
    const n = Array.from(this.$root.querySelectorAll("[data-gm-field]"));
    this.fields = n.map((s) => ({
      key: s.dataset.key ?? "",
      label: s.dataset.label ?? "",
      required: s.dataset.required === "true",
      limit: Number(s.dataset.limit ?? 0)
    }));
    const r = Object.fromEntries(n.map((s) => [s.dataset.key ?? "", s.querySelector("input, textarea")?.value ?? ""])), i = Z(this).giftDraft;
    this.values = {
      ...r,
      ...i?.values ?? {}
    }, this.open = i?.open ?? t.editorOpen, this.editing = i?.editing ?? !t.saved, this.card = t.cardInCart ? !0 : i?.card ?? !1, this.error = i?.error ?? "";
  },
  context() {
    return {
      cardVariantId: t.cardVariantId,
      cardInCart: t.cardInCart,
      cardLineKey: t.cardLineKey,
      cardQuantity: t.cardQuantity,
      copyToNote: t.copyToNote
    };
  },
  control(n) {
    return Array.from(this.$root.querySelectorAll("[data-gm-field]")).find((r) => r.dataset.key === n)?.querySelector("input, textarea") ?? null;
  },
  focusKey(n) {
    this.$root.querySelector(`[data-focus-key="${n}"]`)?.focus();
  },
  focusFirstField() {
    const n = this.fields.find((r) => !this.control(r.key)?.disabled);
    n && this.control(n.key)?.focus();
  },
  persist() {
    Z(this).giftDraft = {
      open: this.open,
      editing: this.editing,
      card: this.card,
      values: { ...this.values },
      error: this.error
    };
  },
  clearDraft() {
    Z(this).giftDraft = null;
  },
  toggle() {
    this.open = !this.open, this.persist();
  },
  collapse() {
    if (t.saved && this.editing) {
      this.editing = !1, this.persist(), this.$nextTick(() => this.focusKey("gift-edit"));
      return;
    }
    this.open = !1, this.persist(), this.$nextTick(() => this.focusKey("gift-toggle"));
  },
  edit() {
    this.editing = !0, this.open = !0, this.persist(), this.$nextTick(() => this.focusFirstField());
  },
  onInput(n) {
    if (this.errors[n]) {
      const r = this.fields.find((s) => s.key === n), i = r ? $t([r], this.values, t.strings) : {};
      if (i[n])
        this.errors = {
          ...this.errors,
          [n]: i[n]
        };
      else {
        const { [n]: s, ...a } = this.errors;
        this.errors = a;
      }
    }
    this.persist(), this.scheduleCounterAnnouncement(n);
  },
  onCardChange() {
    if (!this.card) {
      const n = this.$root.querySelector("fieldset"), r = document.activeElement;
      n && r && n.contains(r) && this.$root.querySelector('input[type="checkbox"]')?.focus();
    }
    this.persist();
  },
  counterText(n, r) {
    return $r(this.values[n] ?? "", r, t.strings);
  },
  describedBy(n, r, i) {
    const s = [r, this.errors[n] ? i : ""].filter(Boolean);
    return s.length ? s.join(" ") : null;
  },
  scheduleCounterAnnouncement(n) {
    const r = this.fields.find((i) => i.key === n);
    !r || r.limit <= 0 || (window.clearTimeout(this.counterTimer), this.counterTimer = window.setTimeout(() => {
      const i = r.limit - (this.values[n] ?? "").length, s = i <= 0 ? 0 : i <= 20 ? 20 : -1;
      if (s < 0 || this.lastAnnounced[n] === s) {
        s < 0 && delete this.lastAnnounced[n];
        return;
      }
      this.lastAnnounced[n] = s, Z(this).announce(s === 0 ? t.strings.limitReached : Dn(t.strings.charsRemaining, { count: i }));
    }, 500));
  },
  async save() {
    if (Mt() || this.saving) return;
    this.error = "", this.errors = $t(this.fields, this.values, t.strings);
    const n = this.fields.find((s) => this.errors[s.key]);
    if (n) {
      this.$nextTick(() => this.control(n.key)?.focus());
      return;
    }
    const r = Pr(this.fields, this.values, this.context());
    this.saving = !0, Z(this).giftDraft = {
      open: !0,
      editing: !1,
      card: !1,
      values: {},
      error: ""
    };
    let i = 0;
    try {
      for (const s of r)
        await Z(this).postCart(s.path, s.body, { swap: s.swap }), i++;
      Z(this).announce(t.cardVariantId !== null && !t.cardInCart ? t.strings.cardAdded : t.strings.saved);
    } catch {
      this.saving = !1, this.error = t.strings.error, this.persist(), i > 0 && r.length > 1 && await Z(this).refresh();
    }
  },
  async remove() {
    if (Mt() || this.saving) return;
    this.error = "", this.saving = !0, this.clearDraft();
    const n = Fr(this.fields, this.context());
    try {
      await Z(this).postCart(n.path, n.body, { swap: n.swap }), Z(this).announce(t.cardVariantId !== null && t.cardInCart ? t.strings.cardRemoved : t.strings.removed);
    } catch {
      this.saving = !1, this.error = t.strings.error, this.persist();
    }
  }
})), ri = (e) => e.data("collectionFilters", (t) => ({
  ...t,
  open: !1,
  fadeTransition: {
    "x-transition:enter": "transition-opacity ease-linear duration-300",
    "x-transition:enter-start": "opacity-0",
    "x-transition:enter-end": "opacity-100",
    "x-transition:leave": "transition-opacity ease-linear duration-300",
    "x-transition:leave-start": "opacity-100",
    "x-transition:leave-end": "opacity-0"
  },
  slideTransition: {
    "x-transition:enter": "transition ease-in-out duration-300 transform",
    "x-transition:enter-start": "-translate-x-full",
    "x-transition:enter-end": "translate-x-0",
    "x-transition:leave": "transition ease-in-out duration-300 transform",
    "x-transition:leave-start": "translate-x-0",
    "x-transition:leave-end": "-translate-x-full"
  }
})), ii = (e) => e.data("detailsElement", () => ({
  isOpen: !1,
  theDetails: null,
  summaryElement: null,
  init() {
    this.summaryElement = this.$el.querySelector("summary"), this.summaryElement.setAttribute("aria-expanded", !1), this.summaryElement.setAttribute("aria-controls", this.$refs.contentElement.id), this.theDetails = this.$el, this.$watch("$store.mobileMenu.visible", (t) => !t && this.close());
  },
  open() {
    this.summaryElement.setAttribute("aria-expanded", !0), this.$nextTick(() => {
      this.isOpen = !0;
    });
  },
  cleanUp() {
    setTimeout(() => {
      this.theDetails.removeAttribute("open").then(() => this.isOpen = !1);
    }, 200);
  },
  close() {
    this.isOpen = !1, this.summaryElement.setAttribute("aria-expanded", !1), setTimeout(() => {
      this.theDetails.removeAttribute("open");
    }, 300);
  },
  detailsContent: {
    "x-show"() {
      return this.isOpen;
    },
    "x-transition:enter": "transition-transform",
    "x-transition:enter-start": "translate-x-full",
    "x-transition:leave": "transition-transform",
    "x-transition:leave-end": "translate-x-full"
  }
})), ai = (e) => {
  e.addRootSelector(() => `[${e.prefixed("dynamic-image")}]`), e.addInitSelector(() => `[${e.prefixed("dynamic-image-broadcaster")}]`), e.directive("dynamic-image", $n), e.directive("dynamic-image-broadcaster", si), e.directive("dynamic-image-image", ci);
}, Pn = /* @__PURE__ */ new WeakMap(), $n = (e, t, { Alpine: n }) => {
  console.log("Setting up Dynamic Image Node");
  const r = Pn.get(e);
  if (!r) return console.error("Dynamic Image Failed to Register: ", e, t.value);
  n.addScopeToNode(e, r);
};
$n.inline = (e, t, { Alpine: n, cleanup: r }) => {
  console.log("Setting Dynamic Image Handler");
  const i = n.reactive({ image: null });
  Pn.set(e, i);
  const s = new AbortController();
  e.closest("section")?.addEventListener("dynamic-image-update", (a) => {
    console.log("Dynamic Image receiving Event"), i.image = a.detail;
  }, { signal: s.signal }), r(s.abort.bind(s));
};
var si = (e, { value: t, expression: n, modifiers: r }, { Alpine: i, cleanup: s }) => {
  if (console.log("Setting up Dynamic Image Broadcaster"), t === "intersect") {
    console.log("Dynamic Image Root:", n);
    const a = new IntersectionObserver((o) => {
      for (const c of o) c.isIntersecting ? (console.log("Dynamic Image Broadcaster Intersecting "), oi(e)) : console.log("Dynamic Image Broadcaster NOT Intersecting ");
    }, { rootMargin: n });
    r.includes("parent") && a.observe(e.parentElement), a.observe(e), s(a.disconnect.bind(a));
  }
}, oi = (e) => {
  e.dispatchEvent(new CustomEvent("dynamic-image-update", {
    detail: JSON.parse(e.querySelector("script")?.textContent ?? "null"),
    bubbles: !0
  }));
}, ci = (e, t, { Alpine: n, effect: r }) => {
  if (!(e instanceof HTMLTemplateElement)) return console.error("Dynamic Image Image must be Template Element");
  const i = e.content;
  let s = null;
  const a = n.$data(e);
  console.log("Registering Dynamic Image Effect"), r(() => {
    if (console.log("running Dynamic Image Effect"), "image" in a && a.image) {
      const o = a.image, c = document.importNode(i, !0).firstElementChild;
      if (!(c instanceof HTMLImageElement)) return console.error("Dynamic Image Template Must have an img child");
      if (n.bind(c, {
        "x-rias"() {
          return o.url;
        },
        width: o.width,
        height: o.height,
        alt: o.alt
      }), (s ?? e).after(c), new Animation(new KeyframeEffect(c, [{ opacity: "0" }, { opacity: "1" }], {
        duration: 500,
        fill: "both"
      })).play(), s) {
        const d = new Animation(new KeyframeEffect(s, [{ opacity: "1" }, { opacity: "0" }], {
          duration: 500,
          fill: "both",
          delay: 500
        }));
        d.play(), d.addEventListener("finish", s.remove.bind(s));
      }
      s = c;
    }
  });
}, di = (e) => e == null ? [] : Array.isArray(e) ? e.map((t) => Number(t)) : typeof e == "number" && !Number.isNaN(e) ? [e] : typeof e == "string" ? e.split(",").map((t) => t.trim()).filter(Boolean).map((t) => Number(t)) : [], li = (e) => e ? Array.isArray(e) ? e.map(String) : typeof e == "string" ? e.split(",").map((t) => t.trim()).filter(Boolean) : [] : [], ui = (e) => e ? typeof e == "string" ? e : String(e) : "", Fe = (e) => {
  const t = e ?? {};
  let n = Number(t.cutOffHour);
  Number.isFinite(n) || (n = 14);
  let r = Number(t.leadTime);
  return Number.isFinite(r) || (r = 0), {
    cutOffHour: n,
    leadTime: r,
    messageHtml: ui(t.messageHtml),
    isCustomMessage: !!t.isCustomMessage,
    restrictedDays: di(t.restrictedDays),
    restrictedDates: li(t.restrictedDates)
  };
}, Jt = (e) => e.dayOfWeek % 7, hi = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
], fi = (e) => {
  let t = Math.max(0, Math.floor(e));
  const n = Math.floor(t / 86400);
  t %= 86400;
  const r = Math.floor(t / 3600);
  return t %= 3600, {
    days: n,
    hours: r,
    minutes: Math.floor(t / 60),
    seconds: t % 60
  };
}, mi = (e) => {
  const t = e.dataset.esCfgId;
  if (!t) return Fe(void 0);
  const n = document.getElementById(t);
  if (!n?.textContent?.trim()) return Fe(void 0);
  try {
    const r = JSON.parse(n.textContent);
    return Fe(r);
  } catch {
    return Fe(void 0);
  }
}, mt = "America/Chicago", pi = (e) => {
  e.data("estimatedShipping", (t = {}) => ({
    cutOffHour: 0,
    leadTime: 0,
    messageHtml: "",
    isCustomMessage: !1,
    restrictedDays: [],
    restrictedDates: [],
    message: "",
    intervalId: null,
    async init() {
      "Temporal" in globalThis || await import("./global.esm-ShPgAYTn.js"), Object.assign(this, mi(this.$el), t), this.tick(), this.intervalId = setInterval(() => this.tick(), 1e3);
    },
    destroy() {
      clearInterval(this.intervalId);
    },
    tick() {
      const n = Temporal.Now.zonedDateTimeISO(mt), r = this.nextCutoffDate(), i = r.epochNanoseconds - n.epochNanoseconds, s = i <= 0n ? 0 : Number(i / 1000000000n), { days: a, hours: o, minutes: c, seconds: d } = fi(s), l = [];
      (l.length || a) && l.push(a === 1 ? `${a} day` : `${a} days`), (l.length || o) && l.push(o === 1 ? `${o} hour` : `${o} hours`), (l.length || c) && l.push(c === 1 ? `${c} minute` : `${c} minutes`), (l.length || d) && l.push(d === 1 ? `${d} second` : `${d} seconds`);
      const u = this.nextShippingDate(r), m = u.toPlainDate().equals(Temporal.Now.plainDateISO()) ? "Today" : hi[Jt(u)];
      this.message = String(this.messageHtml).replace("%countdown%", l.join(", ")).replace("%ship_day%", m);
    },
    nextCutoffDate() {
      const n = Temporal.Now.zonedDateTimeISO(mt);
      let r = Temporal.Now.zonedDateTimeISO(mt).with({
        hour: this.cutOffHour,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      for (Temporal.ZonedDateTime.compare(r, n) === -1 && (r = r.add({ days: 1 })); this.isDateRestricted(r); ) r = r.add({ days: 1 });
      return r;
    },
    nextShippingDate(n) {
      let r = n, i = this.leadTime;
      for (; this.isDateRestricted(r) || i > 0; )
        r = r.add({ days: 1 }), this.isDateRestricted(r) || i--;
      return r;
    },
    isDateRestricted(n) {
      if (this.restrictedDays.includes(Jt(n))) return !0;
      const r = n.toPlainDate().toString(), i = r.slice(5);
      return this.restrictedDates.some((s) => s === r || s === i);
    }
  }));
}, gi = (e) => {
  e.data("filterController", (r) => {
    const i = [];
    return r || console.error("No grid selector provided to filterController"), {
      forms: {},
      async init() {
        await e.nextTick(), this.facetChange(!1), i.push(e.effect(() => this.filterProducts())), window.addEventListener("popstate", this.updateFromHistory.bind(this));
      },
      updateFromHistory({ state: s }) {
        this.facetData = s ? JSON.parse(s) : this.facetChange();
        const a = this.facetData;
        document.querySelectorAll("#filter-drawer input[type=checkbox]").forEach((d) => {
          d.checked = a.some(([l, u]) => l === d.name && u === d.value);
        });
        const o = a.find(([d]) => d === "sort_by")?.[1];
        if (!o) return;
        const c = document.querySelector('select[name="sort_by"]');
        c && (c.value = o);
      },
      destroy() {
        i.forEach(e.release);
      },
      _expanded: [!0],
      expanded(s) {
        return this._expanded[s];
      },
      expand(s) {
        this._expanded[s] = !this._expanded[s];
      },
      open: !1,
      fadeTransition: Ur,
      slideTransition: qn,
      facetData: [],
      facetChange(s = !0) {
        return this.facetData = Object.values(this.forms).flatMap((a) => Array.from(new FormData(a).entries())).filter(([a, o]) => !(a === "sort_by" && o === "manual" || a === "page" && (s || o === "1"))), this.facetData;
      },
      filterProducts() {
        n(this.facetData, r);
      },
      get isFiltered() {
        return this.facetData.some(([s]) => ![
          "type",
          "sort_by",
          "q"
        ].includes(s));
      }
    };
  });
  let t = !0;
  const n = _r(async (r, i) => {
    const s = new URL(window.location.href);
    s.search = new URLSearchParams(r).toString();
    const a = await Wr(s);
    if (!a) return;
    t || wt(a, i);
    const o = s.toString() === window.location.href;
    history[t || o ? "replaceState" : "pushState"](JSON.stringify(r), "", s.toString()), t = !1;
  });
}, yi = (e) => {
  e.data("meganav", () => ({
    isVisible: !1,
    meganavIndex: 0,
    init() {
      this.meganavIndex = this.$store.meganavState.registerItem();
    },
    show() {
      this.isVisible = !0, this.$store.meganavState.items[this.meganavIndex] = !0;
    },
    hide() {
      this.isVisible = !1, this.$store.meganavState.items[this.meganavIndex] = !1;
    },
    toggle() {
      this.isVisible = !this.isVisible, e.nextTick(() => this.$store.meganavStateIsOpen = this.isVisible);
    },
    expand: {
      "@mouseover"() {
        this.show();
      },
      "@mouseleave"() {
        this.hide();
      },
      "@keydown.tab"() {
        this.$event.target.isSameNode(this.$focus.getLast()) && this.isVisible && !this.$event.shiftKey && (this.isVisible = !1);
      },
      "@keydown.shift.tab"() {
        this.$event.target.isSameNode(this.$focus.getFirst()) && this.isVisible && (this.isVisible = !1);
      },
      "@keydown.esc"() {
        this.$focus.getFirst().focus(), this.isVisible = !1;
      },
      "@keydown.down.prevent"() {
        this.$focus.wrap().next();
      },
      "@keydown.up.prevent"() {
        this.$focus.wrap().previous();
      }
    },
    fade: {
      "x-transition:enter": "transition-[top] duration-200",
      "x-transition:enter-start": "top-5",
      "x-transition:enter-end": "top-3",
      "x-transition:leave": "transition-[top] duration-200",
      "x-transition:leave-start": "top-3",
      "x-transition:leave-end": "top-5"
    }
  })), e.store("meganavState", {
    get isOpen() {
      return this.items.length ? this.items.some((t) => t) : !1;
    },
    items: [],
    registerItem() {
      return this.items.push(!1), this.items.length - 1;
    }
  });
}, wi = (e) => e.data("mobileMenu", () => ({
  size: "auto",
  adjustSize() {
    const t = this.$refs.menuDrawer;
    if (!t) return;
    const n = t.closest("section > :is(div.relative, div.absolute)");
    if (!n) return;
    const r = n.getBoundingClientRect(), i = r.y + r.height;
    this.size = `${i}px`;
  },
  adjustToLargestPart(t) {
    const n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT);
    let r = 0, i = t;
    do
      r = Math.max(r, i.scrollHeight);
    while (i = n.nextNode());
    this.size = `${r + 5}px`;
  },
  get isOpen() {
    return this.$nextTick(() => this.$dispatch("update-size")), this.$store.mobileMenu.visible;
  },
  open() {
    this.$store.mobileMenu.show();
  },
  close() {
    this.$store.mobileMenu.hide();
  },
  cleanUp() {
    this.$refs.menuDrawerList.querySelectorAll("details").forEach((t) => t.removeAttribute("open"));
  }
})), bi = (e) => e.data("modal", () => ({
  isOpen: !1,
  init() {
    this.$watch("$store.modal.isOpen", (t) => {
      !t && this.close(!1);
    });
  },
  open() {
    this.$dispatch("nt:modal-open"), this.isOpen = !0, this.$store.modal.open();
  },
  close(t = !0) {
    this.$dispatch("nt:modal-close"), this.isOpen = !1, t && this.$store.modal.close();
  }
})), vi = (e) => {
  e.addRootSelector(() => `[${e.prefixed("panel-stack")}]`), e.directive("panel-stack", Ii);
}, Si = /* @__PURE__ */ new Set([
  "STYLE",
  "SCRIPT",
  "TEMPLATE",
  "LINK"
]), Ii = (e, { expression: t }, { Alpine: n, effect: r, cleanup: i }) => {
  const s = n.reactive({ index: 0 }), a = new AbortController();
  i(a.abort.bind(a)), r(() => {
    const o = s.index;
    Ti(e).forEach((c, d) => {
      c.classList.toggle("panel-current", d === o), c.classList.toggle("panel-previous", d < o), c.classList.toggle("panel-next", d > o), c.setAttribute("aria-hidden", String(d !== o));
    });
  }), queueMicrotask(() => {
    if (a.signal.aborted) return;
    const o = Ri(e, t, xi(n));
    o && (ki(o, e, s, a.signal, r), Ci(o, e, s, n, r)), queueMicrotask(() => e.classList.add("panels-ready"));
  });
}, Ti = (e) => Array.from(e.children).filter((t) => t instanceof HTMLElement && !Si.has(t.tagName)), Fn = (e) => {
  const t = e.prefixed("accordion");
  return `[${t}], [${t}\\.open], [${t}\\.closed]`;
}, xi = (e) => `[data-panel-trigger], ${Fn(e)}`, xt = (e, t, n) => Array.from(e.querySelectorAll(n)).filter((r) => !t.contains(r)), Ri = (e, t, n) => {
  if (t) return e.closest(t) ?? document.querySelector(t);
  let r = e.parentElement;
  for (; r; ) {
    if (xt(r, e, n).length) return r;
    if (r.tagName === "SECTION") return null;
    r = r.parentElement;
  }
  return null;
}, Ci = (e, t, n, r, i) => {
  xt(e, t, Fn(r)).map((s) => r.evaluate(s, "$accordion")).forEach((s, a) => {
    s && i(() => {
      s.active && (n.index = a);
    });
  });
}, ki = (e, t, n, r, i) => {
  const s = xt(e, t, "[data-panel-trigger]");
  if (!s.length) return;
  const a = s.map((o) => [o.dataset.panelTriggerTarget === "parent" ? o.parentElement ?? o : o, o.dataset.panelTrigger ?? "hover"]);
  a.forEach(([o, c], d) => {
    const l = () => {
      n.index = d;
    };
    c === "click" ? o.addEventListener("click", l, { signal: r }) : c === "hover" ? (o.addEventListener("pointerenter", l, { signal: r }), o.addEventListener("focusin", l, { signal: r })) : console.error("x-panel-trigger action: ", c, " is invalid. Use 'hover' or 'click'.");
  }), i(() => {
    const o = n.index;
    a.forEach(([c], d) => c.classList.toggle("trigger-current", d === o));
  });
}, Ei = (e) => {
  e.data("productCard", (t) => ({
    variant: t,
    get image() {
      return this.variant.featuredImage;
    },
    get currentShade() {
      const { name: n, description: r, color: i } = this.variant;
      return {
        name: n,
        description: r,
        color: i
      };
    },
    get colorDisplay() {
      const { name: n } = this.variant;
      return `${n}`;
    },
    get queryString() {
      return `?variant=${this.variant.id}`;
    },
    setShade(n) {
      Object.assign(this, { variant: n });
    },
    get isOnSale() {
      return this.variant.price < (this.variant.compare_at_price ?? 0);
    }
  }));
}, _n = class extends Error {
}, pt = /* @__PURE__ */ new Map(), Oi = (e) => typeof e == "string" ? e : e.name, Ai = (e, t) => {
  const n = pt.get(e);
  if (n) return n;
  const r = window.Shopify?.routes?.root ?? "/", i = fetch(`${r}products/${e}?view=quickadd`).then((s) => {
    if (s.status === 404) throw new _n(e);
    if (!s.ok) throw new Error(`Quick add: ${s.status}`);
    return s.json();
  }).then((s) => ({
    optionNames: s.options.map(Oi),
    variants: s.variants.map((a) => ({
      id: a.id,
      options: a.options,
      available: a.available,
      price: t(a.price / 100),
      label: a.label
    }))
  }));
  return i.catch(() => pt.delete(e)), pt.set(e, i), i;
}, Ni = 500, Di = 5e3, qi = (e) => {
  e.data("quickAdd", (t) => ({
    text: t.text,
    title: t.title,
    label: t.label,
    soldOut: t.available === !1,
    handle: t.handle ?? null,
    variants: t.variants ?? [],
    optionNames: t.optionNames ?? [],
    open: !1,
    hasPanel: (t.variants ?? []).length > 1,
    step: 0,
    picked: [],
    busy: !1,
    pendingFocus: 0,
    loading: !1,
    status: "",
    error: "",
    requestId: 0,
    loadingTimer: 0,
    statusTimer: 0,
    get panelId() {
      return `quick-add-panel-${t.blockId}-${t.uid}`;
    },
    get scopeId() {
      return `shopify-block-${t.blockId}-${t.uid}`;
    },
    get loaded() {
      return this.variants.length > 0;
    },
    get isLast() {
      return this.step === this.optionNames.length - 1;
    },
    get optionName() {
      return this.optionNames[this.step] ?? "";
    },
    get panelLabel() {
      return this.optionName ? `${this.text.choose} — ${this.optionName}` : null;
    },
    get choices() {
      const n = this.variants.filter((i) => this.picked.every((s, a) => i.options[a] === s)), r = /* @__PURE__ */ new Map();
      return n.forEach((i) => {
        const s = i.options[this.step], a = r.get(s);
        if (a) {
          i.available && !a.available && Object.assign(a, {
            available: !0,
            id: i.id,
            price: i.price,
            label: this.labelFor(i, s)
          });
          return;
        }
        r.set(s, {
          value: s,
          options: i.options,
          available: i.available,
          id: i.id,
          price: i.price,
          label: this.labelFor(i, s)
        });
      }), this.withoutCollidingLabels(Array.from(r.values()));
    },
    labelFor(n, r) {
      return this.isLast && n.label || r;
    },
    withoutCollidingLabels(n) {
      const r = /* @__PURE__ */ new Map();
      return n.forEach((i) => {
        const s = i.label.trim().toLowerCase().replace(/\s+/g, " ");
        r.set(s, (r.get(s) ?? 0) + 1);
      }), n.map((i) => {
        const s = i.label.trim().toLowerCase().replace(/\s+/g, " ");
        return (r.get(s) ?? 0) < 2 ? i : {
          ...i,
          label: i.value
        };
      });
    },
    detail(n) {
      return n.available ? this.isLast ? n.price : "" : this.text.soldOut;
    },
    get alive() {
      return !!this.$root?.isConnected;
    },
    say(n) {
      window.clearTimeout(this.statusTimer), this.status = "", this.$nextTick(() => {
        this.alive && (this.status = n, n && (this.statusTimer = window.setTimeout(() => {
          this.status = "";
        }, Di)));
      });
    },
    focusMountedOption() {
      this.$nextTick(() => {
        this.alive && this.$refs.options?.querySelector("[data-quick-add-option]")?.focus();
      });
    },
    requestOptionFocus() {
      this.pendingFocus = this.requestId;
    },
    claimFocus(n) {
      this.pendingFocus && this.pendingFocus === this.requestId && this.open && this.$root?.contains(n) && (this.pendingFocus = 0, n.focus());
    },
    focusFirstOption() {
      if (this.$refs.options?.querySelector("[data-quick-add-option]")) {
        this.focusMountedOption();
        return;
      }
      this.requestOptionFocus();
    },
    reset() {
      this.step = 0, this.picked = [];
    },
    close(n) {
      this.open = !1, this.$refs.panel?.close(), this.pendingFocus = 0, this.reset(), n && this.alive && this.$refs.trigger?.focus();
    },
    back() {
      if (this.step === 0) {
        this.close(!0);
        return;
      }
      this.step = this.step - 1, this.picked = this.picked.slice(0, this.step), this.requestOptionFocus();
    },
    select(n) {
      if (n.available && this.loaded) {
        if (this.isLast) {
          this.add(n);
          return;
        }
        this.picked = this.picked.slice(0, this.step).concat(n.value), this.step = this.step + 1, this.requestOptionFocus();
      }
    },
    onEscape(n) {
      if (!this.open && !this.loading) return;
      n.stopPropagation();
      const r = this.open;
      this.requestId += 1, window.clearTimeout(this.loadingTimer), this.loading = !1, this.close(r || document.activeElement === document.body);
    },
    async ensureLoaded(n) {
      if (this.loaded) return !0;
      if (!this.handle) return !1;
      this.loading = !0, this.loadingTimer = window.setTimeout(() => {
        this.loading && this.requestId === n && this.say(this.text.loading);
      }, Ni);
      try {
        const r = await Ai(this.handle, this.$formatMoney);
        return this.requestId !== n || !this.alive ? !1 : (this.optionNames = r.optionNames, this.variants = r.variants, !0);
      } catch (r) {
        return this.requestId !== n || !this.alive || (r instanceof _n ? this.say(this.text.unavailable.replace("[product]", () => this.title)) : this.error = this.text.loadFailed.replace("[product]", () => this.title)), !1;
      } finally {
        window.clearTimeout(this.loadingTimer), this.loading = !1;
      }
    },
    async activate() {
      if (this.busy || this.soldOut) return;
      if (this.open) {
        this.close(!1);
        return;
      }
      this.busy = !0, this.error = "";
      const n = this.requestId += 1;
      try {
        if (!await this.ensureLoaded(n)) return;
        if (!this.variants.some((r) => r.available)) {
          this.soldOut = !0, this.say(this.text.soldOutProduct.replace("[product]", () => this.title));
          return;
        }
        if (this.variants.length === 1) {
          await this.addVariant(this.variants[0].id, this.title);
          return;
        }
        if (this.reset(), this.hasPanel = !0, await this.$nextTick(), this.requestId !== n || !this.alive) return;
        this.open = !0, this.$refs.panel?.show(), document.activeElement === this.$refs.trigger ? this.focusFirstOption() : this.say(`${this.title}. ${this.panelLabel ?? ""}`);
      } finally {
        this.busy = !1;
      }
    },
    get cart() {
      return this.$store.cart;
    },
    get itemCount() {
      return this.cart.data.item_count ?? 0;
    },
    async syncCart() {
      this.cart.data.items || (this.cart.data = await this.cart.getState());
    },
    async add(n) {
      if (!this.busy) {
        this.busy = !0;
        try {
          await this.addVariant(n.id, n.value);
        } finally {
          this.busy = !1;
        }
      }
    },
    async addVariant(n, r) {
      this.error = "", this.say(this.text.adding), await this.syncCart();
      const i = this.itemCount;
      if (await this.cart.addItem(n), !!this.alive) {
        if (this.itemCount === i) {
          this.error = this.text.failed;
          return;
        }
        this.say(this.text.added.replace("[variant]", () => r)), this.close(!0), this.cart.open();
      }
    },
    destroy() {
      window.clearTimeout(this.loadingTimer), window.clearTimeout(this.statusTimer);
    }
  }));
}, Li = (e) => {
  e.data("quickOrder", (t) => ({
    removing: !1,
    get cart() {
      return this.$store.cart;
    },
    get productEntries() {
      return this.cart.items.filter((n) => n.product_id === t);
    },
    get quantity() {
      return this.productEntries.reduce((n, r) => n + r.quantity, 0);
    },
    get subtotal() {
      return this.$formatMoney(this.productEntries.reduce((n, r) => n + r.final_line_price, 0) / 100);
    },
    async removeAll() {
      this.removing = !0;
      for (const { id: n } of this.productEntries)
        await this.cart.removeItem(n), this.$dispatch("removeall", { id: n });
      this.removing = !1;
    }
  })), e.data("quickOrderRow", (t, n) => ({
    quantity: e.store("cart").items.find((r) => r.id === Number(t))?.quantity ?? 0,
    price: n,
    get priceDisplay() {
      return this.$formatMoney(this.price * this.quantity / 100);
    }
  })), e.data("quickQuantity", (t) => ({
    q: 0,
    get quant() {
      return this.q;
    },
    set quant(n) {
      n = Math.max(0, n), this.q = n;
    }
  }));
}, Pi = (e) => e.data("sizes", (t) => ({
  ...t,
  changeSize(n) {
    this.$dispatch("product-change", { product: n.product }), history.replaceState(null, n.product.title, n.url);
  }
})), $i = (e) => {
  e.data("stickyATC", () => ({
    show: !1,
    PDPATC: document.querySelector("#atc-button button[name=add]"),
    onScroll() {
      if (!this.PDPATC) return;
      const t = this.PDPATC.getBoundingClientRect();
      this.show = t.top < 25;
    }
  }));
}, Fi = (e) => {
  e.addRootSelector(() => `[${e.prefixed("stickyheader")}]`), e.directive("stickyheader", (t, n, { cleanup: r }) => {
    console.log("checking sticky header");
    const i = t.closest("section");
    if (!i || !("Animation" in globalThis)) return;
    console.log("setting up sticky header animation");
    const s = new Animation(new KeyframeEffect(i, [{ top: "0px" }, { get top() {
      return `-${t.clientHeight}px`;
    } }], {
      duration: 500,
      fill: "both"
    }));
    s.persist(), s.reverse(), s.finish();
    const a = e.effect(() => {
      const o = +(e.$scroll.direction === "down" && !e.$scroll.nearTop && !e.store("search").isOpen);
      s.playbackRate = o * 2 - 1;
    });
    r(() => e.release(a));
  });
}, _i = [
  jr,
  Vr,
  zr,
  ai,
  pi,
  Hr,
  Qr,
  ni,
  ri,
  ii,
  gi,
  yi,
  wi,
  bi,
  vi,
  Ei,
  qi,
  Li,
  Pi,
  $i,
  Fi
], We = Math.min, ge = Math.max, Ge = Math.round, _e = Math.floor, ce = (e) => ({
  x: e,
  y: e
}), Mi = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ji = {
  start: "end",
  end: "start"
};
function Bt(e, t, n) {
  return ge(e, We(t, n));
}
function rt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ye(e) {
  return e.split("-")[0];
}
function it(e) {
  return e.split("-")[1];
}
function Mn(e) {
  return e === "x" ? "y" : "x";
}
function Jn(e) {
  return e === "y" ? "height" : "width";
}
function at(e) {
  return ["top", "bottom"].includes(ye(e)) ? "y" : "x";
}
function Bn(e) {
  return Mn(at(e));
}
function Bi(e, t, n) {
  n === void 0 && (n = !1);
  const r = it(e), i = Bn(e), s = Jn(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (a = Ye(a)), [a, Ye(a)];
}
function Ui(e) {
  const t = Ye(e);
  return [
    bt(e),
    t,
    bt(t)
  ];
}
function bt(e) {
  return e.replace(/start|end/g, (t) => Ji[t]);
}
function ji(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], s = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? s : a;
    default:
      return [];
  }
}
function Vi(e, t, n, r) {
  const i = it(e);
  let s = ji(ye(e), n === "start", r);
  return i && (s = s.map((a) => a + "-" + i), t && (s = s.concat(s.map(bt)))), s;
}
function Ye(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Mi[t]);
}
function Hi(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function zi(e) {
  return typeof e != "number" ? Hi(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Xe(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Ut(e, t, n) {
  let { reference: r, floating: i } = e;
  const s = at(t), a = Bn(t), o = Jn(a), c = ye(t), d = s === "y", l = r.x + r.width / 2 - i.width / 2, u = r.y + r.height / 2 - i.height / 2, m = r[o] / 2 - i[o] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: l,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: u
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (it(t)) {
    case "start":
      p[a] -= m * (n && d ? -1 : 1);
      break;
    case "end":
      p[a] += m * (n && d ? -1 : 1);
  }
  return p;
}
var Ki = async (e, t, n) => {
  const { placement: r = "bottom", strategy: i = "absolute", middleware: s = [], platform: a } = n, o = s.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let d = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), { x: l, y: u } = Ut(d, r, c), m = r, p = {}, g = 0;
  for (let w = 0; w < o.length; w++) {
    const { name: y, fn: S } = o[w], { x: k, y: A, data: P, reset: L } = await S({
      x: l,
      y: u,
      initialPlacement: r,
      placement: m,
      strategy: i,
      middlewareData: p,
      rects: d,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (l = k ?? l, u = A ?? u, p = {
      ...p,
      [y]: {
        ...p[y],
        ...P
      }
    }, L && g <= 50) {
      g++, typeof L == "object" && (L.placement && (m = L.placement), L.rects && (d = L.rects === !0 ? await a.getElementRects({
        reference: e,
        floating: t,
        strategy: i
      }) : L.rects), { x: l, y: u } = Ut(d, m, c)), w = -1;
      continue;
    }
  }
  return {
    x: l,
    y: u,
    placement: m,
    strategy: i,
    middlewareData: p
  };
};
async function Un(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: r, y: i, platform: s, rects: a, elements: o, strategy: c } = e, { boundary: d = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: m = !1, padding: p = 0 } = rt(t, e), g = zi(p), w = o[m ? u === "floating" ? "reference" : "floating" : u], y = Xe(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(w))) == null || n ? w : w.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(o.floating)),
    boundary: d,
    rootBoundary: l,
    strategy: c
  })), S = u === "floating" ? {
    ...a.floating,
    x: r,
    y: i
  } : a.reference, k = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(o.floating)), A = await (s.isElement == null ? void 0 : s.isElement(k)) ? await (s.getScale == null ? void 0 : s.getScale(k)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, P = Xe(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: S,
    offsetParent: k,
    strategy: c
  }) : S);
  return {
    top: (y.top - P.top + g.top) / A.y,
    bottom: (P.bottom - y.bottom + g.bottom) / A.y,
    left: (y.left - P.left + g.left) / A.x,
    right: (P.right - y.right + g.right) / A.x
  };
}
var Wi = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const { placement: i, middlewareData: s, rects: a, initialPlacement: o, platform: c, elements: d } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: m, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: g = "none", flipAlignment: w = !0, ...y } = rt(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset) return {};
      const S = ye(i), k = ye(o) === o, A = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), P = m || (k || !w ? [Ye(o)] : Ui(o));
      !m && g !== "none" && P.push(...Vi(o, w, g, A));
      const L = [o, ...P], M = await Un(t, y), C = [];
      let $ = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (l && C.push(M[S]), u) {
        const x = Bi(i, a, A);
        C.push(M[x[0]], M[x[1]]);
      }
      if ($ = [...$, {
        placement: i,
        overflows: C
      }], !C.every((x) => x <= 0)) {
        var Q, te;
        const x = (((Q = s.flip) == null ? void 0 : Q.index) || 0) + 1, h = L[x];
        if (h) return {
          data: {
            index: x,
            overflows: $
          },
          reset: { placement: h }
        };
        let f = (te = $.filter((b) => b.overflows[0] <= 0).sort((b, T) => b.overflows[1] - T.overflows[1])[0]) == null ? void 0 : te.placement;
        if (!f) switch (p) {
          case "bestFit": {
            var U;
            const b = (U = $.map((T) => [T.placement, T.overflows.filter((I) => I > 0).reduce((I, O) => I + O, 0)]).sort((T, I) => T[1] - I[1])[0]) == null ? void 0 : U[0];
            b && (f = b);
            break;
          }
          case "initialPlacement":
            f = o;
        }
        if (i !== f) return { reset: { placement: f } };
      }
      return {};
    }
  };
};
async function Gi(e, t) {
  const { placement: n, platform: r, elements: i } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = ye(n), o = it(n), c = at(n) === "y", d = ["left", "top"].includes(a) ? -1 : 1, l = s && c ? -1 : 1, u = rt(t, e);
  let { mainAxis: m, crossAxis: p, alignmentAxis: g } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return o && typeof g == "number" && (p = o === "end" ? g * -1 : g), c ? {
    x: p * l,
    y: m * d
  } : {
    x: m * d,
    y: p * l
  };
}
var Yi = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const { x: n, y: r } = t, i = await Gi(t, e);
      return {
        x: n + i.x,
        y: r + i.y,
        data: i
      };
    }
  };
}, Xi = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const { x: n, y: r, placement: i } = t, { mainAxis: s = !0, crossAxis: a = !1, limiter: o = { fn: (y) => {
        let { x: S, y: k } = y;
        return {
          x: S,
          y: k
        };
      } }, ...c } = rt(e, t), d = {
        x: n,
        y: r
      }, l = await Un(t, c), u = at(ye(i)), m = Mn(u);
      let p = d[m], g = d[u];
      if (s) {
        const y = m === "y" ? "top" : "left", S = m === "y" ? "bottom" : "right", k = p + l[y], A = p - l[S];
        p = Bt(k, p, A);
      }
      if (a) {
        const y = u === "y" ? "top" : "left", S = u === "y" ? "bottom" : "right", k = g + l[y], A = g - l[S];
        g = Bt(k, g, A);
      }
      const w = o.fn({
        ...t,
        [m]: p,
        [u]: g
      });
      return {
        ...w,
        data: {
          x: w.x - n,
          y: w.y - r
        }
      };
    }
  };
};
function de(e) {
  return jn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function G(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ie(e) {
  var t;
  return (t = (jn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function jn(e) {
  return e instanceof Node || e instanceof G(e).Node;
}
function re(e) {
  return e instanceof Element || e instanceof G(e).Element;
}
function ee(e) {
  return e instanceof HTMLElement || e instanceof G(e).HTMLElement;
}
function jt(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof G(e).ShadowRoot;
}
function Pe(e) {
  const { overflow: t, overflowX: n, overflowY: r, display: i } = Y(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function Qi(e) {
  return [
    "table",
    "td",
    "th"
  ].includes(de(e));
}
function Rt(e) {
  const t = Ct(), n = Y(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || [
    "transform",
    "perspective",
    "filter"
  ].some((r) => (n.willChange || "").includes(r)) || [
    "paint",
    "layout",
    "strict",
    "content"
  ].some((r) => (n.contain || "").includes(r));
}
function Zi(e) {
  let t = Re(e);
  for (; ee(t) && !st(t); ) {
    if (Rt(t)) return t;
    t = Re(t);
  }
  return null;
}
function Ct() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function st(e) {
  return [
    "html",
    "body",
    "#document"
  ].includes(de(e));
}
function Y(e) {
  return G(e).getComputedStyle(e);
}
function ot(e) {
  return re(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Re(e) {
  if (de(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || jt(e) && e.host || ie(e);
  return jt(t) ? t.host : t;
}
function Vn(e) {
  const t = Re(e);
  return st(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ee(t) && Pe(t) ? t : Vn(t);
}
function De(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = Vn(e), s = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = G(i);
  return s ? t.concat(a, a.visualViewport || [], Pe(i) ? i : [], a.frameElement && n ? De(a.frameElement) : []) : t.concat(i, De(i, [], n));
}
function Hn(e) {
  const t = Y(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = ee(e), s = i ? e.offsetWidth : n, a = i ? e.offsetHeight : r, o = Ge(n) !== s || Ge(r) !== a;
  return o && (n = s, r = a), {
    width: n,
    height: r,
    $: o
  };
}
function kt(e) {
  return re(e) ? e : e.contextElement;
}
function xe(e) {
  const t = kt(e);
  if (!ee(t)) return ce(1);
  const n = t.getBoundingClientRect(), { width: r, height: i, $: s } = Hn(t);
  let a = (s ? Ge(n.width) : n.width) / r, o = (s ? Ge(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
var ea = /* @__PURE__ */ ce(0);
function zn(e) {
  const t = G(e);
  return !Ct() || !t.visualViewport ? ea : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ta(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== G(e) ? !1 : t;
}
function we(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), s = kt(e);
  let a = ce(1);
  t && (r ? re(r) && (a = xe(r)) : a = xe(e));
  const o = ta(s, n, r) ? zn(s) : ce(0);
  let c = (i.left + o.x) / a.x, d = (i.top + o.y) / a.y, l = i.width / a.x, u = i.height / a.y;
  if (s) {
    const m = G(s), p = r && re(r) ? G(r) : r;
    let g = m.frameElement;
    for (; g && r && p !== m; ) {
      const w = xe(g), y = g.getBoundingClientRect(), S = Y(g), k = y.left + (g.clientLeft + parseFloat(S.paddingLeft)) * w.x, A = y.top + (g.clientTop + parseFloat(S.paddingTop)) * w.y;
      c *= w.x, d *= w.y, l *= w.x, u *= w.y, c += k, d += A, g = G(g).frameElement;
    }
  }
  return Xe({
    width: l,
    height: u,
    x: c,
    y: d
  });
}
function na(e) {
  let { rect: t, offsetParent: n, strategy: r } = e;
  const i = ee(n), s = ie(n);
  if (n === s) return t;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, o = ce(1);
  const c = ce(0);
  if ((i || !i && r !== "fixed") && ((de(n) !== "body" || Pe(s)) && (a = ot(n)), ee(n))) {
    const d = we(n);
    o = xe(n), c.x = d.x + n.clientLeft, c.y = d.y + n.clientTop;
  }
  return {
    width: t.width * o.x,
    height: t.height * o.y,
    x: t.x * o.x - a.scrollLeft * o.x + c.x,
    y: t.y * o.y - a.scrollTop * o.y + c.y
  };
}
function ra(e) {
  return Array.from(e.getClientRects());
}
function Kn(e) {
  return we(ie(e)).left + ot(e).scrollLeft;
}
function ia(e) {
  const t = ie(e), n = ot(e), r = e.ownerDocument.body, i = ge(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), s = ge(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + Kn(e);
  const o = -n.scrollTop;
  return Y(r).direction === "rtl" && (a += ge(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: s,
    x: a,
    y: o
  };
}
function aa(e, t) {
  const n = G(e), r = ie(e), i = n.visualViewport;
  let s = r.clientWidth, a = r.clientHeight, o = 0, c = 0;
  if (i) {
    s = i.width, a = i.height;
    const d = Ct();
    (!d || d && t === "fixed") && (o = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: s,
    height: a,
    x: o,
    y: c
  };
}
function sa(e, t) {
  const n = we(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, s = ee(e) ? xe(e) : ce(1);
  return {
    width: e.clientWidth * s.x,
    height: e.clientHeight * s.y,
    x: i * s.x,
    y: r * s.y
  };
}
function Vt(e, t, n) {
  let r;
  if (t === "viewport") r = aa(e, n);
  else if (t === "document") r = ia(ie(e));
  else if (re(t)) r = sa(t, n);
  else {
    const i = zn(e);
    r = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return Xe(r);
}
function Wn(e, t) {
  const n = Re(e);
  return n === t || !re(n) || st(n) ? !1 : Y(n).position === "fixed" || Wn(n, t);
}
function oa(e, t) {
  const n = t.get(e);
  if (n) return n;
  let r = De(e, [], !1).filter((o) => re(o) && de(o) !== "body"), i = null;
  const s = Y(e).position === "fixed";
  let a = s ? Re(e) : e;
  for (; re(a) && !st(a); ) {
    const o = Y(a), c = Rt(a);
    !c && o.position === "fixed" && (i = null), (s ? !c && !i : !c && o.position === "static" && i && ["absolute", "fixed"].includes(i.position) || Pe(a) && !c && Wn(e, a)) ? r = r.filter((d) => d !== a) : i = o, a = Re(a);
  }
  return t.set(e, r), r;
}
function ca(e) {
  let { element: t, boundary: n, rootBoundary: r, strategy: i } = e;
  const s = [...n === "clippingAncestors" ? oa(t, this._c) : [].concat(n), r], a = s[0], o = s.reduce((c, d) => {
    const l = Vt(t, d, i);
    return c.top = ge(l.top, c.top), c.right = We(l.right, c.right), c.bottom = We(l.bottom, c.bottom), c.left = ge(l.left, c.left), c;
  }, Vt(t, a, i));
  return {
    width: o.right - o.left,
    height: o.bottom - o.top,
    x: o.left,
    y: o.top
  };
}
function da(e) {
  return Hn(e);
}
function la(e, t, n) {
  const r = ee(t), i = ie(t), s = n === "fixed", a = we(e, !0, s, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = ce(0);
  if (r || !r && !s)
    if ((de(t) !== "body" || Pe(i)) && (o = ot(t)), r) {
      const d = we(t, !0, s, t);
      c.x = d.x + t.clientLeft, c.y = d.y + t.clientTop;
    } else i && (c.x = Kn(i));
  return {
    x: a.left + o.scrollLeft - c.x,
    y: a.top + o.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function Ht(e, t) {
  return !ee(e) || Y(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Gn(e, t) {
  const n = G(e);
  if (!ee(e)) return n;
  let r = Ht(e, t);
  for (; r && Qi(r) && Y(r).position === "static"; ) r = Ht(r, t);
  return r && (de(r) === "html" || de(r) === "body" && Y(r).position === "static" && !Rt(r)) ? n : r || Zi(e) || n;
}
var ua = async function(e) {
  let { reference: t, floating: n, strategy: r } = e;
  const i = this.getOffsetParent || Gn, s = this.getDimensions;
  return {
    reference: la(t, await i(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await s(n)
    }
  };
};
function ha(e) {
  return Y(e).direction === "rtl";
}
var fa = {
  convertOffsetParentRelativeRectToViewportRelativeRect: na,
  getDocumentElement: ie,
  getClippingRect: ca,
  getOffsetParent: Gn,
  getElementRects: ua,
  getClientRects: ra,
  getDimensions: da,
  getScale: xe,
  isElement: re,
  isRTL: ha
};
function ma(e, t) {
  let n = null, r;
  const i = ie(e);
  function s() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function a(o, c) {
    o === void 0 && (o = !1), c === void 0 && (c = 1), s();
    const { left: d, top: l, width: u, height: m } = e.getBoundingClientRect();
    if (o || t(), !u || !m) return;
    const p = _e(l), g = _e(i.clientWidth - (d + u)), w = _e(i.clientHeight - (l + m)), y = _e(d), S = {
      rootMargin: -p + "px " + -g + "px " + -w + "px " + -y + "px",
      threshold: ge(0, We(1, c)) || 1
    };
    let k = !0;
    function A(P) {
      const L = P[0].intersectionRatio;
      if (L !== c) {
        if (!k) return a();
        L ? a(!1, L) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      k = !1;
    }
    try {
      n = new IntersectionObserver(A, {
        ...S,
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(A, S);
    }
    n.observe(e);
  }
  return a(!0), s;
}
function pa(e, t, n, r) {
  r === void 0 && (r = {});
  const { ancestorScroll: i = !0, ancestorResize: s = !0, elementResize: a = typeof ResizeObserver == "function", layoutShift: o = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, d = kt(e), l = i || s ? [...d ? De(d) : [], ...De(t)] : [];
  l.forEach((S) => {
    i && S.addEventListener("scroll", n, { passive: !0 }), s && S.addEventListener("resize", n);
  });
  const u = d && o ? ma(d, n) : null;
  let m = -1, p = null;
  a && (p = new ResizeObserver((S) => {
    let [k] = S;
    k && k.target === d && p && (p.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      p && p.observe(t);
    })), n();
  }), d && !c && p.observe(d), p.observe(t));
  let g, w = c ? we(e) : null;
  c && y();
  function y() {
    const S = we(e);
    w && (S.x !== w.x || S.y !== w.y || S.width !== w.width || S.height !== w.height) && n(), w = S, g = requestAnimationFrame(y);
  }
  return n(), () => {
    l.forEach((S) => {
      i && S.removeEventListener("scroll", n), s && S.removeEventListener("resize", n);
    }), u && u(), p && p.disconnect(), p = null, c && cancelAnimationFrame(g);
  };
}
var ga = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: fa,
    ...n
  }, s = {
    ...i.platform,
    _c: r
  };
  return Ki(e, t, {
    ...i,
    platform: s
  });
};
function ya(e) {
  e.magic("anchor", (t) => {
    if (!t._x_anchor) throw "Alpine: No x-anchor directive found on element using $anchor...";
    return t._x_anchor;
  }), e.interceptClone((t, n) => {
    t && t._x_anchor && !n._x_anchor && (n._x_anchor = t._x_anchor);
  }), e.directive("anchor", e.skipDuringClone((t, { expression: n, modifiers: r, value: i }, { evaluate: s, effect: a, cleanup: o }) => {
    let { placement: c, offsetValue: d, unstyled: l, strategy: u, allowFlip: m } = Kt(r);
    t._x_anchor = e.reactive({
      x: 0,
      y: 0
    });
    let p = null, g = null;
    a(() => {
      let w = s(n);
      if (w && p !== w) {
        g && g(), p = w;
        let y = () => {
          let S;
          ga(w, t, {
            placement: c,
            strategy: u,
            middleware: [
              m && Wi(),
              Xi({ padding: 5 }),
              Yi(d)
            ]
          }).then(({ x: k, y: A }) => {
            l || zt(t, k, A, u), JSON.stringify({
              x: k,
              y: A
            }) !== S && (t._x_anchor.x = k, t._x_anchor.y = A), S = JSON.stringify({
              x: k,
              y: A
            });
          });
        };
        g = pa(w, t, () => y());
      }
    }), o(() => {
      g && g();
    });
  }, (t, { expression: n, modifiers: r, value: i }, { cleanup: s, evaluate: a }) => {
    let { placement: o, offsetValue: c, unstyled: d, strategy: l } = Kt(r);
    t._x_anchor && (d || zt(t, t._x_anchor.x, t._x_anchor.y, l));
  }));
}
function zt(e, t, n, r = "absolute") {
  Object.assign(e.style, {
    left: t + "px",
    top: n + "px",
    position: r
  });
}
function Kt(e) {
  let t = [
    "top",
    "top-start",
    "top-end",
    "right",
    "right-start",
    "right-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "left",
    "left-start",
    "left-end"
  ].find((a) => e.includes(a)), n = 0;
  if (e.includes("offset")) {
    let a = e.findIndex((o) => o === "offset");
    n = e[a + 1] !== void 0 ? Number(e[a + 1]) : n;
  }
  let r = e.includes("no-style"), i = !e.includes("noflip"), s = e.includes("fixed") ? "fixed" : "absolute";
  return {
    placement: t,
    offsetValue: n,
    unstyled: r,
    strategy: s,
    allowFlip: i
  };
}
var wa = ya;
function ba(e) {
  e.directive("collapse", t), t.inline = (n, { modifiers: r }) => {
    r.includes("min") && (n._x_doShow = () => {
    }, n._x_doHide = () => {
    });
  };
  function t(n, { modifiers: r }) {
    let i = Wt(r, "duration", 250) / 1e3, s = Wt(r, "min", 0), a = !r.includes("min");
    n._x_isShown || (n.style.height = `${s}px`), !n._x_isShown && a && (n.hidden = !0), n._x_isShown || (n.style.overflow = "hidden");
    let o = (d, l) => {
      let u = e.setStyles(d, l);
      return l.height ? () => {
      } : u;
    }, c = {
      transitionProperty: "height",
      transitionDuration: `${i}s`,
      transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
    };
    n._x_transition = {
      in(d = () => {
      }, l = () => {
      }) {
        a && (n.hidden = !1), a && (n.style.display = null);
        let u = n.getBoundingClientRect().height;
        n.style.height = "auto";
        let m = n.getBoundingClientRect().height;
        u === m && (u = s), e.transition(n, e.setStyles, {
          during: c,
          start: { height: u + "px" },
          end: { height: m + "px" }
        }, () => n._x_isShown = !0, () => {
          Math.abs(n.getBoundingClientRect().height - m) < 1 && (n.style.overflow = null);
        });
      },
      out(d = () => {
      }, l = () => {
      }) {
        let u = n.getBoundingClientRect().height;
        e.transition(n, o, {
          during: c,
          start: { height: u + "px" },
          end: { height: s + "px" }
        }, () => n.style.overflow = "hidden", () => {
          n._x_isShown = !1, n.style.height == `${s}px` && a && (n.style.display = "none", n.hidden = !0);
        });
      }
    };
  }
}
function Wt(e, t, n) {
  if (e.indexOf(t) === -1) return n;
  const r = e[e.indexOf(t) + 1];
  if (!r) return n;
  if (t === "duration") {
    let i = r.match(/([0-9]+)ms/);
    if (i) return i[1];
  }
  if (t === "min") {
    let i = r.match(/([0-9]+)px/);
    if (i) return i[1];
  }
  return r;
}
var va = ba, Yn = [
  "input:not([inert]):not([inert] *)",
  "select:not([inert]):not([inert] *)",
  "textarea:not([inert]):not([inert] *)",
  "a[href]:not([inert]):not([inert] *)",
  "button:not([inert]):not([inert] *)",
  "[tabindex]:not(slot):not([inert]):not([inert] *)",
  "audio[controls]:not([inert]):not([inert] *)",
  "video[controls]:not([inert]):not([inert] *)",
  '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
  "details>summary:first-of-type:not([inert]):not([inert] *)",
  "details:not([inert]):not([inert] *)"
], Qe = /* @__PURE__ */ Yn.join(","), Xn = typeof Element > "u", be = Xn ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Ze = !Xn && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, et = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert");
  return i === "" || i === "true" || n && t && (typeof t.closest == "function" ? t.closest("[inert]") : et(t.parentNode));
}, Sa = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, Qn = function(t, n, r) {
  if (et(t)) return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(Qe));
  return n && be.call(t, Qe) && i.unshift(t), i = i.filter(r), i;
}, tt = function(t, n, r) {
  for (var i = [], s = Array.from(t); s.length; ) {
    var a = s.shift();
    if (!et(a, !1))
      if (a.tagName === "SLOT") {
        var o = a.assignedElements(), c = tt(o.length ? o : a.children, !0, r);
        r.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: a,
          candidates: c
        });
      } else {
        be.call(a, Qe) && r.filter(a) && (n || !t.includes(a)) && i.push(a);
        var d = a.shadowRoot || typeof r.getShadowRoot == "function" && r.getShadowRoot(a), l = !et(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (d && l) {
          var u = tt(d === !0 ? a.children : d.children, !0, r);
          r.flatten ? i.push.apply(i, u) : i.push({
            scopeParent: a,
            candidates: u
          });
        } else s.unshift.apply(s, a.children);
      }
  }
  return i;
}, Zn = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, pe = function(t) {
  if (!t) throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Sa(t)) && !Zn(t) ? 0 : t.tabIndex;
}, Ia = function(t, n) {
  var r = pe(t);
  return r < 0 && n && !Zn(t) ? 0 : r;
}, Ta = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, er = function(t) {
  return t.tagName === "INPUT";
}, xa = function(t) {
  return er(t) && t.type === "hidden";
}, Ra = function(t) {
  return t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
}, Ca = function(t, n) {
  for (var r = 0; r < t.length; r++) if (t[r].checked && t[r].form === n) return t[r];
}, ka = function(t) {
  if (!t.name) return !0;
  var n = t.form || Ze(t), r = function(o) {
    return n.querySelectorAll('input[type="radio"][name="' + o + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") i = r(window.CSS.escape(t.name));
  else try {
    i = r(t.name);
  } catch (a) {
    return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
  }
  var s = Ca(i, t.form);
  return !s || s === t;
}, Ea = function(t) {
  return er(t) && t.type === "radio";
}, Oa = function(t) {
  return Ea(t) && !ka(t);
}, Aa = function(t) {
  var n, r = t && Ze(t), i = (n = r) === null || n === void 0 ? void 0 : n.host, s = !1;
  if (r && r !== t) {
    var a, o, c;
    for (s = !!((a = i) !== null && a !== void 0 && (o = a.ownerDocument) !== null && o !== void 0 && o.contains(i) || t != null && (c = t.ownerDocument) !== null && c !== void 0 && c.contains(t)); !s && i; ) {
      var d, l, u;
      r = Ze(i), i = (d = r) === null || d === void 0 ? void 0 : d.host, s = !!((l = i) !== null && l !== void 0 && (u = l.ownerDocument) !== null && u !== void 0 && u.contains(i));
    }
  }
  return s;
}, Gt = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, Na = function(t, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t)
    return !t.checkVisibility({
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      checkVisibilityCSS: !0
    });
  if (getComputedStyle(t).visibility === "hidden") return !0;
  var s = be.call(t, "details>summary:first-of-type") ? t.parentElement : t;
  if (be.call(s, "details:not([open]) *")) return !0;
  if (!r || r === "full" || r === "full-native" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var a = t; t; ) {
        var o = t.parentElement, c = Ze(t);
        if (o && !o.shadowRoot && i(o) === !0) return Gt(t);
        t.assignedSlot ? t = t.assignedSlot : !o && c !== t.ownerDocument ? t = c.host : t = o;
      }
      t = a;
    }
    if (Aa(t)) return !t.getClientRects().length;
    if (r !== "legacy-full") return !0;
  } else if (r === "non-zero-area") return Gt(t);
  return !1;
}, Da = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND") return be.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, nt = function(t, n) {
  return !(n.disabled || xa(n) || Na(n, t) || Ra(n) || Da(n));
}, vt = function(t, n) {
  return !(Oa(n) || pe(n) < 0 || !nt(t, n));
}, qa = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, tr = function(t) {
  var n = [], r = [];
  return t.forEach(function(i, s) {
    var a = !!i.scopeParent, o = a ? i.scopeParent : i, c = Ia(o, a), d = a ? tr(i.candidates) : o;
    c === 0 ? a ? n.push.apply(n, d) : n.push(o) : r.push({
      documentOrder: s,
      tabIndex: c,
      item: i,
      isScope: a,
      content: d
    });
  }), r.sort(Ta).reduce(function(i, s) {
    return s.isScope ? i.push.apply(i, s.content) : i.push(s.content), i;
  }, []).concat(n);
}, La = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = tt([t], n.includeContainer, {
    filter: vt.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: qa
  }) : r = Qn(t, n.includeContainer, vt.bind(null, n)), tr(r);
}, nr = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = tt([t], n.includeContainer, {
    filter: nt.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = Qn(t, n.includeContainer, nt.bind(null, n)), r;
}, Ie = function(t, n) {
  if (n = n || {}, !t) throw new Error("No node provided");
  return be.call(t, Qe) === !1 ? !1 : vt(n, t);
}, Pa = /* @__PURE__ */ Yn.concat("iframe:not([inert]):not([inert] *)").join(","), je = function(t, n) {
  if (n = n || {}, !t) throw new Error("No node provided");
  return be.call(t, Pa) === !1 ? !1 : nt(n, t);
};
function St(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function $a(e) {
  if (Array.isArray(e)) return St(e);
}
function Yt(e, t, n, r, i, s, a) {
  try {
    var o = e[s](a), c = o.value;
  } catch (d) {
    n(d);
    return;
  }
  o.done ? t(c) : Promise.resolve(c).then(r, i);
}
function Xt(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var s = e.apply(t, n);
      function a(c) {
        Yt(s, r, i, a, o, "next", c);
      }
      function o(c) {
        Yt(s, r, i, a, o, "throw", c);
      }
      a(void 0);
    });
  };
}
function Qt(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = rr(e)) || t) {
      n && (e = n);
      var r = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return r >= e.length ? { done: !0 } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var s, a = !0, o = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var c = n.next();
      return a = c.done, c;
    },
    e: function(c) {
      o = !0, s = c;
    },
    f: function() {
      try {
        a || n.return == null || n.return();
      } finally {
        if (o) throw s;
      }
    }
  };
}
function Fa(e, t, n) {
  return (t = Ua(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function _a(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ma() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Zt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function en(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zt(Object(n), !0).forEach(function(r) {
      Fa(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Oe() {
  var e, t, n = typeof Symbol == "function" ? Symbol : {}, r = n.iterator || "@@iterator", i = n.toStringTag || "@@toStringTag";
  function s(p, g, w, y) {
    var S = g && g.prototype instanceof o ? g : o, k = Object.create(S.prototype);
    return W(k, "_invoke", (function(A, P, L) {
      var M, C, $, Q = 0, te = L || [], U = !1, x = {
        p: 0,
        n: 0,
        v: e,
        a: h,
        f: h.bind(e, 4),
        d: function(f, b) {
          return M = f, C = 0, $ = e, x.n = b, a;
        }
      };
      function h(f, b) {
        for (C = f, $ = b, t = 0; !U && Q && !T && t < te.length; t++) {
          var T, I = te[t], O = x.p, R = I[2];
          f > 3 ? (T = R === b) && ($ = I[(C = I[4]) ? 5 : (C = 3, 3)], I[4] = I[5] = e) : I[0] <= O && ((T = f < 2 && O < I[1]) ? (C = 0, x.v = b, x.n = I[1]) : O < R && (T = f < 3 || I[0] > b || b > R) && (I[4] = f, I[5] = b, x.n = R, C = 0));
        }
        if (T || f > 1) return a;
        throw U = !0, b;
      }
      return function(f, b, T) {
        if (Q > 1) throw TypeError("Generator is already running");
        for (U && b === 1 && h(b, T), C = b, $ = T; (t = C < 2 ? e : $) || !U; ) {
          M || (C ? C < 3 ? (C > 1 && (x.n = -1), h(C, $)) : x.n = $ : x.v = $);
          try {
            if (Q = 2, M) {
              if (C || (f = "next"), t = M[f]) {
                if (!(t = t.call(M, $))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                $ = t.value, C < 2 && (C = 0);
              } else C === 1 && (t = M.return) && t.call(M), C < 2 && ($ = TypeError("The iterator does not provide a '" + f + "' method"), C = 1);
              M = e;
            } else if ((t = (U = x.n < 0) ? $ : A.call(P, x)) !== a) break;
          } catch (I) {
            M = e, C = 1, $ = I;
          } finally {
            Q = 1;
          }
        }
        return {
          value: t,
          done: U
        };
      };
    })(p, w, y), !0), k;
  }
  var a = {};
  function o() {
  }
  function c() {
  }
  function d() {
  }
  t = Object.getPrototypeOf;
  var l = [][r] ? t(t([][r]())) : (W(t = {}, r, function() {
    return this;
  }), t), u = d.prototype = o.prototype = Object.create(l);
  function m(p) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(p, d) : (p.__proto__ = d, W(p, i, "GeneratorFunction")), p.prototype = Object.create(u), p;
  }
  return c.prototype = d, W(u, "constructor", d), W(d, "constructor", c), c.displayName = "GeneratorFunction", W(d, i, "GeneratorFunction"), W(u), W(u, i, "Generator"), W(u, r, function() {
    return this;
  }), W(u, "toString", function() {
    return "[object Generator]";
  }), (Oe = function() {
    return {
      w: s,
      m
    };
  })();
}
function W(e, t, n, r) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch {
    i = 0;
  }
  W = function(s, a, o, c) {
    function d(l, u) {
      W(s, l, function(m) {
        return this._invoke(l, u, m);
      });
    }
    a ? i ? i(s, a, {
      value: o,
      enumerable: !c,
      configurable: !c,
      writable: !c
    }) : s[a] = o : (d("next", 0), d("throw", 1), d("return", 2));
  }, W(e, t, n, r);
}
function Ja(e) {
  return $a(e) || _a(e) || rr(e) || Ma();
}
function Ba(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ua(e) {
  var t = Ba(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function rr(e, t) {
  if (e) {
    if (typeof e == "string") return St(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? St(e, t) : void 0;
  }
}
var ne = {
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  activateTrap: function(t, n) {
    n !== ne.getActiveTrap(t) && ne.pauseTrap(t);
    var r = t.indexOf(n);
    r === -1 || t.splice(r, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), ne.unpauseTrap(t);
  },
  pauseTrap: function(t) {
    var n = ne.getActiveTrap(t);
    n?._setPausedState(!0);
  },
  unpauseTrap: function(t) {
    var n = ne.getActiveTrap(t);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, ja = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Va = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, Ne = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Ha = function(t) {
  return Ne(t) && !t.shiftKey;
}, za = function(t) {
  return Ne(t) && t.shiftKey;
}, tn = function(t) {
  return setTimeout(t, 0);
}, Ce = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Me = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Ka = [], Wa = function(t, n) {
  var r = n?.document || document, i = n?.trapStack || Ka, s = en({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Ha,
    isKeyBackward: za
  }, n), a = {
    containers: [],
    containerGroups: [],
    tabbableGroups: [],
    adjacentElements: /* @__PURE__ */ new Set(),
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    delayInitialFocusTimer: void 0,
    recentNavEvent: void 0
  }, o, c = function(h, f, b) {
    return h && h[f] !== void 0 ? h[f] : s[b || f];
  }, d = function(h, f) {
    var b = typeof f?.composedPath == "function" ? f.composedPath() : void 0;
    return a.containerGroups.findIndex(function(T) {
      var I = T.container, O = T.tabbableNodes;
      return I.contains(h) || b?.includes(I) || O.find(function(R) {
        return R === h;
      });
    });
  }, l = function(h) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, b = f.hasFallback, T = b === void 0 ? !1 : b, I = f.params, O = I === void 0 ? [] : I, R = s[h];
    if (typeof R == "function" && (R = R.apply(void 0, Ja(O))), R === !0 && (R = void 0), !R) {
      if (R === void 0 || R === !1) return R;
      throw new Error("`".concat(h, "` was specified but was not a node, or did not return a node"));
    }
    var E = R;
    if (typeof R == "string") {
      try {
        E = r.querySelector(R);
      } catch (q) {
        throw new Error("`".concat(h, '` appears to be an invalid selector; error="').concat(q.message, '"'));
      }
      if (!E && !T)
        throw new Error("`".concat(h, "` as selector refers to no known node"));
    }
    return E;
  }, u = function() {
    var h = l("initialFocus", { hasFallback: !0 });
    if (h === !1) return !1;
    if (h === void 0 || h && !je(h, s.tabbableOptions))
      if (d(r.activeElement) >= 0) h = r.activeElement;
      else {
        var f = a.tabbableGroups[0];
        h = f && f.firstTabbableNode || l("fallbackFocus");
      }
    else h === null && (h = l("fallbackFocus"));
    if (!h) throw new Error("Your focus-trap needs to have at least one focusable element");
    return h;
  }, m = function() {
    if (a.containerGroups = a.containers.map(function(h) {
      var f = La(h, s.tabbableOptions), b = nr(h, s.tabbableOptions), T = f.length > 0 ? f[0] : void 0, I = f.length > 0 ? f[f.length - 1] : void 0, O = b.find(function(E) {
        return Ie(E);
      }), R = b.slice().reverse().find(function(E) {
        return Ie(E);
      });
      return {
        container: h,
        tabbableNodes: f,
        focusableNodes: b,
        posTabIndexesFound: !!f.find(function(E) {
          return pe(E) > 0;
        }),
        firstTabbableNode: T,
        lastTabbableNode: I,
        firstDomTabbableNode: O,
        lastDomTabbableNode: R,
        nextTabbableNode: function(q) {
          var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, H = f.indexOf(q);
          return H < 0 ? V ? b.slice(b.indexOf(q) + 1).find(function(B) {
            return Ie(B);
          }) : b.slice(0, b.indexOf(q)).reverse().find(function(B) {
            return Ie(B);
          }) : f[H + (V ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(h) {
      return h.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !l("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(h) {
      return h.posTabIndexesFound;
    }) && a.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, p = function(h) {
    var f = h.activeElement;
    if (f)
      return f.shadowRoot && f.shadowRoot.activeElement !== null ? p(f.shadowRoot) : f;
  }, g = function(h) {
    if (h !== !1 && h !== p(document)) {
      if (!h || !h.focus) {
        g(u());
        return;
      }
      h.focus({ preventScroll: !!s.preventScroll }), a.mostRecentlyFocusedNode = h, ja(h) && h.select();
    }
  }, w = function(h) {
    var f = l("setReturnFocus", { params: [h] });
    return f || (f === !1 ? !1 : h);
  }, y = function(h) {
    var f = h.target, b = h.event, T = h.isBackward, I = T === void 0 ? !1 : T;
    f = f || Me(b), m();
    var O = null;
    if (a.tabbableGroups.length > 0) {
      var R = d(f, b), E = R >= 0 ? a.containerGroups[R] : void 0;
      if (R < 0)
        I ? O = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : O = a.tabbableGroups[0].firstTabbableNode;
      else if (I) {
        var q = a.tabbableGroups.findIndex(function(ht) {
          var ft = ht.firstTabbableNode;
          return f === ft;
        });
        if (q < 0 && (E.container === f || je(f, s.tabbableOptions) && !Ie(f, s.tabbableOptions) && !E.nextTabbableNode(f, !1)) && (q = R), q >= 0) {
          var V = q === 0 ? a.tabbableGroups.length - 1 : q - 1, H = a.tabbableGroups[V];
          O = pe(f) >= 0 ? H.lastTabbableNode : H.lastDomTabbableNode;
        } else Ne(b) || (O = E.nextTabbableNode(f, !1));
      } else {
        var B = a.tabbableGroups.findIndex(function(ht) {
          var ft = ht.lastTabbableNode;
          return f === ft;
        });
        if (B < 0 && (E.container === f || je(f, s.tabbableOptions) && !Ie(f, s.tabbableOptions) && !E.nextTabbableNode(f)) && (B = R), B >= 0) {
          var ut = B === a.tabbableGroups.length - 1 ? 0 : B + 1, ae = a.tabbableGroups[ut];
          O = pe(f) >= 0 ? ae.firstTabbableNode : ae.firstDomTabbableNode;
        } else Ne(b) || (O = E.nextTabbableNode(f));
      }
    } else O = l("fallbackFocus");
    return O;
  }, S = function(h) {
    if (!(d(Me(h), h) >= 0)) {
      if (Ce(s.clickOutsideDeactivates, h)) {
        o.deactivate({ returnFocus: s.returnFocusOnDeactivate });
        return;
      }
      Ce(s.allowOutsideClick, h) || h.preventDefault();
    }
  }, k = function(h) {
    var f = Me(h), b = d(f, h) >= 0;
    if (b || f instanceof Document)
      b && (a.mostRecentlyFocusedNode = f);
    else {
      h.stopImmediatePropagation();
      var T, I = !0;
      if (a.mostRecentlyFocusedNode)
        if (pe(a.mostRecentlyFocusedNode) > 0) {
          var O = d(a.mostRecentlyFocusedNode), R = a.containerGroups[O].tabbableNodes;
          if (R.length > 0) {
            var E = R.findIndex(function(q) {
              return q === a.mostRecentlyFocusedNode;
            });
            E >= 0 && (s.isKeyForward(a.recentNavEvent) ? E + 1 < R.length && (T = R[E + 1], I = !1) : E - 1 >= 0 && (T = R[E - 1], I = !1));
          }
        } else a.containerGroups.some(function(q) {
          return q.tabbableNodes.some(function(V) {
            return pe(V) > 0;
          });
        }) || (I = !1);
      else I = !1;
      I && (T = y({
        target: a.mostRecentlyFocusedNode,
        isBackward: s.isKeyBackward(a.recentNavEvent)
      })), g(T || a.mostRecentlyFocusedNode || u());
    }
    a.recentNavEvent = void 0;
  }, A = function(h) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = h;
    var b = y({
      event: h,
      isBackward: f
    });
    b && (Ne(h) && h.preventDefault(), g(b));
  }, P = function(h) {
    (s.isKeyForward(h) || s.isKeyBackward(h)) && A(h, s.isKeyBackward(h));
  }, L = function(h) {
    Va(h) && Ce(s.escapeDeactivates, h) !== !1 && (h.preventDefault(), o.deactivate());
  }, M = function(h) {
    d(Me(h), h) >= 0 || Ce(s.clickOutsideDeactivates, h) || Ce(s.allowOutsideClick, h) || (h.preventDefault(), h.stopImmediatePropagation());
  }, C = function() {
    if (!a.active) return Promise.resolve();
    ne.activateTrap(i, o);
    var h;
    return s.delayInitialFocus ? h = new Promise(function(f) {
      a.delayInitialFocusTimer = tn(function() {
        g(u()), f();
      });
    }) : (h = Promise.resolve(), g(u())), r.addEventListener("focusin", k, !0), r.addEventListener("mousedown", S, {
      capture: !0,
      passive: !1
    }), r.addEventListener("touchstart", S, {
      capture: !0,
      passive: !1
    }), r.addEventListener("click", M, {
      capture: !0,
      passive: !1
    }), r.addEventListener("keydown", P, {
      capture: !0,
      passive: !1
    }), r.addEventListener("keydown", L), h;
  }, $ = function(h) {
    a.active && !a.paused && o._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
    var f = /* @__PURE__ */ new Set(), b = /* @__PURE__ */ new Set(), T = Qt(h), I;
    try {
      for (T.s(); !(I = T.n()).done; ) {
        var O = I.value;
        f.add(O);
        for (var R = typeof ShadowRoot < "u" && O.getRootNode() instanceof ShadowRoot, E = O; E; ) {
          f.add(E);
          var q = E.parentElement, V = [];
          q ? V = q.children : !q && R && (V = E.getRootNode().children, q = E.getRootNode().host, R = typeof ShadowRoot < "u" && q.getRootNode() instanceof ShadowRoot);
          var H = Qt(V), B;
          try {
            for (H.s(); !(B = H.n()).done; ) {
              var ut = B.value;
              b.add(ut);
            }
          } catch (ae) {
            H.e(ae);
          } finally {
            H.f();
          }
          E = q;
        }
      }
    } catch (ae) {
      T.e(ae);
    } finally {
      T.f();
    }
    f.forEach(function(ae) {
      b.delete(ae);
    }), a.adjacentElements = b;
  }, Q = function() {
    if (a.active)
      return r.removeEventListener("focusin", k, !0), r.removeEventListener("mousedown", S, !0), r.removeEventListener("touchstart", S, !0), r.removeEventListener("click", M, !0), r.removeEventListener("keydown", P, !0), r.removeEventListener("keydown", L), o;
  }, te = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(function(h) {
    h.some(function(f) {
      return Array.from(f.removedNodes).some(function(b) {
        return b === a.mostRecentlyFocusedNode;
      });
    }) && g(u());
  }) : void 0, U = function() {
    te && (te.disconnect(), a.active && !a.paused && a.containers.map(function(h) {
      te.observe(h, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return o = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(h) {
      if (a.active) return this;
      var f = c(h, "onActivate"), b = c(h, "onPostActivate"), T = c(h, "checkCanFocusTrap"), I = ne.getActiveTrap(i), O = !1;
      if (I && !I.paused) {
        var R;
        (R = I._setSubtreeIsolation) === null || R === void 0 || R.call(I, !1), O = !0;
      }
      try {
        T || m(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = p(r), f?.();
        var E = /* @__PURE__ */ (function() {
          var V = Xt(/* @__PURE__ */ Oe().m(function H() {
            return Oe().w(function(B) {
              for (; ; ) switch (B.n) {
                case 0:
                  return T && m(), B.n = 1, C();
                case 1:
                  o._setSubtreeIsolation(!0), U(), b?.();
                case 2:
                  return B.a(2);
              }
            }, H);
          }));
          return function() {
            return V.apply(this, arguments);
          };
        })();
        if (T)
          return T(a.containers.concat()).then(E, E), this;
        E();
      } catch (V) {
        if (I === ne.getActiveTrap(i) && O) {
          var q;
          (q = I._setSubtreeIsolation) === null || q === void 0 || q.call(I, !0);
        }
        throw V;
      }
      return this;
    },
    deactivate: function(h) {
      if (!a.active) return this;
      var f = en({
        onDeactivate: s.onDeactivate,
        onPostDeactivate: s.onPostDeactivate,
        checkCanReturnFocus: s.checkCanReturnFocus
      }, h);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || o._setSubtreeIsolation(!1), a.alreadySilent.clear(), Q(), a.active = !1, a.paused = !1, U(), ne.deactivateTrap(i, o);
      var b = c(f, "onDeactivate"), T = c(f, "onPostDeactivate"), I = c(f, "checkCanReturnFocus"), O = c(f, "returnFocus", "returnFocusOnDeactivate");
      b?.();
      var R = function() {
        tn(function() {
          O && g(w(a.nodeFocusedBeforeActivation)), T?.();
        });
      };
      return O && I ? (I(w(a.nodeFocusedBeforeActivation)).then(R, R), this) : (R(), this);
    },
    pause: function(h) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, h)) : this;
    },
    unpause: function(h) {
      return a.active ? (a.manuallyPaused = !1, i[i.length - 1] !== this ? this : this._setPausedState(!1, h)) : this;
    },
    updateContainerElements: function(h) {
      return a.containers = [].concat(h).filter(Boolean).map(function(f) {
        return typeof f == "string" ? r.querySelector(f) : f;
      }), s.isolateSubtrees && $(a.containers), a.active && (m(), a.paused || o._setSubtreeIsolation(!0)), U(), this;
    }
  }, Object.defineProperties(o, {
    _isManuallyPaused: { value: function() {
      return a.manuallyPaused;
    } },
    _setPausedState: { value: function(h, f) {
      if (a.paused === h) return this;
      if (a.paused = h, h) {
        var b = c(f, "onPause"), T = c(f, "onPostPause");
        b?.(), Q(), o._setSubtreeIsolation(!1), U(), T?.();
      } else {
        var I = c(f, "onUnpause"), O = c(f, "onPostUnpause");
        I?.(), (/* @__PURE__ */ (function() {
          var R = Xt(/* @__PURE__ */ Oe().m(function E() {
            return Oe().w(function(q) {
              for (; ; ) switch (q.n) {
                case 0:
                  return m(), q.n = 1, C();
                case 1:
                  o._setSubtreeIsolation(!0), U(), O?.();
                case 2:
                  return q.a(2);
              }
            }, E);
          }));
          return function() {
            return R.apply(this, arguments);
          };
        })())();
      }
      return this;
    } },
    _setSubtreeIsolation: { value: function(h) {
      s.isolateSubtrees && a.adjacentElements.forEach(function(f) {
        var b;
        h ? s.isolateSubtrees === "aria-hidden" ? ((f.ariaHidden === "true" || ((b = f.getAttribute("aria-hidden")) === null || b === void 0 ? void 0 : b.toLowerCase()) === "true") && a.alreadySilent.add(f), f.setAttribute("aria-hidden", "true")) : ((f.inert || f.hasAttribute("inert")) && a.alreadySilent.add(f), f.setAttribute("inert", !0)) : a.alreadySilent.has(f) || (s.isolateSubtrees === "aria-hidden" ? f.removeAttribute("aria-hidden") : f.removeAttribute("inert"));
      });
    } }
  }), o.updateContainerElements(t), o;
};
function Ga(e) {
  let t, n;
  window.addEventListener("focusin", () => {
    t = n, n = document.activeElement;
  }), e.magic("focus", (r) => {
    let i = r;
    return {
      __noscroll: !1,
      __wrapAround: !1,
      within(s) {
        return i = s, this;
      },
      withoutScrolling() {
        return this.__noscroll = !0, this;
      },
      noscroll() {
        return this.__noscroll = !0, this;
      },
      withWrapAround() {
        return this.__wrapAround = !0, this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(s) {
        return je(s);
      },
      previouslyFocused() {
        return t;
      },
      lastFocused() {
        return t;
      },
      focused() {
        return n;
      },
      focusables() {
        return Array.isArray(i) ? i : nr(i, { displayCheck: "none" });
      },
      all() {
        return this.focusables();
      },
      isFirst(s) {
        let a = this.all();
        return a[0] && a[0].isSameNode(s);
      },
      isLast(s) {
        let a = this.all();
        return a.length && a.slice(-1)[0].isSameNode(s);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let s = this.all(), a = document.activeElement;
        if (s.indexOf(a) !== -1)
          return this.__wrapAround && s.indexOf(a) === s.length - 1 ? s[0] : s[s.indexOf(a) + 1];
      },
      getPrevious() {
        let s = this.all(), a = document.activeElement;
        if (s.indexOf(a) !== -1)
          return this.__wrapAround && s.indexOf(a) === 0 ? s.slice(-1)[0] : s[s.indexOf(a) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(s) {
        s && setTimeout(() => {
          s.hasAttribute("tabindex") || s.setAttribute("tabindex", "0"), s.focus({ preventScroll: this.__noscroll });
        });
      }
    };
  }), e.directive("trap", e.skipDuringClone((r, { expression: i, modifiers: s }, { effect: a, evaluateLater: o, cleanup: c }) => {
    let d = o(i), l = !1, u = {
      escapeDeactivates: !1,
      allowOutsideClick: !0,
      fallbackFocus: () => r
    }, m = () => {
    };
    if (s.includes("noautofocus")) u.initialFocus = !1;
    else {
      let y = r.querySelector("[autofocus]");
      y && (u.initialFocus = y);
    }
    s.includes("inert") && (u.onPostActivate = () => {
      e.nextTick(() => {
        m = nn(r);
      });
    });
    let p = Wa(r, u), g = () => {
    };
    const w = () => {
      m(), m = () => {
      }, g(), g = () => {
      }, p.deactivate({ returnFocus: !s.includes("noreturn") });
    };
    a(() => d((y) => {
      l !== y && (y && !l && (s.includes("noscroll") && (g = Ya()), setTimeout(() => {
        p.activate();
      }, 15)), !y && l && w(), l = !!y);
    })), c(w);
  }, (r, { expression: i, modifiers: s }, { evaluate: a }) => {
    s.includes("inert") && a(i) && nn(r);
  }));
}
function nn(e) {
  let t = [];
  return ir(e, (n) => {
    let r = n.hasAttribute("aria-hidden");
    n.setAttribute("aria-hidden", "true"), t.push(() => r || n.removeAttribute("aria-hidden"));
  }), () => {
    for (; t.length; ) t.pop()();
  };
}
function ir(e, t) {
  e.isSameNode(document.body) || !e.parentNode || Array.from(e.parentNode.children).forEach((n) => {
    n.isSameNode(e) ? ir(e.parentNode, t) : t(n);
  });
}
function Ya() {
  let e = document.documentElement.style.overflow, t = document.documentElement.style.paddingRight, n = window.innerWidth - document.documentElement.clientWidth, r = window.getComputedStyle(document.documentElement).scrollbarGutter;
  return document.documentElement.style.overflow = "hidden", r && r !== "auto" ? () => {
    document.documentElement.style.overflow = e;
  } : (document.documentElement.style.paddingRight = `${n}px`, () => {
    document.documentElement.style.overflow = e, document.documentElement.style.paddingRight = t;
  });
}
var Xa = Ga;
function Qa(e) {
  e.directive("intersect", e.skipDuringClone((t, { value: n, expression: r, modifiers: i }, { evaluateLater: s, cleanup: a }) => {
    let o = s(r), c = ts(i), d = {
      rootMargin: rs(i),
      threshold: c,
      root: i.includes("parent") ? t.parentElement : null
    };
    if (i.includes("dwell")) {
      Za(t, n, i, o, a, d, c);
      return;
    }
    let l = new IntersectionObserver((u) => {
      u.forEach((m) => {
        m.isIntersecting !== (n === "leave") && (o(), i.includes("once") && l.disconnect());
      });
    }, d);
    l.observe(t), a(() => {
      l.disconnect();
    });
  }));
}
function Za(e, t, n, r, i, s, a) {
  let o, c, d = !1, l = !1, u = es(n), m, p = () => {
    clearTimeout(o), o = void 0;
  }, g = () => {
    l = !1, !(!c || document.hidden || !Je(c, t, a)) && (d = !0, r(), n.includes("once") && (m.disconnect(), document.removeEventListener("visibilitychange", A)));
  }, w = () => {
    m && m.disconnect(), m = new IntersectionObserver(k, s), m.observe(e);
  }, y = () => {
    if (o = void 0, document.hidden) return;
    let P = m.takeRecords();
    if (P.some((L) => !Je(L, t, a))) {
      k(P);
      return;
    }
    l = !0, c = void 0, w();
  }, S = () => {
    o !== void 0 || d || document.hidden || !c || Je(c, t, a) && (o = setTimeout(y, u));
  }, k = (P) => {
    P.forEach((L) => {
      if (c = L, !Je(L, t, a)) {
        p(), d = !1, l = !1;
        return;
      }
      if (l) {
        g();
        return;
      }
      S();
    });
  }, A = () => {
    if (document.hidden) {
      p(), c = void 0, d = !1, l = !1, m.disconnect();
      return;
    }
    w();
  };
  w(), document.addEventListener("visibilitychange", A), i(() => {
    p(), m.disconnect(), document.removeEventListener("visibilitychange", A);
  });
}
function Je(e, t, n) {
  let r = n === 0 ? e.isIntersecting : e.isIntersecting && e.intersectionRatio >= n;
  return t === "leave" ? !r : r;
}
function es(e) {
  let t = (e[e.indexOf("dwell") + 1] || "").match(/^([0-9]+)(ms)?$/);
  return t ? Number(t[1]) : 250;
}
function ts(e) {
  if (e.includes("full")) return 0.99;
  if (e.includes("half")) return 0.5;
  if (!e.includes("threshold")) return 0;
  let t = e[e.indexOf("threshold") + 1];
  return t === "100" ? 1 : t === "0" ? 0 : +`.${t}`;
}
function ns(e) {
  let t = e.match(/^(-?[0-9]+)(px|%)?$/);
  return t ? t[1] + (t[2] || "px") : void 0;
}
function rs(e) {
  const t = "margin", n = "0px 0px 0px 0px", r = e.indexOf(t);
  if (r === -1) return n;
  let i = [];
  for (let s = 1; s < 5; s++) i.push(ns(e[r + s] || ""));
  return i = i.filter((s) => s !== void 0), i.length ? i.join(" ").trim() : n;
}
var is = Qa;
function Et(e, t, n) {
  sr();
  let r = ar(n), i = typeof t == "string" ? os(t) : t;
  return window.Alpine && window.Alpine.closestDataStack && !e._x_dataStack && (i._x_dataStack = window.Alpine.closestDataStack(e), i._x_dataStack && window.Alpine.cloneNode(e, i)), r.patch(e, i), e;
}
function as(e, t, n, r = {}) {
  sr();
  let i = ar(r), s = e.parentNode, a = new qe(e, t), o = typeof n == "string" ? (() => {
    let u = document.createElement("div");
    return u.insertAdjacentHTML("beforeend", n), u;
  })() : n, c = document.createComment("[morph-start]"), d = document.createComment("[morph-end]");
  o.insertBefore(c, o.firstChild), o.appendChild(d);
  let l = new qe(c, d);
  window.Alpine && window.Alpine.closestDataStack && (o._x_dataStack = window.Alpine.closestDataStack(s), o._x_dataStack && window.Alpine.cloneNode(s, o)), i.patchChildren(a, l);
}
function ar(e = {}) {
  let t = (i) => i.getAttribute("key"), n = () => {
  }, r = {
    key: e.key || t,
    lookahead: e.lookahead || !1,
    updating: e.updating || n,
    updated: e.updated || n,
    removing: e.removing || n,
    removed: e.removed || n,
    adding: e.adding || n,
    added: e.added || n
  };
  return r.patch = function(i, s) {
    if (r.differentElementNamesTypesOrKeys(i, s)) return r.swapElements(i, s);
    let a = !1, o = !1, c = (d) => r.skipUntilCondition = d;
    if (!ss(r.updating, () => o = !0, c, i, s, () => a = !0)) {
      if (i.nodeType === 1 && window.Alpine && (window.Alpine.cloneNode(i, s), i._x_teleport && s._x_teleport && r.patch(i._x_teleport, s._x_teleport)), cs(s)) {
        r.patchNodeValue(i, s), r.updated(i, s);
        return;
      }
      a || r.patchAttributes(i, s), r.updated(i, s), o || r.patchChildren(i, s);
    }
  }, r.differentElementNamesTypesOrKeys = function(i, s) {
    return i.nodeType != s.nodeType || i.nodeName != s.nodeName || r.getKey(i) != r.getKey(s);
  }, r.swapElements = function(i, s) {
    if (ke(r.removing, i)) return;
    let a = s.cloneNode(!0);
    ke(r.adding, a) || (i.replaceWith(a), r.removed(i), r.added(a));
  }, r.patchNodeValue = function(i, s) {
    let a = s.nodeValue;
    i.nodeValue !== a && (i.nodeValue = a);
  }, r.patchAttributes = function(i, s) {
    if (i._x_transitioning || i._x_isShown && !s._x_isShown || !i._x_isShown && s._x_isShown) return;
    let a = Array.from(i.attributes), o = Array.from(s.attributes);
    for (let c = a.length - 1; c >= 0; c--) {
      let d = a[c].name;
      s.hasAttribute(d) || (d === "open" && i.nodeName === "DIALOG" && i.open ? i.close() : i.removeAttribute(d));
    }
    for (let c = o.length - 1; c >= 0; c--) {
      let d = o[c].name, l = o[c].value;
      i.getAttribute(d) !== l && i.setAttribute(d, l);
    }
  }, r.patchChildren = function(i, s) {
    let a = r.keyToMap(i.children), o = {}, c = an(s), d = an(i);
    for (; c; ) {
      ds(c, d);
      let u = r.getKey(c), m = r.getKey(d);
      if (r.skipUntilCondition) {
        let y = !d || r.skipUntilCondition(d), S = !c || r.skipUntilCondition(c);
        if (y && S) r.skipUntilCondition = null;
        else {
          y || (d = d && j(i, d)), S || (c = c && j(s, c));
          continue;
        }
      }
      if (!d)
        if (u && o[u]) {
          let y = o[u];
          i.appendChild(y), d = y, m = r.getKey(d);
        } else {
          if (!ke(r.adding, c)) {
            let y = c.cloneNode(!0);
            i.appendChild(y), r.added(y);
          }
          c = j(s, c);
          continue;
        }
      let p = (y) => y && y.nodeType === 8 && y.textContent === "[if BLOCK]><![endif]", g = (y) => y && y.nodeType === 8 && y.textContent === "[if ENDBLOCK]><![endif]";
      if (p(c) && p(d)) {
        let y = 0, S = d;
        for (; d; ) {
          let C = j(i, d);
          if (p(C)) y++;
          else if (g(C) && y > 0) y--;
          else if (g(C) && y === 0) {
            d = C;
            break;
          }
          d = C;
        }
        let k = d;
        y = 0;
        let A = c;
        for (; c; ) {
          let C = j(s, c);
          if (p(C)) y++;
          else if (g(C) && y > 0) y--;
          else if (g(C) && y === 0) {
            c = C;
            break;
          }
          c = C;
        }
        let P = c, L = new qe(S, k), M = new qe(A, P);
        r.patchChildren(L, M);
        continue;
      }
      if (d.nodeType === 1 && r.lookahead && !d.isEqualNode(c)) {
        let y = j(s, c), S = !1;
        for (; !S && y; )
          y.nodeType === 1 && d.isEqualNode(y) && (S = !0, d = r.addNodeBefore(i, c, d), m = r.getKey(d)), y = j(s, y);
      }
      if (u !== m) {
        if (!u && m) {
          o[m] = d, d = r.addNodeBefore(i, c, d), o[m].remove(), d = j(i, d), c = j(s, c);
          continue;
        }
        if (u && !m && a[u] && (d.replaceWith(a[u]), d = a[u], m = r.getKey(d)), u && m) {
          let y = a[u];
          if (y)
            o[m] = d, d.replaceWith(y), d = y, m = r.getKey(d);
          else {
            o[m] = d, d = r.addNodeBefore(i, c, d), o[m].remove(), d = j(i, d), c = j(s, c);
            continue;
          }
        }
      }
      let w = d && j(i, d);
      r.patch(d, c), d._x_lastRenderedEl && (w = j(i, d._x_lastRenderedEl)), c = c && j(s, c), d = w;
    }
    let l = [];
    for (; d; )
      ke(r.removing, d) || l.push(d), d = j(i, d);
    for (; l.length; ) {
      let u = l.shift();
      u.remove(), r.removed(u);
    }
  }, r.getKey = function(i) {
    return i && i.nodeType === 1 && r.key(i);
  }, r.keyToMap = function(i) {
    let s = {};
    for (let a of i) {
      let o = r.getKey(a);
      o && (s[o] = a);
    }
    return s;
  }, r.addNodeBefore = function(i, s, a) {
    if (!ke(r.adding, s)) {
      let o = s.cloneNode(!0);
      return i.insertBefore(o, a), r.added(o), o;
    }
    return s;
  }, r;
}
Et.step = () => {
};
Et.log = () => {
};
function ke(e, ...t) {
  let n = !1;
  return e(...t, () => n = !0), n;
}
function ss(e, t, n, ...r) {
  let i = !1;
  return e(...r, () => i = !0, t, n), i;
}
var rn = !1;
function os(e) {
  const t = document.createElement("template");
  return t.innerHTML = e, t.content.firstElementChild;
}
function cs(e) {
  return e.nodeType === 3 || e.nodeType === 8;
}
var qe = class {
  constructor(e, t) {
    this.startComment = e, this.endComment = t;
  }
  get children() {
    let e = [], t = this.startComment.nextSibling;
    for (; t && t !== this.endComment; )
      e.push(t), t = t.nextSibling;
    return e;
  }
  appendChild(e) {
    this.endComment.before(e);
  }
  get firstChild() {
    let e = this.startComment.nextSibling;
    if (e !== this.endComment)
      return e;
  }
  nextNode(e) {
    let t = e.nextSibling;
    if (t !== this.endComment)
      return t;
  }
  insertBefore(e, t) {
    return t.before(e), e;
  }
};
function an(e) {
  return e.firstChild;
}
function j(e, t) {
  let n;
  return e instanceof qe ? n = e.nextNode(t) : n = t.nextSibling, n;
}
function sr() {
  if (rn) return;
  rn = !0;
  let e = Element.prototype.setAttribute, t = document.createElement("div");
  Element.prototype.setAttribute = function(r, i) {
    if (!r.includes("@")) return e.call(this, r, i);
    let s = i.replace(/&/g, "&amp;").replace(/"/g, "&quot;");
    t.innerHTML = `<span ${r}="${s}"></span>`;
    let a = t.firstElementChild.getAttributeNode(r);
    t.firstElementChild.removeAttributeNode(a), this.setAttributeNode(a);
  };
}
function ds(e, t) {
  let n = t && t._x_bindings && t._x_bindings.id;
  n && e.setAttribute && (e.setAttribute("id", n), e.id = n);
}
function ls(e) {
  e.morph = Et, e.morphBetween = as;
}
var us = ls, hs = (e, t) => {
  let n;
  const r = /* @__PURE__ */ new Set();
  return function(i, s) {
    n && clearTimeout(n), i.forEach(({ target: a }) => r.add(a)), n = setTimeout(() => {
      e(r, s), n = null;
    }, t);
  };
}, fs = (e) => {
  e.forEach((t) => ms(t)), e.clear();
}, ms = (e) => {
  const t = (a) => e.setAttribute("sizes", (a | 0) + "px");
  let n = 0, r = 0, i = e;
  for (; n < 100 && i; )
    n = i.offsetWidth, r = i.offsetHeight, i = i.parentNode;
  if (getComputedStyle(e).objectFit !== "cover") return t(n);
  const s = Number(e.getAttribute("width")) / Number(e.getAttribute("height"));
  if (!s || n / r >= s + 0.1) return t(n);
  t(r * s);
}, le = new ResizeObserver(hs(fs, 800)), sn = (e, t, n) => {
  if (t) return gs(e);
  if (n) return ps(e, n);
  throw new TypeError("Invalid options");
}, ps = (e, t) => (e = new URL(e, document.baseURI).href, e.includes("localhost") ? () => e : (n) => (t + e).replace("{width}", String(n))), gs = (e) => {
  if (e.includes("{width}")) return (t) => e.replaceAll("{width}", String(t));
  if (cn.test(e)) {
    const t = e.replace(cn, "_{width}x$1");
    return (n) => t.replaceAll("{width}", String(n));
  }
  return (t) => {
    const n = new URL(e, document.baseURI);
    return n.searchParams.set("width", String(t)), n.href;
  };
}, ys = [
  180,
  360,
  540,
  720,
  900,
  1080,
  1296,
  1512,
  1728,
  1944,
  2160,
  2376,
  2592,
  2808,
  3024
], on = (e, t = 1 / 0) => ys.filter((n) => n <= t).map((n) => `${e(n)} ${n}w`).join(","), cn = /_\d+x(\.jpg|\.png)/;
function ws(e) {
  const { autoSize: t = !0, shopify: n = !1, maxSize: r = 0, cloudURL: i = "" } = bs(e) ?? {};
  return (s) => {
    s.directive("rias", (o, { expression: c }, { effect: d, evaluateLater: l, cleanup: u }) => {
      if (!(o instanceof HTMLImageElement)) return console.warn("x-rias only works on img elements");
      if (u(() => le.unobserve(o)), !c) return t && le.observe(o);
      const m = l(c);
      d(() => {
        m((p) => {
          if (!p || typeof p != "string") return;
          const g = sn(p, n, i), w = r || Number(o.dataset.maxSize) || 1 / 0, y = g(Math.min(w, 360)), S = on(g, w);
          s.mutateDom(() => {
            o.src = y, o.srcset = S, o.loading = o.loading == "eager" ? "eager" : "lazy", (t || o.dataset.sizes == "auto") && le.observe(o);
          });
        });
      });
    });
    const a = {
      srcset(o) {
        return on(sn(o, n, i), r || 1 / 0);
      },
      observe: le.observe.bind(le),
      unobserve: le.unobserve.bind(le)
    };
    s.magic("rias", () => a);
  };
}
var bs = (e) => {
  if (typeof e == "string") return { cloudURL: `https://res.cloudinary.com/${e}/image/fetch/f_auto,q_80,w_{width}/` };
  if (typeof e == "object") return {
    ...e,
    cloudURL: e.key ? `https://res.cloudinary.com/${e.key}/image/fetch/f_auto,q_80,w_{width}/` : ""
  };
}, vs = (e) => {
  e.addRootSelector(() => `[${e.prefixed("data-async")}]`);
  const t = "data-async", n = e.prefixed("ignore"), r = {}, i = /* @__PURE__ */ new WeakSet(), s = (a, { expression: o }, { evaluateLater: c, evaluate: d, cleanup: l }) => {
    i.has(a) || (i.add(a), c(o)((u) => {
      if (typeof u != "object" || u === null) throw new Error(`alpine.js Async directive expected an object, but received: ${typeof u}`);
      [!0, void 0].includes(u) && (u = {});
      const m = e.reactive(u), p = e.addScopeToNode(a, m);
      m.init && d(m.init), l(() => {
        m.destroy && d(m.destroy), p();
      }), delete a._x_ignore, a.removeAttribute(n), e.initTree(a);
    }, { scope: r }));
  };
  s.inline = (a, { expression: o }) => {
    i.has(a) || (a._x_ignore = !0, a.setAttribute(n, ""));
  }, e.directive(t, s).before("ignore"), e.asyncData = (a, o) => {
    r[a] = async (...c) => {
      const [d, l] = o.split("?");
      try {
        const u = await import(d);
        if (l && l in u) return u[l](...c);
        if (a in u) return u[a](...c);
        if (u.default && typeof u.default == "function") return u.default(...c);
        if (typeof u == "function") return u(...c);
        throw new Error(`Async Data: Module ${o} does not export a function named ${a}, or a default function.`);
      } catch (u) {
        return console.error("Async Data Loader Error while looking for:", a, o), console.error(u), {};
      }
    };
  };
}, Ss = (e) => {
  e.directive("clickable", (r, { expression: i }, { cleanup: s }) => {
    const a = r.querySelector(i || "a, button");
    if (!a) return console.warn(`x-clickable: No target found for selector ${i || "a, button"}`);
    const o = function(c) {
      const d = c.target;
      !(d instanceof HTMLElement) || t(d, r) !== r || n(a, c.constructor, c);
    };
    s(e.bind(r, {
      "@click": o,
      "@auxclick": o
    }));
  });
  const t = (r, i) => e.findClosest(r, (s) => s.matches("a, button, input, select") || s === i), n = (r, i = MouseEvent, s) => r.dispatchEvent(new i("click", s));
}, Is = class {
  el;
  details;
  get id() {
    return this.el.id;
  }
  closing = !1;
  opening = !1;
  backdrop;
  keyboard;
  constructor(e, t, n) {
    this.el = e, this.details = n, this.backdrop = t.backdrop, this.keyboard = t.keyboard;
  }
  withDetails(e) {
    return e && (this.details = e), this;
  }
  async open() {
    return this.el.open ? this : (this.opening = !0, this.el.dispatchEvent(new CustomEvent("dialog-opening", {
      detail: this,
      bubbles: !0
    })), this.el.showModal(), await this.el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200 }).finished, this.el.dispatchEvent(new CustomEvent("dialog-opened", {
      detail: this,
      bubbles: !0
    })), this.opening = !1, this);
  }
  async close() {
    return this.el.open ? (this.closing = !0, this.el.dispatchEvent(new CustomEvent("dialog-closing", {
      detail: this,
      bubbles: !0
    })), await this.el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200 }).finished, this.el.close(), this.el.dispatchEvent(new CustomEvent("dialog-closed", {
      detail: this,
      bubbles: !0
    })), this.closing = !1, this) : this;
  }
}, Ts = class extends EventTarget {
  Alpine;
  availableDialogs = /* @__PURE__ */ new Map();
  active = null;
  constructor(e) {
    super(), this.Alpine = e;
  }
  get isActive() {
    return !!this.active;
  }
  get id() {
    return this.active?.el.id;
  }
  get details() {
    return this.active?.details;
  }
  open(e, t) {
    if (e === this.active?.el.id) return this;
    this.active && this.close(this.active);
    const n = this.availableDialogs.get(e) ?? null;
    return n ? (this.active = n, n.withDetails(t).open(), this.dispatchEvent(new CustomEvent("dialog-opened", { detail: n })), this) : (console.error(`Modal with id "${e}" does not exist`), this);
  }
  close(e) {
    const t = e ?? this.active;
    return t ? (t.close().then((n) => n === this.active && (this.active = null)), this.dispatchEvent(new CustomEvent("dialog-closed", { detail: t })), this) : (console.log(e, t, "there is no active"), this);
  }
  setOptions(e) {
    return this.active && Object.assign(this.active, e), this;
  }
  isRegistered(e) {
    return this.availableDialogs.has(e);
  }
  unregister(e) {
    return this.availableDialogs.delete(e), this.active?.id === e && (this.active = null), this;
  }
  create(e, t, n) {
    const r = this.Alpine.reactive(new Is(e, t, n));
    return this.availableDialogs.set(r.id, r), r;
  }
}, xs = (e) => {
  const t = new Ts(e);
  e.addRootSelector(() => `[${e.prefixed("dialog")}]`), e.directive("dialog", (n, { expression: r }, { evaluate: i, cleanup: s }) => {
    if (!(n instanceof HTMLDialogElement)) return console.error("x-modal must be on a <dialog> element", n);
    const a = n.id;
    console.assert(!!a, "x-dialog element must have an ID: %o", n);
    const { backdrop: o = !0, keyboard: c = !0 } = r ? i(r) : {}, d = t.create(n, {
      backdrop: o,
      keyboard: c
    });
    s(e.addScopeToNode(n, { $dialog: d })), s(t.unregister.bind(t, a)), s(e.bind(n, {
      "@click.self"() {
        d.backdrop && t.close(d);
      },
      "@cancel.prevent.stop"() {
        d.keyboard && t.close(d);
      },
      "@dialog-closed.self"(l) {
        l.detail === d && d === t.active && (t.active = null, t.dispatchEvent(new CustomEvent("dialog-closed", { detail: d })));
      },
      "@keydown.escape.prevent.stop"() {
        d.keyboard && t.close(d);
      },
      ":class"() {
        return {
          "dialog-out backdrop:animate-fade-out": d.closing,
          "dialog-in backdrop:animate-fade-in": d.opening
        };
      }
    }));
  }), e.magic("dialogs", () => t), e.$dialogs = t;
}, Ve = /* @__PURE__ */ (function(e) {
  return e.Up = "up", e.Down = "down", e;
})(Ve || {}), Rs = (e) => {
  const t = /* @__PURE__ */ new Set(), n = e.reactive({
    previous: window.scrollY,
    current: window.scrollY,
    nearTop: window.scrollY < 120,
    direction: Ve.Up,
    onScroll: (i) => (t.add(i), () => t.delete(i))
  });
  let r;
  n.onScroll((i) => {
    const s = i.current > i.previous ? Ve.Down : Ve.Up;
    s !== n.direction ? r ??= setTimeout(() => n.direction = s, 200) : (clearTimeout(r), r = void 0);
  }), window.addEventListener("scroll", () => {
    n.previous = n.current, n.current = window.scrollY, n.nearTop = window.scrollY <= 90 ? !0 : window.scrollY >= 120 ? !1 : n.nearTop, t.forEach((i) => i(n));
  }, { passive: !0 }), e.$scroll = n, e.magic("scroll", () => n);
}, _ = /* @__PURE__ */ Symbol("$slider"), or = (e) => _ in e, Cs = {
  ":disabled"() {
    return this[_].isLast;
  },
  "x-on:click"() {
    this[_].next(this.$el);
  }
}, ks = {
  ":disabled"() {
    return this[_].isFirst;
  },
  "x-on:click"() {
    this[_].prev(this.$el);
  }
}, Es = (e) => ({
  ":disabled"() {
    return this[_].focusedIndex === e;
  },
  "x-on:click"() {
    this[_].scrollTo(e);
  }
}), Os = {
  "x-on:mouseenter"() {
    this[_].pause();
  },
  "x-on:mouseleave"() {
    this[_].unpause();
  },
  "x-on:focusin"() {
    this[_].pause();
  },
  "x-on:focusout"() {
    this[_].unpause();
  }
}, As = { ":style"() {
  const e = this[_].focusedSize;
  return {
    maxHeight: e ? `${e}px` : "max-content",
    transition: "max-height 300ms"
  };
} }, Ns = {
  "x-intersect.threshold.60"() {
    this.visible = !0;
    const e = this[_];
    this.index = e.indexOfItem(this.$el) ?? 0, e.handleIntersect(this.$el);
  },
  "x-intersect:leave.threshold.40"() {
    this.visible = !1;
    const e = this[_];
    this.index = e.indexOfItem(this.$el) ?? 0, e.handleIntersect(this.$el, !1);
  },
  "x-init"() {
    this[_].onLoad(this.$el);
  },
  "x-on:load"() {
    this[_].onLoad(this.$el);
  },
  "x-data"() {
    return {
      visible: !1,
      index: 0
    };
  },
  ":class"() {
    const e = this[_], t = this.index, n = e.focusedIndex;
    return {
      "slide-item": !0,
      "slide-next": t > n,
      "slide-previous": t < n,
      "slide-current": t === n,
      "slide-visible": this.visible
    };
  }
}, Ds = {
  "x-intersect:enter.threshold.60"() {
    this.$el.removeAttribute("tabindex"), this.$el.removeAttribute("inert");
  },
  "x-intersect:leave.threshold.40"() {
    this.$el.setAttribute("tabindex", "-1"), this.$el.setAttribute("inert", "inert");
  }
}, qs = (e, t, n, { Alpine: r, cleanup: i }) => {
  const s = r.$data(t);
  if (!or(s)) {
    console.error(`Element with ${n.original} needs to be inside an x-slider element`, t);
    return;
  }
  const a = s[_];
  if (a.components.set(e, t), e === "gallery") {
    const o = new AbortController(), c = a.updateEdges.bind(a);
    t.addEventListener("scroll", c, {
      passive: !0,
      signal: o.signal
    });
    const d = new ResizeObserver(c), l = new MutationObserver(c);
    d.observe(t), l.observe(t, { childList: !0 }), i(() => {
      o.abort(), d.disconnect(), l.disconnect();
    }), a.updateEdges();
  }
}, he = (e) => Array.from(e.children).flatMap((t) => getComputedStyle(t).display === "contents" ? he(t) : t).filter((t) => t.nodeName !== "TEMPLATE" && getComputedStyle(t).display !== "none"), Ls = (e, t) => {
  let n = 0, r = Number.POSITIVE_INFINITY;
  for (let i = 0; i < e.length; i++) {
    const s = Math.abs(e[i] - t);
    if (s >= r) return n;
    r = s, n = i;
  }
  return n;
}, Ps = (e, t, n, r = 1) => {
  const i = t - n;
  return {
    atStart: e <= r,
    atEnd: e >= i - r
  };
}, $s = (e) => e instanceof HTMLImageElement, Fs = (e, { expression: t }, { evaluate: n, cleanup: r, Alpine: i }) => {
  const s = Object.assign({
    scrollToDepth: 0,
    intoView: !1,
    centerVertically: !1,
    autoScroll: 0,
    autoInitialize: !1,
    animated: !1
  }, t ? n(t) : {}), a = i.reactive({
    focusedIndex: 0,
    focusedSize: 0,
    initialized: !!s.autoInitialize,
    touched: !1,
    paused: !1,
    atStart: !0,
    atEnd: !1,
    pause() {
      return this.paused = !0, this;
    },
    unpause() {
      return this.paused = !1, this;
    },
    components: /* @__PURE__ */ new Map(),
    autoScrollPercentage: 1,
    init() {
      if (s.autoScroll) {
        const o = new _s(s.autoScroll).onTick((c) => {
          this.autoScrollPercentage = c;
        }).onFinish(() => {
          if (this.touched) return o.abort();
          if (this.paused) return;
          const c = this.components.get("gallery");
          c && this.scrollTo(Yr(this.focusedIndex + 1, he(c).length));
        });
        r(() => o.abort());
      }
    },
    onLoad(o) {
      if (this.initialized || $s(o) && !o.complete) return;
      this.focusedIndex = 0, this.focusedSize = this.itemAtIndex(0)?.clientHeight || 0;
      const c = this.components.get("gallery");
      c && (c.scrollLeft = 0), this.initialized = !0, this.init(), this.updateEdges();
    },
    handleIntersect(o, c = !0) {
      if (!this.initialized) return;
      const d = this.components.get("gallery");
      if (c && (!d || s.animated)) {
        this.focusedIndex = this.indexOfItem(o) ?? 0, this.focusedSize = o.clientHeight;
        return;
      }
      this.updateFocusedIndex(), this.updateEdges();
    },
    updateFocusedIndex() {
      const o = this.components.get("gallery");
      if (!o) return;
      const c = he(o), d = parseFloat(getComputedStyle(o).scrollPaddingLeft) || 0, l = c.map((m) => Se(HTMLElement, m)?.offsetLeft ?? 0), u = Ls(l, o.scrollLeft + d);
      this.focusedIndex = u, this.focusedSize = Se(HTMLElement, c[u])?.clientHeight ?? e.clientHeight;
    },
    itemAtIndex(o) {
      const c = this.components.get("gallery");
      if (!c) return;
      const d = he(c);
      let l = d[Kr(o, d.length - 1)];
      if (l !== void 0) {
        for (let u = 0; u < s.scrollToDepth; u++) l = l?.firstElementChild ?? l;
        return l?.closest("template") ? this.itemAtIndex(o + 1) : l;
      }
    },
    indexOfItem(o) {
      const c = this.components.get("gallery");
      if (!c) return;
      const d = he(c);
      for (let l = 0; l < d.length; l++) if (d[l].contains(o)) return l;
    },
    async scrollTo(o, c = 0, d = !1, l = !1) {
      const u = this.components.get("gallery");
      if (!u) return;
      const m = o instanceof Element ? o : this.itemAtIndex(o);
      if (!m) return;
      d && (this.touched = !0);
      const p = typeof o == "number" ? o : this.indexOfItem(m) ?? this.focusedIndex;
      this.initialized || (this.initialized = !0, await Gr()), l || s.animated ? this.focusedIndex = p : this.focusedIndex += Math.sign(p - this.focusedIndex), s.animated || (window.scrollBy({ top: 0.5 }), window.scrollBy({ top: -0.5 }), s.intoView ? m.scrollIntoView({
        behavior: "smooth",
        block: s.centerVertically ? "center" : "nearest",
        inline: "center"
      }) : (l && (u.style.scrollBehavior = "auto"), u.scrollLeft = o === 0 ? 0 : (Se(HTMLElement, m)?.offsetLeft ?? 0) - c, l && (u.style.scrollBehavior = null)));
      const g = this.components.get("thumbnails");
      if (!g) return;
      const w = Se(HTMLElement, g.children[p]);
      w && g.scrollTo({
        top: w.offsetTop - (g.clientHeight - w.clientHeight) / 2,
        left: w.offsetLeft - (g.clientWidth - w.clientWidth) / 2,
        behavior: "smooth"
      });
    },
    updateEdges() {
      const o = this.components.get("gallery");
      if (!o || s.animated) return;
      const { atStart: c, atEnd: d } = Ps(o.scrollLeft, o.scrollWidth, o.clientWidth);
      this.atStart = c, this.atEnd = d;
    },
    get isFirst() {
      return s.animated ? this.focusedIndex === 0 : this.atStart;
    },
    get isLast() {
      const o = this.components.get("gallery");
      return o ? s.animated ? this.focusedIndex === he(o).length - 1 : this.atEnd : !0;
    },
    get itemCount() {
      const o = this.components.get("gallery");
      return o ? he(o).length : 0;
    },
    next(o) {
      const c = this.getStepInfo(o);
      this.scrollTo(Math.max(0, this.focusedIndex + c), 10, !0);
    },
    prev(o) {
      const c = this.getStepInfo(o);
      this.scrollTo(Math.max(0, this.focusedIndex - c), 10, !0);
    },
    getStepInfo(o) {
      const c = getComputedStyle(o);
      let d = parseInt(c.getPropertyValue("--perpage") || "1");
      const l = c.getPropertyValue("--arrow-step").trim(), u = this.components.get("gallery");
      if (u && l === "view") {
        const m = Se(HTMLElement, this.itemAtIndex(0)), p = Se(HTMLElement, this.itemAtIndex(1)), g = m && p && m !== p ? Math.abs(p.offsetLeft - m.offsetLeft) : 0;
        g > 0 && (d = Math.max(1, Math.floor(u.clientWidth / g)));
      }
      return d;
    }
  });
  i.addScopeToNode(e, { [_]: a }), s.autoInitialize && a.init();
}, _s = class cr extends EventTarget {
  duration = 0;
  currentTime = 0;
  lastTimestep = 0;
  controller = new AbortController();
  get percentage() {
    return this.currentTime / this.duration;
  }
  constructor(t) {
    super(), this.duration = t, this.lastTimestep = performance.now(), requestAnimationFrame(this.ticker);
  }
  ticker = (t) => {
    if (this.controller.signal.aborted) return;
    const n = t - this.lastTimestep;
    this.lastTimestep = t, this.currentTime += n, this.dispatchEvent(new Event("tick")), this.currentTime > this.duration && (this.dispatchEvent(new Event("just-finished")), this.currentTime %= this.duration), requestAnimationFrame(this.ticker);
  };
  abort() {
    this.controller.abort();
  }
  onTick(t) {
    return this.addEventListener("tick", () => t(this.percentage), { signal: this.controller.signal }), this;
  }
  onFinish(t) {
    return this.addEventListener("just-finished", t, { signal: this.controller.signal }), this;
  }
  static fromSeconds(t) {
    return new cr(t * 1e3);
  }
}, Ms = (e) => {
  e.addRootSelector(() => `[${e.prefixed("slider")}]`), e.directive("slider", (t, n, r) => {
    if (!n.value || n.value === "root") return Fs(t, n, r);
    (n.value === "gallery" || n.value === "thumbnails") && qs(n.value, t, n, r);
  }), e.magic("slider", (t) => {
    const n = e.$data(t);
    if (or(n)) return n[_];
  }), e.bind("$sliderDynamicHeight", As), e.bind("$sliderItem", Ns), e.bind("$sliderNext", Cs), e.bind("$sliderPrev", ks), e.bind("$sliderGoTo", Es), e.bind("$sliderPause", Os), e.bind("$sliderUnfocusHidden", Ds);
}, dn = (e, t, n = t) => {
  const { scrollPaddingTop: r, scrollPaddingBottom: i } = window.getComputedStyle(e);
  return {
    top: ln(r, t),
    bottom: ln(i, n)
  };
}, ln = (e, t) => e !== "auto" ? parseInt(e) : t, Js = 100, Bs = (e) => {
  e.addRootSelector(() => `[${e.prefixed("smartstick")}]`), e.directive("smartstick", (t, n, { cleanup: r }) => {
    let i = dn(t, Js);
    const s = e.reactive({
      top: 0,
      get topString() {
        return `${-1 * this.top + i.top}px`;
      }
    });
    let a = 0, o = window.scrollY;
    const c = () => {
      const g = window.scrollY, w = g - o;
      s.top = Math.min(a, Math.max(0, s.top + w)), o = g;
    }, d = () => {
      i = dn(t, i.top, i.bottom), a = Math.max(0, t.clientHeight - window.innerHeight + i.top + i.bottom);
    }, l = new ResizeObserver(d);
    l.observe(t), window.addEventListener("resize", d);
    const u = window.matchMedia("(min-width: 1024px)"), m = (g) => window[g.matches ? "addEventListener" : "removeEventListener"]("scroll", c, { passive: !0 });
    u.addEventListener("change", m), m(u);
    const p = e.effect(() => t.style.top = s.topString);
    r(() => {
      e.release(p), l.disconnect(), u.removeEventListener("change", m), window.removeEventListener("resize", d), window.removeEventListener("scroll", c);
    });
  });
}, Ot = (e, t, n) => {
  const r = /* @__PURE__ */ new WeakMap();
  return (i) => {
    i.addRootSelector(() => `[${i.prefixed(e)}]`);
    const s = (a) => {
      const o = i.findClosest(a, r.has.bind(r));
      if (!o) return console.error(`Could not find root for ${e} component`, a);
      if (o instanceof HTMLElement) return r.get(o);
    };
    i.magic(e, (a) => s(a)), i.directive(e, (a, o, c) => {
      if (!o.value) return r.set(a, t(a, o, c));
      const d = s(a);
      if (!d) return js(e, a);
      (n?.[o.value] || Us(e))(d, a, o, c);
    });
  };
}, Us = (e) => (t, n, r) => {
  console.error(`Alpine ${e}: Invalid directive value`, n, r.original);
}, js = (e, t) => console.error(`Could not find root for ${e} component`, t), He = /* @__PURE__ */ new WeakMap(), Vs = (e, t) => {
  const n = t.findClosest(e, He.has.bind(He));
  if (n instanceof HTMLElement) return He.get(n);
}, Hs = (e, t, { Alpine: n, effect: r }) => {
  const i = n.reactive({
    active: null,
    id: 0,
    addAccordion(s) {
      const a = this.id++, o = n.reactive({ active: s });
      return r(() => {
        o.active ? this.active = a : this.active === a && (this.active = null);
      }), r(() => {
        this.active === a ? o.active = !0 : o.active = !1;
      }), o;
    }
  });
  return He.set(e, i), i;
}, zs = (e) => {
  e.addRootSelector(() => `[${e.prefixed("accordion-group")}]`), e.directive("accordion-group", Hs);
}, Ks = (e, { modifiers: [t = "closed"] }, { Alpine: n }) => Vs(e, n)?.addAccordion(t === "open") ?? n.reactive({ active: t === "open" }), Ws = {
  open: !0,
  close: !1,
  toggle: null
}, Gs = (e, t, { modifiers: [n = "toggle"] }, { Alpine: r }) => {
  r.bind(t, {
    "x-on:click": () => {
      e.active = Ws[n] ?? !e.active;
    },
    ":aria-expanded": () => e.active
  });
}, Ys = (e, t, n, { Alpine: r }) => {
  r.bind(t, { "x-show": () => e.active });
}, Xs = {
  control: Gs,
  container: Ys
}, Qs = Ot("accordion", Ks, Xs), Zs = (e) => {
  zs(e), Qs(e);
}, dr = () => new Promise((e) => queueMicrotask(() => setTimeout(e))), un = new ResizeObserver((e) => {
  for (const t of e) {
    const n = t.target;
    n instanceof HTMLElement && eo(n);
  }
}), eo = async (e) => {
  await dr(), e.scrollLeft = (e.scrollWidth - e.clientWidth) / 2, e.scrollTop = (e.scrollHeight - e.clientHeight) / 2;
}, hn = Array.prototype.forEach, to = (e) => e.directive("dragscroll", (t, { modifiers: n }, { cleanup: r }) => {
  const i = n.includes("center");
  r(no(t)), t.classList.add("overscroll-contain", "cursor-grab"), i && (hn.call(t.children, (s) => un.observe(s)), r(() => hn.call(t.children, (s) => un.unobserve(s))));
}), Ee = (e) => {
  e.preventDefault(), e.stopPropagation();
}, fn = [
  "pointerup",
  "mouseup",
  "touchend"
], no = (e) => {
  const t = (i) => {
    Ee(i), e.scrollLeft -= i.movementX, e.scrollTop -= i.movementY;
  }, n = async (i) => {
    Ee(i), document.removeEventListener("pointermove", t, !0), document.body.classList.remove("!cursor-grabbing", "[&>*]:pointer-events-none"), e.classList.add("cursor-grab"), await dr(), document.removeEventListener("click", Ee, !0), fn.forEach((s) => {
      document.removeEventListener(s, n, { capture: !0 });
    });
  }, r = (i) => {
    ro(i) || i.button !== 2 && (Ee(i), e.classList.remove("cursor-grab"), document.body.classList.add("!cursor-grabbing", "[&>*]:pointer-events-none"), document.addEventListener("pointermove", t, { capture: !0 }), fn.forEach((s) => document.addEventListener(s, n, { capture: !0 })), document.addEventListener("click", Ee, { capture: !0 }));
  };
  return e.addEventListener("pointerdown", r), () => e.removeEventListener("pointerdown", r);
}, ro = (e) => e instanceof TouchEvent || e instanceof PointerEvent && e.pointerType === "touch", io = (e, t, { Alpine: n }) => {
  const r = n.reactive({
    root: e,
    isOpen: !1,
    open() {
      this.isOpen = !0;
    },
    close() {
      this.isOpen = !1;
    },
    toggle() {
      return this.isOpen ? this.close() : this.open();
    }
  });
  return n.bind(e, { "x-id": () => ["x-panel"] }), r;
}, ao = Ot("panel", io, {
  summary: (e, t, n, { Alpine: r }) => {
    r.bind(t, {
      ":aria-expanded": () => e.isOpen,
      ":aria-controls": '$id("x-panel")'
    });
  },
  content: (e, t, n, { Alpine: r }) => {
    r.bind(t, {
      "x-show": () => e.isOpen,
      ":id": '$id("x-panel")'
    });
  }
}), so = Ot("tabs", (e, t, { Alpine: n, evaluate: r }) => n.reactive({
  activeTab: 0,
  tabs: [],
  panels: [],
  $focus: r("$focus"),
  isSelected(i) {
    return this.tabs[this.activeTab] === i;
  },
  activate(i) {
    this.activeTab = i, n.nextTick(() => this.panels[i]?.dispatchEvent(new CustomEvent("tab-activated")));
  }
}), {
  list: (e, t, n, { Alpine: r }) => {
    const i = () => e.$focus.wrap().next(), s = () => e.$focus.wrap().previous();
    r.bind(t, {
      ":role": () => "tablist",
      "@keydown.arrow-left.stop.prevent": s,
      "@keydown.arrow-right.stop.prevent": i,
      "@keydown.arrow-up.stop.prevent": s,
      "@keydown.arrow-down.stop.prevent": i
    });
  },
  tab: (e, t, n, { Alpine: r }) => {
    const i = e.tabs.push(t) - 1, s = () => e.activate(i);
    r.bind(t, {
      ":tabindex": () => Number(e.isSelected(t)) - 1,
      ":aria-selected": () => e.isSelected(t),
      "@click": s,
      "@keydown.space.stop.prevent": s,
      "@keydown.enter.stop.prevent": s
    });
  },
  panel: (e, t, n, { Alpine: r }) => {
    const i = e.panels.push(t) - 1;
    r.bind(t, {
      ":tab-index": () => Number(e.isSelected(t)) - 1,
      ":aria-hidden": () => !e.isSelected(t),
      ":class"() {
        if (i === e.activeTab) return "panel-current";
        if (i > e.activeTab) return "panel-next";
        if (i < e.activeTab) return "panel-previous";
      }
    });
  }
}), ct = /* @__PURE__ */ (function(e) {
  return e[e.None = 0] = "None", e[e.Left = 1] = "Left", e[e.Right = 2] = "Right", e[e.Up = 4] = "Up", e[e.Down = 8] = "Down", e;
})(ct || {}), Le = /* @__PURE__ */ new WeakMap(), oo = Le.has.bind(Le), co = (e) => e.directive("swipe", (t, n, { cleanup: r }) => {
  Le.set(t, { dispatch: (i) => {
    const s = Object.entries(ct).filter(([, a]) => typeof a == "number" && a && (i & a) === a).map(([a]) => a.toLowerCase());
    t.dispatchEvent(new CustomEvent("swipe", { detail: s.join("-") })), t.dispatchEvent(new CustomEvent(`swipe${s.join("")}`, { detail: s.join("-") }));
  } }), t.addEventListener("touchstart", mn), r(() => t.removeEventListener("touchstart", mn));
}), mn = (e) => {
  const t = Le.get(e.currentTarget);
  if (!t) return;
  const { clientX: n, clientY: r } = e.touches[0];
  t.start ??= {
    x: n,
    y: r
  }, document.addEventListener("touchend", lo, { once: !0 });
}, lo = (e) => {
  const t = e.target;
  if (!t) return;
  const n = Le.get(lr(t, oo));
  if (!n?.start) return;
  const { clientX: r, clientY: i } = e.changedTouches[0], s = uo(n.start, {
    x: r,
    y: i
  });
  s !== ct.None && (n.dispatch(s), delete n.start);
}, lr = (e, t) => t(e) ? e : e.parentElement ? lr(e.parentElement, t) : null, uo = (e, t) => {
  const n = [t.x - e.x, t.y - e.y];
  if (n.every((a) => Math.abs(a) < 50)) return ct.None;
  const r = Math.sqrt(n[0] * n[0] + n[1] * n[1]), [i, s] = n.map((a) => a / r);
  return pn(i) | pn(s) << 2;
}, pn = (e) => e > 0.5 ? 2 : e < -0.5 ? 1 : 0, ho = (e) => {
  e.magic("screen", () => (t) => {
    const n = typeof t == "number" ? t : fo[t] ?? Number(t);
    return n ? mo(n, e).value : (console.error(`Invalid breakpoint: $screen(${JSON.stringify(t)})`), !1);
  });
}, fo = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, ur = {}, mo = (e, t) => ur[e] ?? po(e, t), po = (e, t) => {
  const n = window.matchMedia(`(min-width: ${e}px)`), r = t.reactive({ value: n.matches });
  return ur[e] = r, n.addEventListener("change", (i) => {
    r.value = i.matches;
  }), r;
}, go = (e) => e.plugin([ho]), yo = (e) => e.plugin([
  Zs,
  to,
  ao,
  co,
  so,
  go
]), wo = (e) => {
  e.magic("abortSignal", (t, { cleanup: n }) => {
    const r = new AbortController();
    return n(() => r.abort("Alpine Component has been Removed")), r.signal;
  });
}, bo = (e) => {
  e.magic("dataset", (t) => t.dataset), e.magic("formatMoney", () => window.NewThink?.ACCESS_GATE_SHOW_PRICES === !1 ? () => "" : Mr);
}, vo = (e) => {
  e.bind("hideOverflow", {
    "x-data": "{ visible: true }",
    ":class": "{ 'pointer-events-none invisible': !visible }",
    "x-intersect:leave.threshold.99.margin.1000.0": "visible = false",
    "x-intersect:enter.threshold.99.margin.1000.0": "visible = true"
  });
}, So = (e) => {
  e.addRootSelector(() => `[${e.prefixed("hydratable")}]`), e.directive("hydratable", (t, n, { cleanup: r }) => {
    r(e.addScopeToNode(t, {
      hydrated: !1,
      async hydrate() {
        const i = this.$refs.deferred;
        if (this.hydrated || !i || !(i instanceof HTMLTemplateElement)) return;
        this.hydrated = !0;
        const s = this.$refs.content, a = i.content.cloneNode(!0), o = Array.from(a.querySelectorAll("script"));
        o.forEach((c) => c.remove()), e.mutateDom(() => {
          i.replaceWith(a);
        });
        for (const c of o) await new Promise((d) => {
          const l = document.createElement("script");
          for (const u of c.attributes) l.setAttribute(u.name, u.value);
          l.textContent = c.textContent, c.src ? (l.addEventListener("load", () => d()), l.addEventListener("error", () => d()), s.appendChild(l)) : (s.appendChild(l), d());
        });
        e.initTree(s);
      }
    }));
  });
}, Io = 0, To = (e) => {
  e.directive("inert-trap", (t, { expression: n, modifiers: r }, { evaluateLater: i, effect: s, cleanup: a }) => {
    const o = r.includes("retain"), c = r.includes("noscroll"), d = r.includes("return"), l = r.includes("header"), u = i(n), m = String(++Io);
    let p = null, g = null;
    const w = () => {
      for (const y of document.querySelectorAll(`[data-inert-trap="${m}"]`))
        y.removeAttribute("inert"), y.removeAttribute("data-inert-trap");
      c && (document.documentElement.style.removeProperty("overflow"), document.body.style.removeProperty("overflow"));
    };
    a(w), s(() => {
      u((y) => {
        if (y) {
          p = document.activeElement, g = Nn(document.body, p);
          for (const S of xo(t, ...document.querySelectorAll("[role=alertdialog]"), ...l ? document.querySelectorAll("[data-site-header]") : [], o ? p?.closest("[data-retain-focus-from]") ?? p : null))
            S.setAttribute("inert", "inert"), S.setAttribute("data-inert-trap", m);
          c && document.documentElement.setAttribute("data-scroll-lock", "");
        } else
          w(), d && p && (p.isConnected ? p.focus() : g && An(document.body, g), p = null, g = null);
      });
    });
  });
};
function xo(...e) {
  return e = e.filter((t) => t !== null), document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, (t) => {
    if (!(t instanceof HTMLElement) || t.matches("[inert] > *") || e.includes(t)) return NodeFilter.FILTER_REJECT;
    for (const n of e) if (t.contains(n)) return NodeFilter.FILTER_SKIP;
    return NodeFilter.FILTER_ACCEPT;
  });
}
var Ro = (e) => {
  e.directive("highlight-scroll", (t, { expression: n }, { cleanup: r }) => {
    const i = n.trim();
    if (!i) {
      console.warn("Alpine.js: v-highlight-scroll requires a class name to highlight.");
      return;
    }
    const s = t.firstChild;
    if (!s || !(s instanceof Text)) {
      console.warn("Alpine.js: v-highlight-scroll requires a text node as the first child.");
      return;
    }
    const a = (s.textContent?.trim().split("") ?? []).map((d) => {
      const l = document.createElement("span");
      return l.textContent = d, l.classList.add(i), l;
    });
    s.replaceWith(...a);
    let o = -1;
    const c = setInterval(() => {
      o == -1 ? a.forEach((d) => d.classList.remove(i)) : a[o]?.classList.remove(i), o += 1, o %= a.length, a[o]?.classList.add(i);
    }, 500);
    r(() => clearInterval(c));
  }), e.addInitSelector(() => e.prefixed("highlight-scroll"));
}, Co = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])', ko = (e) => {
  e.directive("scroll-region", (t, { expression: n }, { cleanup: r }) => {
    const i = () => {
      t.querySelector(Co) ? (t.removeAttribute("tabindex"), t.removeAttribute("role"), t.removeAttribute("aria-label")) : (t.tabIndex = 0, t.setAttribute("role", "region"), t.setAttribute("aria-label", n));
    };
    i();
    const s = new MutationObserver(i);
    s.observe(t, {
      childList: !0,
      subtree: !0
    }), r(() => s.disconnect());
  });
}, gn = {
  linear: (e) => e,
  easeOut: (e) => 1 - (1 - e) ** 3,
  easeInOut: (e) => e < 0.5 ? 2 * e * e : 1 - (-2 * e + 2) ** 2 / 2
}, hr = (e) => e === document.scrollingElement || e === document.documentElement, Eo = (e) => {
  let t = e.parentElement;
  for (; t; ) {
    const { overflowY: n } = getComputedStyle(t);
    if ((n === "auto" || n === "scroll") && t.scrollHeight > t.clientHeight) return t;
    t = t.parentElement;
  }
  return document.scrollingElement ?? document.documentElement;
}, Oo = (e, t, { block: n = "center", offset: r = 0 }) => {
  const { top: i, height: s } = e.getBoundingClientRect(), a = hr(t) ? 0 : t.getBoundingClientRect().top + t.clientTop, o = n === "start" ? 0 : n === "end" ? t.clientHeight - s : (t.clientHeight - s) / 2;
  return Math.max(0, Math.min(t.scrollTop + i - a - o + r, t.scrollHeight - t.clientHeight));
}, gt = /* @__PURE__ */ new WeakMap(), yn = (e, t = {}) => {
  const { duration: n = 700, easing: r = "easeOut" } = t, i = Eo(e);
  gt.get(i)?.();
  const s = i.scrollTop, a = Oo(e, i, t) - s;
  if (Math.abs(a) < 1) return;
  const o = (w) => i.scrollTo({
    top: w,
    behavior: "instant"
  });
  if (n <= 0 || matchMedia("(prefers-reduced-motion: reduce)").matches) return o(s + a);
  const c = gn[r] ?? gn.easeOut, d = new AbortController();
  let l = 0, u = null;
  const m = () => {
    cancelAnimationFrame(l), d.abort(), gt.delete(i);
  }, p = (w) => {
    u ??= w;
    const y = Math.min((w - u) / n, 1);
    o(s + a * c(y)), y < 1 ? l = requestAnimationFrame(p) : m();
  }, g = hr(i) ? window : i;
  for (const w of ["wheel", "touchstart"]) g.addEventListener(w, m, {
    passive: !0,
    signal: d.signal
  });
  gt.set(i, m), l = requestAnimationFrame(p);
}, Ao = (e) => {
  e.magic("smoothScroll", (t) => (n = t, r = {}) => n instanceof Element ? yn(n, r) : yn(t, n));
}, No = [
  wo,
  wa,
  vs,
  Ss,
  va,
  Xa,
  xs,
  To,
  is,
  vo,
  So,
  us,
  ws({
    shopify: !0,
    autoSize: !0
  }),
  Ro,
  ko,
  Ao,
  Ms,
  Bs,
  Rs,
  yo,
  bo
], Do = (e) => e.store("mobileMenu", {
  visible: !1,
  show() {
    this.visible = !0, e.store("search").isOpen = !1;
  },
  hide() {
    this.visible = !1;
  },
  toggle() {
    this.visible ? this.hide() : this.show();
  }
}), qo = (e) => e.store("modal", {
  isOpen: !1,
  open() {
    this.isOpen = !0;
  },
  close() {
    this.isOpen = !1;
  }
}), Lo = [
  Jr,
  Do,
  qo,
  Br
];
Tt.plugin([
  ...No,
  ...Lo,
  ..._i
]);
window.Alpine = Tt;
var Po = Tt, wn = () => {
};
Promise.withResolvers ??= function() {
  let e = wn, t = wn;
  return {
    promise: new this((n, r) => {
      e = n, t = r;
    }),
    resolve: e,
    reject: t
  };
};
Array.prototype.toSorted ??= function(e) {
  return Array.from(this).sort(e);
};
HTMLFormControlsCollection.prototype.toArray ??= function() {
  return Array.from(this);
};
TreeWalker.prototype[Symbol.iterator] ??= function* () {
  let e = this.nextNode();
  for (; e; )
    yield e, e = this.nextNode();
};
function fr(e) {
  return $o(e, !1);
}
function $o(e, t = !1) {
  return e == null ? e : {
    type: e.type,
    id: e.id
  };
}
function mr(e) {
  return Fo(e, !1);
}
function Fo(e, t = !1) {
  return e == null ? e : { code: e.code };
}
function F(e) {
  return _o(e, !1);
}
function _o(e, t = !1) {
  return e == null ? e : {
    initiator: e.initiator,
    pageLoadId: e.pageLoadId,
    pageUrl: e.pageUrl,
    sessionId: e.sessionId,
    timestamp: e.timestamp,
    userId: e.userId,
    attribution: e.attribution == null ? void 0 : e.attribution.map(fr),
    currency: mr(e.currency),
    dev: e.dev,
    IP: e.iP,
    shopperId: e.shopperId,
    userAgent: e.userAgent
  };
}
function ve(e) {
  return Mo(e, !1);
}
function Mo(e, t = !1) {
  return e == null ? e : {
    parentId: e.parentId,
    uid: e.uid,
    sku: e.sku,
    qty: e.qty,
    price: e.price
  };
}
function Jo(e) {
  return Bo(e, !1);
}
function Bo(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    results: e.results.map(ve),
    quickView: e.quickView
  };
}
function At(e) {
  return Uo(e, !1);
}
function Uo(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Jo(e.data)
  };
}
function Nt(e) {
  return jo(e, !1);
}
function jo(e, t = !1) {
  return e == null ? e : { uid: e.uid };
}
function Vo(e) {
  return Ho(e, !1);
}
function Ho(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    tag: e.tag,
    results: e.results.map(ve),
    quickView: e.quickView
  };
}
function zo(e) {
  return Ko(e, !1);
}
function Ko(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Vo(e.data)
  };
}
function pr(e) {
  return Wo(e, !1);
}
function Wo(e, t = !1) {
  return e == null ? e : { uid: e.uid };
}
function gr(e) {
  return !(!("tag" in e) || e.tag === void 0 || !("responseId" in e) || e.responseId === void 0 || !("banners" in e) || e.banners === void 0);
}
function yr(e) {
  return Go(e, !1);
}
function Go(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId,
    banners: e.banners.map(pr)
  };
}
function wr(e) {
  return !(!("type" in e) || e.type === void 0 || !("parentId" in e) || e.parentId === void 0 || !("uid" in e) || e.uid === void 0);
}
function br(e) {
  return Yo(e, !1);
}
function Yo(e, t = !1) {
  return e == null ? e : {
    type: e.type,
    parentId: e.parentId,
    uid: e.uid,
    sku: e.sku
  };
}
function vr(e) {
  return !(!("type" in e) || e.type === void 0 || !("uid" in e) || e.uid === void 0);
}
function Sr(e) {
  return Xo(e, !1);
}
function Xo(e, t = !1) {
  return e == null ? e : {
    type: e.type,
    uid: e.uid
  };
}
function Ir(e) {
  return Qo(e, !1);
}
function Qo(e, t = !1) {
  return e == null || typeof e != "object" ? e : wr(e) ? br(e) : vr(e) ? Sr(e) : {};
}
function Tr(e) {
  return !(!("tag" in e) || e.tag === void 0 || !("responseId" in e) || e.responseId === void 0 || !("results" in e) || e.results === void 0);
}
function xr(e) {
  return Zo(e, !1);
}
function Zo(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId,
    results: e.results.map(Ir),
    quickView: e.quickView
  };
}
function ec(e) {
  return tc(e, !1);
}
function tc(e, t = !1) {
  return e == null || typeof e != "object" ? e : gr(e) ? yr(e) : Tr(e) ? xr(e) : {};
}
function nc(e) {
  return rc(e, !1);
}
function rc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: ec(e.data)
  };
}
function Dt(e) {
  return ic(e, !1);
}
function ic(e, t = !1) {
  return e == null || typeof e != "object" ? e : wr(e) ? br(e) : vr(e) ? Sr(e) : {};
}
function ac(e) {
  return sc(e, !1);
}
function sc(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId,
    results: e.results == null ? void 0 : e.results.map(Dt),
    banners: e.banners.map(Nt),
    quickView: e.quickView
  };
}
function oc(e) {
  return cc(e, !1);
}
function cc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: ac(e.data)
  };
}
function dc(e) {
  return lc(e, !1);
}
function lc(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId
  };
}
function uc(e) {
  return hc(e, !1);
}
function hc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: dc(e.data)
  };
}
function fc(e) {
  return mc(e, !1);
}
function mc(e, t = !1) {
  return e == null ? e : {
    results: e.results.map(ve),
    cart: e.cart.map(ve)
  };
}
function bn(e) {
  return pc(e, !1);
}
function pc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: fc(e.data)
  };
}
function gc(e) {
  return yc(e, !1);
}
function yc(e, t = !1) {
  return e == null ? e : {
    chatSessionId: e.chatSessionId,
    responseId: e.responseId,
    results: e.results.map(ve)
  };
}
function wc(e) {
  return bc(e, !1);
}
function bc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: gc(e.data)
  };
}
function Rr(e) {
  return vc(e, !1);
}
function vc(e, t = !1) {
  return e == null ? e : {
    type: e.type,
    parentId: e.parentId,
    uid: e.uid,
    sku: e.sku
  };
}
function Sc(e) {
  return Ic(e, !1);
}
function Ic(e, t = !1) {
  return e == null ? e : {
    chatSessionId: e.chatSessionId,
    responseId: e.responseId,
    results: e.results.map(Rr)
  };
}
function Tc(e) {
  return xc(e, !1);
}
function xc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Sc(e.data)
  };
}
function Rc(e) {
  return Cc(e, !1);
}
function Cc(e, t = !1) {
  return e == null ? e : {
    chatSessionId: e.chatSessionId,
    feedback: e.feedback
  };
}
function kc(e) {
  return Ec(e, !1);
}
function Ec(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Rc(e.data)
  };
}
function Oc(e) {
  return Ac(e, !1);
}
function Ac(e, t = !1) {
  return e == null ? e : {
    chatSessionId: e.chatSessionId,
    responseId: e.responseId,
    results: e.results.map(Rr)
  };
}
function Nc(e) {
  return Dc(e, !1);
}
function Dc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Oc(e.data)
  };
}
function qc(e) {
  return !(!("responseId" in e) || e.responseId === void 0 || !("banners" in e) || e.banners === void 0);
}
function Lc(e) {
  return Pc(e, !1);
}
function Pc(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    banners: e.banners.map(pr)
  };
}
function $c(e) {
  return !(!("responseId" in e) || e.responseId === void 0 || !("results" in e) || e.results === void 0);
}
function Fc(e) {
  return _c(e, !1);
}
function _c(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    results: e.results.map(Ir),
    quickView: e.quickView
  };
}
function Mc(e) {
  return Jc(e, !1);
}
function Jc(e, t = !1) {
  return e == null || typeof e != "object" ? e : qc(e) ? Lc(e) : $c(e) ? Fc(e) : {};
}
function qt(e) {
  return Bc(e, !1);
}
function Bc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Mc(e.data)
  };
}
function Uc(e) {
  return jc(e, !1);
}
function jc(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    results: e.results.map(Dt),
    banners: e.banners.map(Nt),
    quickView: e.quickView
  };
}
function Lt(e) {
  return Vc(e, !1);
}
function Vc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Uc(e.data)
  };
}
function N(e) {
  return Hc(e, !1);
}
function Hc(e, t) {
  return e == null ? e : { success: e.success == null ? void 0 : e.success };
}
function zc(e) {
  return Kc(e, !1);
}
function Kc(e, t = !1) {
  return e == null ? e : {
    message: e.message,
    stack: e.stack,
    details: e.details
  };
}
function vn(e) {
  return Wc(e, !1);
}
function Wc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: zc(e.data)
  };
}
function Gc(e) {
  return Yc(e, !1);
}
function Yc(e, t = !1) {
  return e == null ? e : {
    orderId: e.orderId,
    transactionTotal: e.transactionTotal,
    total: e.total,
    vat: e.vat,
    city: e.city,
    state: e.state,
    country: e.country,
    results: e.results.map(ve)
  };
}
function Xc(e) {
  return Qc(e, !1);
}
function Qc(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Gc(e.data)
  };
}
function Zc(e) {
  return ed(e, !1);
}
function ed(e, t = !1) {
  return e == null ? e : {
    timestamp: e.timestamp,
    dev: e.dev
  };
}
function td(e) {
  return nd(e, !1);
}
function nd(e, t = !1) {
  return e == null ? e : {
    message: e.message,
    stack: e.stack,
    details: e.details
  };
}
function rd(e) {
  return id(e, !1);
}
function id(e, t = !1) {
  return e == null ? e : {
    context: Zc(e.context),
    data: td(e.data)
  };
}
function ad(e) {
  return sd(e, !1);
}
function sd(e, t = !1) {
  return e == null ? e : {
    parentId: e.parentId,
    uid: e.uid,
    sku: e.sku
  };
}
function od(e) {
  return cd(e, !1);
}
function cd(e, t = !1) {
  return e == null ? e : { result: ad(e.result) };
}
function dd(e) {
  return ld(e, !1);
}
function ld(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: od(e.data)
  };
}
function ud(e) {
  return hd(e, !1);
}
function hd(e, t = !1) {
  return e == null ? e : {
    responseId: e.responseId,
    tag: e.tag,
    results: e.results.map(ve),
    quickView: e.quickView
  };
}
function fd(e) {
  return md(e, !1);
}
function md(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: ud(e.data)
  };
}
function pd(e) {
  return gd(e, !1);
}
function gd(e, t = !1) {
  return e == null || typeof e != "object" ? e : gr(e) ? yr(e) : Tr(e) ? xr(e) : {};
}
function yd(e) {
  return wd(e, !1);
}
function wd(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: pd(e.data)
  };
}
function bd(e) {
  return vd(e, !1);
}
function vd(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId,
    results: e.results == null ? void 0 : e.results.map(Dt),
    banners: e.banners.map(Nt),
    quickView: e.quickView
  };
}
function Sd(e) {
  return Id(e, !1);
}
function Id(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: bd(e.data)
  };
}
function Td(e) {
  return xd(e, !1);
}
function xd(e, t = !1) {
  return e == null ? e : {
    tag: e.tag,
    responseId: e.responseId
  };
}
function Rd(e) {
  return Cd(e, !1);
}
function Cd(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Td(e.data)
  };
}
function kd(e) {
  return Ed(e, !1);
}
function Ed(e, t = !1) {
  return e == null ? e : {
    redirect: e.redirect,
    responseId: e.responseId
  };
}
function Cr(e) {
  return Od(e, !1);
}
function Od(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: kd(e.data)
  };
}
function Ad(e) {
  return Nd(e, !1);
}
function Nd(e, t = !1) {
  return e == null ? e : { responseId: e.responseId };
}
function Pt(e) {
  return Dd(e, !1);
}
function Dd(e, t = !1) {
  return e == null ? e : {
    context: F(e.context),
    data: Ad(e.data)
  };
}
function qd(e) {
  return Ld(e, !1);
}
function Ld(e, t = !1) {
  return e == null ? e : {
    initiator: e.initiator,
    pageLoadId: e.pageLoadId,
    pageUrl: e.pageUrl,
    sessionId: e.sessionId,
    shopperId: e.shopperId,
    timestamp: e.timestamp,
    userId: e.userId,
    attribution: e.attribution == null ? void 0 : e.attribution.map(fr),
    currency: mr(e.currency),
    dev: e.dev,
    IP: e.iP,
    userAgent: e.userAgent
  };
}
function Pd(e) {
  return $d(e, !1);
}
function $d(e, t = !1) {
  return e == null ? e : { context: qd(e.context) };
}
var Fd = "https://analytics.athoscommerce.net/beacon/v2".replace(/\/+$/, ""), kr = class {
  constructor(e = {}) {
    this.configuration = e;
  }
  set config(e) {
    this.configuration = e;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : Fd;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || Or;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const e = this.configuration.apiKey;
    if (e) return typeof e == "function" ? e : () => e;
  }
  get accessToken() {
    const e = this.configuration.accessToken;
    if (e) return typeof e == "function" ? e : async () => e;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
}, _d = new kr(), X = class Er {
  constructor(t = _d) {
    this.configuration = t, this.fetchApi = async (n, r) => {
      let i = {
        url: n,
        init: r
      };
      for (const a of this.middleware) a.pre && (i = await a.pre({
        fetch: this.fetchApi,
        ...i
      }) || i);
      let s;
      try {
        s = await (this.configuration.fetchApi || fetch)(i.url, i.init);
      } catch (a) {
        for (const o of this.middleware) o.onError && (s = await o.onError({
          fetch: this.fetchApi,
          url: i.url,
          init: i.init,
          error: a,
          response: s ? s.clone() : void 0
        }) || s);
        if (s === void 0)
          throw a instanceof Error ? new Ud(a, "The request failed and the interceptors did not return an alternative response") : a;
      }
      for (const a of this.middleware) a.post && (s = await a.post({
        fetch: this.fetchApi,
        url: i.url,
        init: i.init,
        response: s.clone()
      }) || s);
      return s;
    }, this.middleware = t.middleware;
  }
  withMiddleware(...t) {
    const n = this.clone();
    return n.middleware = n.middleware.concat(...t), n;
  }
  withPreMiddleware(...t) {
    const n = t.map((r) => ({ pre: r }));
    return this.withMiddleware(...n);
  }
  withPostMiddleware(...t) {
    const n = t.map((r) => ({ post: r }));
    return this.withMiddleware(...n);
  }
  isJsonMime(t) {
    return t ? Er.jsonRegex.test(t) : !1;
  }
  async request(t, n) {
    const { url: r, init: i } = await this.createFetchParams(t, n), s = await this.fetchApi(r, i);
    if (s && s.status >= 200 && s.status < 300) return s;
    throw new Bd(s, "Response returned an error code");
  }
  async createFetchParams(t, n) {
    let r = this.configuration.basePath + t.path;
    t.query !== void 0 && Object.keys(t.query).length !== 0 && (r += "?" + this.configuration.queryParamsStringify(t.query));
    const i = Object.assign({}, this.configuration.headers, t.headers);
    Object.keys(i).forEach((l) => i[l] === void 0 ? delete i[l] : {});
    const s = typeof n == "function" ? n : async () => n, a = {
      method: t.method,
      headers: i,
      body: t.body,
      credentials: this.configuration.credentials
    }, o = {
      ...a,
      ...await s({
        init: a,
        context: t
      })
    };
    let c;
    Jd(o.body) || o.body instanceof URLSearchParams || Md(o.body) ? c = o.body : this.isJsonMime(i["Content-Type"]) ? c = JSON.stringify(o.body) : c = o.body;
    const d = {
      ...o,
      body: c
    };
    return {
      url: r,
      init: d
    };
  }
  clone() {
    const t = this.constructor, n = new t(this.configuration);
    return n.middleware = this.middleware.slice(), n;
  }
};
X.jsonRegex = /* @__PURE__ */ new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
function Md(e) {
  return typeof Blob < "u" && e instanceof Blob;
}
function Jd(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
var Bd = class extends Error {
  constructor(e, t) {
    super(t), this.response = e, this.name = "ResponseError";
  }
}, Ud = class extends Error {
  constructor(e, t) {
    super(t), this.cause = e, this.name = "FetchError";
  }
}, v = class extends Error {
  constructor(e, t) {
    super(t), this.field = e, this.name = "RequiredError";
  }
};
function Or(e, t = "") {
  return Object.keys(e).map((n) => Ar(n, e[n], t)).filter((n) => n.length > 0).join("&");
}
function Ar(e, t, n = "") {
  const r = n + (n.length ? `[${e}]` : e);
  if (t instanceof Array) {
    const i = t.map((s) => encodeURIComponent(String(s))).join(`&${encodeURIComponent(r)}=`);
    return `${encodeURIComponent(r)}=${i}`;
  }
  return t instanceof Set ? Ar(e, Array.from(t), n) : t instanceof Date ? `${encodeURIComponent(r)}=${encodeURIComponent(t.toISOString())}` : t instanceof Object ? Or(t, r) : `${encodeURIComponent(r)}=${encodeURIComponent(String(t))}`;
}
var D = class {
  constructor(e, t = (n) => n) {
    this.raw = e, this.transformer = t;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
}, jd = class extends X {
  async autocompleteAddtocartRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling autocompleteAddtocart().');
    if (e.addtocartSchema == null) throw new v("addtocartSchema", 'Required parameter "addtocartSchema" was null or undefined when calling autocompleteAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/autocomplete/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: At(e.addtocartSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async autocompleteAddtocart(e, t) {
    return await (await this.autocompleteAddtocartRaw(e, t)).value();
  }
  async autocompleteClickthroughRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling autocompleteClickthrough().');
    if (e.clickthroughSchema == null) throw new v("clickthroughSchema", 'Required parameter "clickthroughSchema" was null or undefined when calling autocompleteClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/autocomplete/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: qt(e.clickthroughSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async autocompleteClickthrough(e, t) {
    return await (await this.autocompleteClickthroughRaw(e, t)).value();
  }
  async autocompleteImpressionRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling autocompleteImpression().');
    if (e.impressionSchema == null) throw new v("impressionSchema", 'Required parameter "impressionSchema" was null or undefined when calling autocompleteImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/autocomplete/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Lt(e.impressionSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async autocompleteImpression(e, t) {
    return await (await this.autocompleteImpressionRaw(e, t)).value();
  }
  async autocompleteRedirectRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling autocompleteRedirect().');
    if (e.redirectSchema == null) throw new v("redirectSchema", 'Required parameter "redirectSchema" was null or undefined when calling autocompleteRedirect().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/autocomplete/redirect";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Cr(e.redirectSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async autocompleteRedirect(e, t) {
    return await (await this.autocompleteRedirectRaw(e, t)).value();
  }
  async autocompleteRenderRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling autocompleteRender().');
    if (e.renderSchema == null) throw new v("renderSchema", 'Required parameter "renderSchema" was null or undefined when calling autocompleteRender().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/autocomplete/render";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Pt(e.renderSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async autocompleteRender(e, t) {
    return await (await this.autocompleteRenderRaw(e, t)).value();
  }
}, Vd = class extends X {
  async bundlesAddtocartRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling bundlesAddtocart().');
    if (e.bundlesAddtocartSchema == null) throw new v("bundlesAddtocartSchema", 'Required parameter "bundlesAddtocartSchema" was null or undefined when calling bundlesAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/bundles/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: zo(e.bundlesAddtocartSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async bundlesAddtocart(e, t) {
    return await (await this.bundlesAddtocartRaw(e, t)).value();
  }
  async bundlesClickthroughRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling bundlesClickthrough().');
    if (e.bundlesClickthroughSchema == null) throw new v("bundlesClickthroughSchema", 'Required parameter "bundlesClickthroughSchema" was null or undefined when calling bundlesClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/bundles/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: nc(e.bundlesClickthroughSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async bundlesClickthrough(e, t) {
    return await (await this.bundlesClickthroughRaw(e, t)).value();
  }
  async bundlesImpressionRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling bundlesImpression().');
    if (e.bundlesImpressionSchema == null) throw new v("bundlesImpressionSchema", 'Required parameter "bundlesImpressionSchema" was null or undefined when calling bundlesImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/bundles/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: oc(e.bundlesImpressionSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async bundlesImpression(e, t) {
    return await (await this.bundlesImpressionRaw(e, t)).value();
  }
  async bundlesRenderRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling bundlesRender().');
    if (e.bundlesRenderSchema == null) throw new v("bundlesRenderSchema", 'Required parameter "bundlesRenderSchema" was null or undefined when calling bundlesRender().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/bundles/render";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: uc(e.bundlesRenderSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async bundlesRender(e, t) {
    return await (await this.bundlesRenderRaw(e, t)).value();
  }
}, Hd = class extends X {
  async cartAddRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling cartAdd().');
    if (e.cartSchema == null) throw new v("cartSchema", 'Required parameter "cartSchema" was null or undefined when calling cartAdd().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/cart/add";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: bn(e.cartSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async cartAdd(e, t) {
    return await (await this.cartAddRaw(e, t)).value();
  }
  async cartRemoveRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling cartRemove().');
    if (e.cartSchema == null) throw new v("cartSchema", 'Required parameter "cartSchema" was null or undefined when calling cartRemove().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/cart/remove";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: bn(e.cartSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async cartRemove(e, t) {
    return await (await this.cartRemoveRaw(e, t)).value();
  }
}, zd = class extends X {
  async categoryAddtocartRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling categoryAddtocart().');
    if (e.addtocartSchema == null) throw new v("addtocartSchema", 'Required parameter "addtocartSchema" was null or undefined when calling categoryAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/category/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: At(e.addtocartSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async categoryAddtocart(e, t) {
    return await (await this.categoryAddtocartRaw(e, t)).value();
  }
  async categoryClickthroughRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling categoryClickthrough().');
    if (e.clickthroughSchema == null) throw new v("clickthroughSchema", 'Required parameter "clickthroughSchema" was null or undefined when calling categoryClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/category/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: qt(e.clickthroughSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async categoryClickthrough(e, t) {
    return await (await this.categoryClickthroughRaw(e, t)).value();
  }
  async categoryImpressionRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling categoryImpression().');
    if (e.impressionSchema == null) throw new v("impressionSchema", 'Required parameter "impressionSchema" was null or undefined when calling categoryImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/category/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Lt(e.impressionSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async categoryImpression(e, t) {
    return await (await this.categoryImpressionRaw(e, t)).value();
  }
  async categoryRenderRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling categoryRender().');
    if (e.renderSchema == null) throw new v("renderSchema", 'Required parameter "renderSchema" was null or undefined when calling categoryRender().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/category/render";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Pt(e.renderSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async categoryRender(e, t) {
    return await (await this.categoryRenderRaw(e, t)).value();
  }
}, Kd = class extends X {
  async chatAddtocartRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling chatAddtocart().');
    if (e.chatAddtocartSchema == null) throw new v("chatAddtocartSchema", 'Required parameter "chatAddtocartSchema" was null or undefined when calling chatAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/chat/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: wc(e.chatAddtocartSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async chatAddtocart(e, t) {
    return await (await this.chatAddtocartRaw(e, t)).value();
  }
  async chatClickthroughRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling chatClickthrough().');
    if (e.chatClickthroughSchema == null) throw new v("chatClickthroughSchema", 'Required parameter "chatClickthroughSchema" was null or undefined when calling chatClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/chat/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Tc(e.chatClickthroughSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async chatClickthrough(e, t) {
    return await (await this.chatClickthroughRaw(e, t)).value();
  }
  async chatFeedbackRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling chatFeedback().');
    if (e.chatFeedbackSchema == null) throw new v("chatFeedbackSchema", 'Required parameter "chatFeedbackSchema" was null or undefined when calling chatFeedback().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/chat/feedback";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: kc(e.chatFeedbackSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async chatFeedback(e, t) {
    return await (await this.chatFeedbackRaw(e, t)).value();
  }
  async chatImpressionRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling chatImpression().');
    if (e.chatImpressionSchema == null) throw new v("chatImpressionSchema", 'Required parameter "chatImpressionSchema" was null or undefined when calling chatImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/chat/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Nc(e.chatImpressionSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async chatImpression(e, t) {
    return await (await this.chatImpressionRaw(e, t)).value();
  }
}, Wd = class extends X {
  async logPersonalizationRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling logPersonalization().');
    if (e.personalizationLogSchema == null) throw new v("personalizationLogSchema", 'Required parameter "personalizationLogSchema" was null or undefined when calling logPersonalization().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/log/personalization";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: rd(e.personalizationLogSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async logPersonalization(e, t) {
    return await (await this.logPersonalizationRaw(e, t)).value();
  }
  async logShopifypixelRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling logShopifypixel().');
    if (e.logSchema == null) throw new v("logSchema", 'Required parameter "logSchema" was null or undefined when calling logShopifypixel().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/log/shopifypixel";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: vn(e.logSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async logShopifypixel(e, t) {
    return await (await this.logShopifypixelRaw(e, t)).value();
  }
  async logSnapRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling logSnap().');
    if (e.logSchema == null) throw new v("logSchema", 'Required parameter "logSchema" was null or undefined when calling logSnap().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/log/snap";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: vn(e.logSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async logSnap(e, t) {
    return await (await this.logSnapRaw(e, t)).value();
  }
};
var Gd = class extends X {
  async orderTransactionRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling orderTransaction().');
    if (e.orderTransactionSchema == null) throw new v("orderTransactionSchema", 'Required parameter "orderTransactionSchema" was null or undefined when calling orderTransaction().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/order/transaction";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Xc(e.orderTransactionSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async orderTransaction(e, t) {
    return await (await this.orderTransactionRaw(e, t)).value();
  }
}, Yd = class extends X {
  async productPageviewRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling productPageview().');
    if (e.productPageviewSchema == null) throw new v("productPageviewSchema", 'Required parameter "productPageviewSchema" was null or undefined when calling productPageview().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/product/pageview";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: dd(e.productPageviewSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async productPageview(e, t) {
    return await (await this.productPageviewRaw(e, t)).value();
  }
}, Xd = class extends X {
  async recommendationsAddtocartRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling recommendationsAddtocart().');
    if (e.recommendationsAddtocartSchema == null) throw new v("recommendationsAddtocartSchema", 'Required parameter "recommendationsAddtocartSchema" was null or undefined when calling recommendationsAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/recommendations/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: fd(e.recommendationsAddtocartSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async recommendationsAddtocart(e, t) {
    return await (await this.recommendationsAddtocartRaw(e, t)).value();
  }
  async recommendationsClickthroughRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling recommendationsClickthrough().');
    if (e.recommendationsClickthroughSchema == null) throw new v("recommendationsClickthroughSchema", 'Required parameter "recommendationsClickthroughSchema" was null or undefined when calling recommendationsClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/recommendations/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: yd(e.recommendationsClickthroughSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async recommendationsClickthrough(e, t) {
    return await (await this.recommendationsClickthroughRaw(e, t)).value();
  }
  async recommendationsImpressionRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling recommendationsImpression().');
    if (e.recommendationsImpressionSchema == null) throw new v("recommendationsImpressionSchema", 'Required parameter "recommendationsImpressionSchema" was null or undefined when calling recommendationsImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/recommendations/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Sd(e.recommendationsImpressionSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async recommendationsImpression(e, t) {
    return await (await this.recommendationsImpressionRaw(e, t)).value();
  }
  async recommendationsRenderRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling recommendationsRender().');
    if (e.recommendationsRenderSchema == null) throw new v("recommendationsRenderSchema", 'Required parameter "recommendationsRenderSchema" was null or undefined when calling recommendationsRender().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/recommendations/render";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Rd(e.recommendationsRenderSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async recommendationsRender(e, t) {
    return await (await this.recommendationsRenderRaw(e, t)).value();
  }
}, Qd = class extends X {
  async searchAddtocartRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling searchAddtocart().');
    if (e.addtocartSchema == null) throw new v("addtocartSchema", 'Required parameter "addtocartSchema" was null or undefined when calling searchAddtocart().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/search/addtocart";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: At(e.addtocartSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async searchAddtocart(e, t) {
    return await (await this.searchAddtocartRaw(e, t)).value();
  }
  async searchClickthroughRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling searchClickthrough().');
    if (e.clickthroughSchema == null) throw new v("clickthroughSchema", 'Required parameter "clickthroughSchema" was null or undefined when calling searchClickthrough().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/search/clickthrough";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: qt(e.clickthroughSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async searchClickthrough(e, t) {
    return await (await this.searchClickthroughRaw(e, t)).value();
  }
  async searchImpressionRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling searchImpression().');
    if (e.impressionSchema == null) throw new v("impressionSchema", 'Required parameter "impressionSchema" was null or undefined when calling searchImpression().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/search/impression";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Lt(e.impressionSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async searchImpression(e, t) {
    return await (await this.searchImpressionRaw(e, t)).value();
  }
  async searchRedirectRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling searchRedirect().');
    if (e.redirectSchema == null) throw new v("redirectSchema", 'Required parameter "redirectSchema" was null or undefined when calling searchRedirect().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/search/redirect";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Cr(e.redirectSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async searchRedirect(e, t) {
    return await (await this.searchRedirectRaw(e, t)).value();
  }
  async searchRenderRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling searchRender().');
    if (e.renderSchema == null) throw new v("renderSchema", 'Required parameter "renderSchema" was null or undefined when calling searchRender().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/search/render";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Pt(e.renderSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async searchRender(e, t) {
    return await (await this.searchRenderRaw(e, t)).value();
  }
}, Zd = class extends X {
  async loginRaw(e, t) {
    if (e.siteId == null) throw new v("siteId", 'Required parameter "siteId" was null or undefined when calling login().');
    if (e.shopperLoginSchema == null) throw new v("shopperLoginSchema", 'Required parameter "shopperLoginSchema" was null or undefined when calling login().');
    const n = {}, r = {};
    r["Content-Type"] = "text/plain";
    let i = "/{siteId}/shopper/login";
    i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
    const s = await this.request({
      path: i,
      method: "POST",
      headers: r,
      query: n,
      body: Pd(e.shopperLoginSchema)
    }, t);
    return new D(s, (a) => N(a));
  }
  async login(e, t) {
    return await (await this.loginRaw(e, t)).value();
  }
}, el = "@athoscommerce/beacon", tl = "1.2.3", nl = "athoscommerce";
var rl = "Javascript library for utilizing Athos Commerce beacon tracking.", il = "dist/cjs/src/index.js", al = "dist/esm/src/index.js", sl = {
  type: "git",
  url: "https://github.com/AthosCommerce/beacon.js.git"
}, ol = "@searchspring/prettier", cl = {
  build: "rm -rf ./dist && npm run generate && tsc && tsc -p tsconfig.cjs.json && npm run build:cdn",
  "build:cdn": "webpack --config webpack.prod.js",
  dev: "tsc --watch & webpack serve --config webpack.dev.js",
  commit: "cz",
  test: "jest",
  "test:watch": "jest --watch",
  generate: "rm -fr ./src/client && openapi-generator-cli generate -i ./beacon.v2.snap.types.oas.yaml -g typescript-fetch -o ./src/client && npm run format",
  format: "prettier --write 'src/**/*.{js,jsx,ts,tsx}'",
  lint: "eslint src --ext .ts,.tsx",
  prepare: "husky",
  version: "standard-version -a",
  postpublish: "git push && git push --tags"
}, dl = { uuid: "9.0.1" }, ll = {
  "@babel/core": "^7.21.4",
  "@babel/preset-env": "^7.21.4",
  "@babel/runtime": "^7.21.0",
  "@openapitools/openapi-generator-cli": "^2.25.2",
  "@searchspring/browserslist-config-snap": "^1.0.7",
  "@searchspring/prettier": "1.0.2",
  "@types/jest": "^29.5.14",
  "@types/uuid": "^10.0.0",
  "babel-loader": "^9.1.2",
  "cz-conventional-changelog": "3.3.0",
  eslint: "9.23.0",
  "eslint-config-prettier": "10.1.1",
  husky: "9.1.7",
  jest: "29.7.0",
  "jest-environment-jsdom": "^29.7.0",
  jsdom: "26.0.0",
  "lint-staged": "15.5.0",
  prettier: "3.5.3",
  "standard-version": "9.5.0",
  "ts-jest": "^29.3.0",
  "ts-loader": "9.4.2",
  typedoc: "0.28.1",
  typescript: "5.8.2",
  "typescript-eslint": "^8.55.0",
  webpack: "^5.77.0",
  "webpack-cli": "^5.0.1",
  "webpack-dev-server": "^4.13.2",
  "webpack-merge": "^5.8.0",
  "whatwg-fetch": "^3.6.20"
}, ul = { commitizen: { path: "./node_modules/cz-conventional-changelog" } }, hl = { universal: "extends @searchspring/browserslist-config-snap/universal" }, fl = {
  name: el,
  version: tl,
  author: nl,
  license: "MIT",
  description: rl,
  main: il,
  module: al,
  repository: sl,
  prettier: ol,
  scripts: cl,
  dependencies: dl,
  devDependencies: ll,
  "lint-staged": { "*.{js,ts,tsx}": ["prettier --write", "eslint"] },
  config: ul,
  browserslist: hl
};
function ml() {
  return {
    cookies: function() {
      return typeof window > "u" ? !1 : window?.navigator?.cookieEnabled;
    },
    storage: function() {
      const e = "ss-test";
      if (typeof window > "u") return !1;
      try {
        return window?.localStorage.setItem(e, e), window?.localStorage.removeItem(e), !0;
      } catch {
        return !1;
      }
    }
  };
}
var Sn = ml(), ze = {
  cookies: Sn.cookies(),
  storage: Sn.storage()
}, In = (e, t, n, r, i) => {
  const s = window.location.protocol == "https:" ? "Secure;" : "", a = "SameSite=" + (n || "Lax") + ";";
  let o = "";
  if (r) {
    const u = /* @__PURE__ */ new Date();
    u.setTime(u.getTime() + r), o = "expires=" + u.toUTCString() + ";";
  }
  const c = encodeURIComponent(t) + ";";
  if (i) return e + "=" + c + o + a + s + "path=/; domain=" + i;
  const d = window?.location?.hostname;
  if (!d || d.split(".").length === 1) return e + "=" + c + o + a + s + "path=/";
  const l = d.split(".");
  return l.shift(), i = "." + l.join("."), e + "=" + c + o + a + s + "path=/; domain=" + i;
}, Be, pl = /* @__PURE__ */ new Uint8Array(16);
function gl() {
  if (!Be && (Be = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Be))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Be(pl);
}
var J = [];
for (let e = 0; e < 256; ++e) J.push((e + 256).toString(16).slice(1));
function yl(e, t = 0) {
  return J[e[t + 0]] + J[e[t + 1]] + J[e[t + 2]] + J[e[t + 3]] + "-" + J[e[t + 4]] + J[e[t + 5]] + "-" + J[e[t + 6]] + J[e[t + 7]] + "-" + J[e[t + 8]] + J[e[t + 9]] + "-" + J[e[t + 10]] + J[e[t + 11]] + J[e[t + 12]] + J[e[t + 13]] + J[e[t + 14]] + J[e[t + 15]];
}
var wl = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Tn = { randomUUID: wl };
function bl(e, t, n) {
  if (Tn.randomUUID && !t && !e) return Tn.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || gl)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (let i = 0; i < 16; ++i) t[n + i] = r[i];
    return t;
  }
  return yl(r);
}
var { version: vl } = fl;
var Ue = 47304e6, xn = 18e5;
var Sl = 20, Il = -1, ue = typeof window < "u" && window.location.hostname && "." + window.location.hostname.replace(/^www\./, "") || void 0, Nr = "userId", Ae = "pageLoadId", Ke = "sessionId", fe = "shopperId", se = "cartProducts", oe = "viewedProducts", me = "attribution", dt = {
  [Nr]: {
    primary: "athosUserId",
    legacy: "ssUserId"
  },
  [Ae]: {
    primary: "athosPageLoadId",
    legacy: "ssPageLoadId"
  },
  [Ke]: {
    primary: "athosSessionId",
    legacy: "ssSessionId"
  },
  [fe]: {
    primary: "athosShopperId",
    legacy: "ssShopperId"
  },
  [se]: {
    primary: "athosCartProducts",
    legacy: "ssCartProducts"
  },
  [oe]: {
    primary: "athosViewedProducts",
    legacy: "ssViewedProducts"
  },
  [me]: {
    primary: "athosAttribution",
    legacy: "ssAttribution"
  }
}, Tl = class {
  constructor(e, t) {
    if (this.mode = "production", this.pageLoadId = "", this.userId = "", this.sessionId = "", this.shopperId = "", this.currency = { code: "" }, this.initiator = "", this.batchIntervalTimeout = 0, this.preflightTimeout = 0, this.requests = [], this.storage = {
      cart: {
        get: () => {
          const a = this.getLocalStorageItem(se);
          if (a) try {
            if (Array.isArray(a)) return a;
          } catch {
            kn(se), this.setCookie(se, "", "Lax", 0, ue);
          }
          else return this.getCookie(se).split(",").filter((o) => o).map((o) => ({
            parentId: o,
            uid: o,
            sku: o,
            qty: 1,
            price: 0
          }));
          return [];
        },
        set: (a) => {
          const o = this.storage.cart.get(), c = JSON.stringify(a);
          try {
            this.setLocalStorageItem(se, a);
          } catch (l) {
            Te(l, this, se, c);
          }
          const d = a.map((l) => this.getProductId(l)).join(",");
          this.setCookie(se, d, "Lax", 0, ue), JSON.stringify(o) !== c && this._sendPreflight();
        },
        add: (a) => {
          if (a.length) {
            const o = [...this.storage.cart.get()];
            a.filter((c) => typeof c == "object" && c.uid).reverse().forEach((c) => {
              const d = o.find((l) => l.uid === c.uid);
              d ? (d.qty += c.qty, d.price = c.price || d.price, (c.parentId !== d.parentId || c.sku !== d.sku) && (d.parentId = c.parentId, d.sku = c.sku)) : o.unshift(c);
            }), this.storage.cart.set(o);
          }
        },
        remove: (a) => {
          if (a.length) {
            const o = [...this.storage.cart.get()];
            a.forEach((d) => {
              const l = o.find((u) => u.uid === d.uid);
              l && l.qty > 0 && (l.qty -= d.qty || 1, (d.parentId !== l.parentId || d.sku !== l.sku) && (l.parentId = d.parentId, l.sku = d.sku));
            });
            const c = o.filter((d) => d.qty > 0);
            this.storage.cart.set(c);
          }
        },
        clear: () => {
          this.storage.cart.set([]);
        }
      },
      viewed: {
        get: () => {
          const a = this.getLocalStorageItem(oe);
          if (a) try {
            if (Array.isArray(a)) return a;
          } catch {
            kn(oe), this.setCookie(oe, "", "Lax", Ue, ue);
          }
          else return this.getCookie(oe).split(",").filter((o) => o).map((o) => ({
            parentId: o,
            uid: o,
            sku: o
          }));
          return [];
        },
        set: (a) => {
          const o = this.storage.viewed.get(), c = a.map((u) => ({
            sku: u.sku,
            parentId: u.parentId,
            uid: u.uid
          })).slice(0, Sl), d = JSON.stringify(c);
          try {
            this.setLocalStorageItem(oe, c);
          } catch (u) {
            Te(u, this, oe, d);
          }
          const l = c.map((u) => this.getProductId(u)).join(",");
          this.setCookie(oe, l, "Lax", Ue, ue), JSON.stringify(o) !== d && this._sendPreflight();
        },
        add: (a) => {
          if (a.length) {
            const o = this.storage.viewed.get();
            a.forEach((c) => {
              const d = {
                sku: c.sku,
                parentId: c.parentId,
                uid: c.uid
              }, l = o.find((u) => u.uid === d.uid);
              if (l) {
                const u = o.indexOf(l);
                o.splice(u, 1);
              }
              o.unshift(d);
            }), this.storage.viewed.set(o);
          }
        }
      }
    }, this.events = {
      shopper: { login: (a) => {
        const o = this.getContext();
        if (!o.shopperId || o.shopperId !== a.data.id) {
          this.setShopperId(a.data.id);
          return;
        }
        if (o.shopperId = a.data?.id, a.data?.id) {
          const c = {
            siteId: a?.siteId || this.globals.siteId,
            shopperLoginSchema: { context: o }
          }, d = this.createRequest("shopper", "login", c);
          this.queueRequest(d);
        }
      } },
      autocomplete: {
        render: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            renderSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("autocomplete", "autocompleteRender", o);
          this.queueRequest(c);
        },
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            impressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("autocomplete", "autocompleteImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            addtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("autocomplete", "autocompleteAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            clickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("autocomplete", "autocompleteClickthrough", o);
          this.sendRequests([c]);
        },
        redirect: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            redirectSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("autocomplete", "autocompleteRedirect", o);
          this.sendRequests([c]);
        }
      },
      search: {
        render: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            renderSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("search", "searchRender", o);
          this.queueRequest(c);
        },
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            impressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("search", "searchImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            addtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("search", "searchAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            clickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("search", "searchClickthrough", o);
          this.sendRequests([c]);
        },
        redirect: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            redirectSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("search", "searchRedirect", o);
          this.sendRequests([c]);
        }
      },
      category: {
        render: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            renderSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("category", "categoryRender", o);
          this.queueRequest(c);
        },
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            impressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("category", "categoryImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            addtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("category", "categoryAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            clickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("category", "categoryClickthrough", o);
          this.sendRequests([c]);
        }
      },
      bundles: {
        render: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            bundlesRenderSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("bundles", "bundlesRender", o);
          this.queueRequest(c);
        },
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            bundlesImpressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("bundles", "bundlesImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            bundlesAddtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("bundles", "bundlesAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            bundlesClickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("bundles", "bundlesClickthrough", o);
          this.sendRequests([c]);
        }
      },
      chat: {
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            chatImpressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("chat", "chatImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            chatAddtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("chat", "chatAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            chatClickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("chat", "chatClickthrough", o);
          this.sendRequests([c]);
        },
        feedback: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            chatFeedbackSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("chat", "chatFeedback", o);
          this.sendRequests([c]);
        }
      },
      recommendations: {
        render: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            recommendationsRenderSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("recommendations", "recommendationsRender", o);
          this.queueRequest(c);
        },
        impression: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            recommendationsImpressionSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("recommendations", "recommendationsImpression", o);
          this.queueRequest(c);
        },
        addToCart: (a) => {
          a.data.results && this.storage.cart.add(a.data.results);
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            recommendationsAddtocartSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("recommendations", "recommendationsAddtocart", o);
          this.queueRequest(c);
        },
        clickThrough: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            recommendationsClickthroughSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("recommendations", "recommendationsClickthrough", o);
          this.sendRequests([c]);
        }
      },
      product: { pageView: (a) => {
        const o = {
          siteId: a?.siteId || this.globals.siteId,
          productPageviewSchema: {
            context: this.getContext(),
            data: a.data
          }
        }, c = this.createRequest("product", "productPageview", o);
        this.sendRequests([c]);
        const d = a.data.result;
        this.storage.viewed.add([d]);
      } },
      cart: {
        add: (a) => {
          const o = { ...a.data };
          o.cart ? this.storage.cart.set(o.cart) : (o.results && this.storage.cart.add(o.results), o.cart = this.storage.cart.get());
          const c = {
            siteId: a?.siteId || this.globals.siteId,
            cartSchema: {
              context: this.getContext(),
              data: o
            }
          }, d = this.createRequest("cart", "cartAdd", c);
          this.sendRequests([d]);
        },
        remove: (a) => {
          const o = { ...a.data };
          o.cart ? this.storage.cart.set(o.cart) : (o.results && this.storage.cart.remove(o.results), o.cart = this.storage.cart.get());
          const c = {
            siteId: a?.siteId || this.globals.siteId,
            cartSchema: {
              context: this.getContext(),
              data: o
            }
          }, d = this.createRequest("cart", "cartRemove", c);
          this.sendRequests([d]);
        }
      },
      order: { transaction: (a) => {
        const o = {
          siteId: a?.siteId || this.globals.siteId,
          orderTransactionSchema: {
            context: this.getContext(),
            data: a.data
          }
        }, c = this.createRequest("order", "orderTransaction", o);
        this.sendRequests([c]), this.storage.cart.clear();
      } },
      error: {
        shopifypixel: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            logSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("error", "logShopifypixel", o);
          this.sendRequests([c]);
        },
        snap: (a) => {
          const o = {
            siteId: a?.siteId || this.globals.siteId,
            logSchema: {
              context: this.getContext(),
              data: a.data
            }
          }, c = this.createRequest("error", "logSnap", o);
          this.sendRequests([c]);
        }
      }
    }, typeof e != "object" || typeof e.siteId != "string") throw new Error('Invalid config passed to tracker. The "siteId" attribute must be provided.');
    this.config = {
      mode: "production",
      ...t || {}
    }, this.config.mode && ["production", "development"].includes(this.config.mode) && (this.mode = this.config.mode);
    const n = this.config.apis?.fetch, r = `${e.siteId}`.trim().toLowerCase().startsWith("at") ? "athos" : "searchspring", i = r === "searchspring" ? "https://analytics.searchspring.net/beacon/v2" : void 0, s = new kr({
      fetchApi: n,
      basePath: this.config.requesters?.beacon?.origin || i,
      headers: { "Content-Type": "text/plain" }
    });
    if (this.apis = {
      shopper: new Zd(s),
      autocomplete: new jd(s),
      search: new Qd(s),
      category: new zd(s),
      recommendations: new Xd(s),
      bundles: new Vd(s),
      chat: new Kd(s),
      product: new Yd(s),
      cart: new Hd(s),
      order: new Gd(s),
      error: new Wd(s)
    }, this.initiator = this.config.initiator || `${r}/beaconjs/${vl}`, this.globals = e, this.pageLoadId = this.getPageLoadId(), this.globals?.siteId) this.globals.siteId = `${this.globals.siteId}`.trim().toLowerCase();
    else throw new Error("Beacon: No siteId found in globals. Beacon will not initialize.");
  }
  setCookie(e, t, n, r, i) {
    ze.cookies && Cn(e, this.globals.siteId).forEach((s) => {
      try {
        if (window.document.cookie = In(s, t, n, r, i), yt(s) == null || yt(s) != t) {
          const a = "." + window.location.hostname;
          window.document.cookie = In(s, t, n, r, a);
        }
      } catch (a) {
        console.error(`Failed to set '${s}' cookie:`, a);
      }
    });
  }
  getLocalStorageItem(e) {
    const t = Rn(e, this.globals.siteId);
    if (typeof window < "u" && ze.storage) {
      let n = "";
      for (const r of t) {
        const i = window.localStorage.getItem(r);
        if (i) {
          n = i;
          break;
        }
      }
      try {
        const r = JSON.parse(n);
        if (r && r.value) return r.value;
        t.forEach((i) => {
          window.localStorage.removeItem(i);
        });
      } catch {
      }
    }
  }
  setLocalStorageItem(e, t) {
    const n = Cn(e, this.globals.siteId);
    if (typeof window < "u" && ze.storage) try {
      const r = JSON.stringify({ value: t });
      n.forEach((i) => {
        window.localStorage.setItem(i, r);
      });
    } catch (r) {
      throw console.warn(`Something went wrong setting local storage item '${e}':`, r), r;
    }
  }
  getCookie(e) {
    const t = Rn(e, this.globals.siteId);
    for (const n of t) {
      const r = yt(n);
      if (r) return r;
    }
    return "";
  }
  queueRequest(e) {
    this.requests.push(e), clearTimeout(this.batchIntervalTimeout), this.batchIntervalTimeout = setTimeout(() => {
      this.processRequests();
    }, 300);
  }
  updateContext(e, t) {
    if (t !== void 0)
      switch (e) {
        case Nr:
        case Ke:
        case fe:
        case Ae:
        case me:
          this[e] = t;
          break;
        case "pageUrl":
          this.config.href = t;
          break;
        case "userAgent":
          this.config.userAgent = t;
          break;
        case "dev":
          ["production", "development"].includes(t) && (this.mode = t);
      }
  }
  getContext() {
    const e = {
      userAgent: this.config.userAgent,
      timestamp: this.getTimestamp(),
      pageUrl: this.config.href || typeof window < "u" && window.location.href || "",
      userId: this.userId || this.getUserId(),
      sessionId: this.sessionId || this.getSessionId(),
      pageLoadId: this.pageLoadId,
      shopperId: this.shopperId || this.getShopperId(),
      initiator: this.initiator,
      dev: this.mode === "development" ? !0 : void 0,
      attribution: this.attribution || this.getAttribution()
    };
    return this.currency.code && (e.currency = { ...this.currency }), e;
  }
  getStoredId(e, t) {
    let n = "", r = "";
    try {
      r = this.getCookie(e);
      const s = this.getLocalStorageItem(e);
      s.timestamp && new Date(s.timestamp).getTime() < Date.now() - t ? (n = this.generateId(), this.attribution = void 0) : n = s.value;
    } catch {
    }
    const i = {
      value: r || n || this.generateId(),
      timestamp: this.getTimestamp()
    };
    e === "userId" && (this.userId = i.value), e === Ke && (this.sessionId = i.value), this.setCookie(e, i.value, "Lax", Il, ue), this.setCookie(e, i.value, "Lax", t);
    try {
      this.setLocalStorageItem(e, i);
    } catch (s) {
      Te(s, this, e, i.value);
    }
    return i.value;
  }
  getPageLoadId() {
    if (this.pageLoadId) return this.pageLoadId;
    let e = this.generateId();
    const t = this.getLocalStorageItem(Ae), n = this.config.href || typeof window < "u" && window.location.href || "";
    if (t) {
      const { href: r, value: i, timestamp: s } = t;
      r === n && i && s && new Date(s).getTime() > Date.now() - 1e4 && (e = i);
    }
    this.pageLoadId = e;
    try {
      this.setLocalStorageItem(Ae, {
        href: n,
        value: e,
        timestamp: this.getTimestamp()
      });
    } catch (r) {
      Te(r, this, Ae, e);
    }
    return e;
  }
  getUserId() {
    return this.userId || this.getStoredId("userId", Ue);
  }
  getSessionId() {
    return this.sessionId || this.getStoredId(Ke, xn);
  }
  getShopperId() {
    try {
      const e = this.getCookie(fe), t = this.getLocalStorageItem(fe), n = e || (t ? "" + t : void 0);
      n && (this.shopperId = n);
    } catch {
    }
    return this.shopperId || "";
  }
  setShopperId(e) {
    if (!e) return;
    const t = this.getShopperId();
    this.shopperId = "" + e, this.setCookie(fe, this.shopperId, "Lax", Ue, ue);
    try {
      this.setLocalStorageItem(fe, this.shopperId);
    } catch (n) {
      Te(n, this, fe, this.shopperId);
    }
    t !== e && (this.events.shopper.login({ data: { id: this.shopperId } }), this._sendPreflight());
  }
  getAttribution() {
    let e = [], t = null;
    try {
      const r = new URL(this.config.href || typeof window < "u" && window.location.href || "");
      t = r.searchParams.get("athos_attribution") || r.searchParams.get("ss_attribution");
    } catch {
    }
    const n = this.getCookie(me) || this.getLocalStorageItem(me);
    if (n) try {
      typeof n == "string" ? e = JSON.parse(n) : Array.isArray(n) && (e = n);
    } catch {
    }
    if (t) try {
      const [r, i] = decodeURIComponent(t).split(":");
      r && i && !e.find((s) => s.type === r && s.id === i) && e.unshift({
        type: r,
        id: i
      });
    } catch {
    }
    if (e.length) {
      const r = JSON.stringify(e);
      this.setCookie(me, r, "Lax", xn, ue);
      try {
        this.setLocalStorageItem(me, e);
      } catch (i) {
        Te(i, this, me, r);
      }
      return this.attribution = e, [...e];
    }
  }
  generateId() {
    return bl();
  }
  getTimestamp() {
    return (/* @__PURE__ */ new Date()).toISOString();
  }
  setCurrency(e) {
    e && e.code && this.currency?.code !== e.code && (this.currency = e);
  }
  pageLoad() {
    return this.pageLoadId = this.generateId(), this.pageLoadId;
  }
  createRequest(e, t, n) {
    return {
      apiType: e,
      endpoint: t,
      payload: n
    };
  }
  getApiClient(e) {
    return this.apis[e];
  }
  sendRequests(e) {
    for (const t of e) {
      const n = this.getApiClient(t.apiType), r = t.endpoint, i = async ({ init: s }) => {
        const a = {
          ...s.headers,
          ...this.config.requesters?.beacon?.headers || {}
        }, o = a && "Content-Type" in a && a["Content-Type"] === "application/json";
        return {
          keepalive: this.mode === "production" ? !0 : void 0,
          body: o ? s.body : JSON.stringify(s.body),
          headers: a
        };
      };
      n[r](t.payload, i).catch((s) => {
        this.mode === "development" && console.debug(s);
      });
    }
  }
  processRequests() {
    const e = this.requests.reduce((n, r) => {
      let i = `${r.payload.siteId}||${r.endpoint}`;
      switch (r.endpoint) {
        case "recommendationsAddtocart": {
          const s = r.payload.recommendationsAddtocartSchema;
          i += K("recommendation", s), z(n, i, "recommendationsAddtocartSchema", r);
          break;
        }
        case "recommendationsImpression": {
          const s = r.payload.recommendationsImpressionSchema;
          i += K("recommendation", s), z(n, i, "recommendationsImpressionSchema", r);
          break;
        }
        case "bundlesAddtocart": {
          const s = r.payload.bundlesAddtocartSchema;
          i += K("bundle", s), z(n, i, "bundlesAddtocartSchema", r);
          break;
        }
        case "bundlesImpression": {
          const s = r.payload.bundlesImpressionSchema;
          i += K("bundle", s), z(n, i, "bundlesImpressionSchema", r);
          break;
        }
        case "chatAddtocart": {
          const s = r.payload.chatAddtocartSchema;
          i += K("chat", s), z(n, i, "chatAddtocartSchema", r);
          break;
        }
        case "chatImpression": {
          const s = r.payload.chatImpressionSchema;
          i += K("chat", s), z(n, i, "chatImpressionSchema", r);
          break;
        }
        case "searchAddtocart": {
          const s = r.payload.addtocartSchema;
          i += K("search", s), z(n, i, "addtocartSchema", r);
          break;
        }
        case "searchImpression": {
          const s = r.payload.impressionSchema;
          i += K("search", s), z(n, i, "impressionSchema", r);
          break;
        }
        case "autocompleteAddtocart": {
          const s = r.payload.addtocartSchema;
          i += K("autocomplete", s), z(n, i, "addtocartSchema", r);
          break;
        }
        case "autocompleteImpression": {
          const s = r.payload.impressionSchema;
          i += K("autocomplete", s), z(n, i, "impressionSchema", r);
          break;
        }
        case "categoryAddtocart": {
          const s = r.payload.addtocartSchema;
          i += K("category", s), z(n, i, "addtocartSchema", r);
          break;
        }
        case "categoryImpression": {
          const s = r.payload.impressionSchema;
          i += K("category", s), z(n, i, "impressionSchema", r);
          break;
        }
        case "login": {
          const s = r.payload.shopperLoginSchema;
          i += K("shopper", s), z(n, i, "shopperLoginSchema", r);
          break;
        }
        default:
          n.nonBatched.push(r);
      }
      return n;
    }, {
      nonBatched: [],
      batches: {}
    });
    this.requests = [];
    const t = Object.values(e.batches).reduce((n, r) => (n.push(r), n), e.nonBatched);
    this.sendRequests(t);
  }
  _sendPreflight() {
    clearTimeout(this.preflightTimeout), this.preflightTimeout = setTimeout(() => {
      this.sendPreflight();
    }, 300);
  }
  sendPreflight(e) {
    const t = e?.userId || this.getUserId(), n = e?.siteId || this.globals.siteId, r = e?.shopper || this.getShopperId(), i = e?.cart || this.storage.cart.get(), s = e?.lastViewed || this.storage.viewed.get();
    if (t && typeof t == "string" && n) {
      const a = {
        userId: t,
        siteId: n
      };
      r && (a.shopper = r), i.length && (a.cart = i.map((d) => this.getProductId(d))), s.length && (a.lastViewed = s.map((d) => this.getProductId(d)));
      const o = `${n}`.toLowerCase().startsWith("at") ? "athoscommerce.net" : "searchspring.io", c = `${this.config.requesters?.personalization?.origin || `https://${n}.a.${o}`}/v1/preflight`;
      (this.config.apis?.fetch || typeof fetch < "u") && (this.config.apis?.fetch || fetch)(c, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          ...this.config.requesters?.personalization?.headers || {}
        },
        body: JSON.stringify(a),
        keepalive: !0
      });
    }
  }
  getProductId(e) {
    return `${e.sku || e.uid || ""}`.trim();
  }
};
function z(e, t, n, r) {
  if (!e.batches[t]) e.batches[t] = JSON.parse(JSON.stringify(r));
  else {
    const i = e.batches[t].payload, s = r.payload, a = i[n], o = s[n];
    if (o?.data?.results) {
      const c = a.data.results || [], d = o.data.results, l = [...c, ...d];
      a.data.results = l;
    }
    if (o?.data?.banners) {
      const c = a?.data?.banners || [], d = o.data.banners, l = [...c, ...d];
      a.data.banners = l;
    }
  }
}
function K(e, t) {
  let n = "";
  return n += `||${t.context.pageLoadId}`, n += `||${t.context.sessionId}`, t.data?.chatSessionId ? n += `||chatSessionId=${t.data.chatSessionId}||responseId=${t.data.responseId}` : t.data?.responseId ? n += `||responseId=${t.data.responseId}` : e === "shopper" && t.context.shopperId && (n += `||shopperId=${t.context.shopperId}`), (e === "recommendation" || e === "bundle") && (n += `||tag=${t.data.tag}`), n;
}
function yt(e) {
  if (typeof window < "u" && ze.cookies) {
    const t = e + "=", n = window.document.cookie.split(";");
    for (let r = 0; r < n.length; r++) {
      let i = n[r];
      for (; i.charAt(0) == " "; ) i = i.substring(1);
      if (i.indexOf(t) == 0) return decodeURIComponent(i.substring(t.length, i.length));
    }
    return "";
  }
  return "";
}
function Rn(e, t) {
  const n = dt[e];
  return t.trim().toLowerCase().startsWith("at") ? [n.primary, n.legacy] : [n.legacy, n.primary];
}
function Cn(e, t) {
  const n = dt[e];
  return t.trim().toLowerCase().startsWith("at") ? [n.primary] : [n.legacy];
}
function kn(e) {
  const t = dt[e];
  typeof window < "u" && (window.localStorage?.removeItem(t.primary), window.localStorage?.removeItem(t.legacy));
}
function Te(e, t, n, r) {
  if (e instanceof Error && e.name === "QuotaExceededError") {
    const i = dt[n];
    t.events.error.snap({ data: {
      message: "QuotaExceededError",
      details: {
        key: i.legacy,
        keyPrimary: i.primary,
        value: r
      }
    } });
  }
}
var lt = class {
  siteId;
  constructor(e) {
    this.siteId = e.siteId;
  }
  dispatch(e, t) {
    return this;
  }
  async context() {
    return null;
  }
}, xl = class extends lt {
  beacon;
  shopper;
  constructor(e) {
    super(e), this.beacon = new Tl({ siteId: e.siteId });
    const t = window.Shopify?.currency?.active;
    t && this.beacon.setCurrency({ code: t }), this.shopper = e.shopperId ? `${e.shopperId}` : null, this.shopper && this.beacon.updateContext("shopperId", this.shopper);
  }
  dispatch(e, t) {
    return kl[e]?.(this.beacon, t), this;
  }
  async context() {
    const { userId: e, sessionId: t, pageLoadId: n } = this.beacon.getContext();
    if (!e || !t || !n) return null;
    const r = window.Alpine?.store("cart").items, i = (r?.length ? r : this.beacon.storage.cart.get()).map(En);
    return {
      userId: e,
      sessionId: t,
      pageLoadId: n,
      shopper: this.shopper,
      cart: [...new Set(i.filter(Boolean))],
      lastViewed: this.beacon.storage.viewed.get().map(En).filter(Boolean)
    };
  }
}, En = (e) => `${e.sku ?? e.uid ?? e.id ?? ""}`.trim(), Rl = class extends lt {
  dispatch(e, t) {
    return console.info(`[TRACKER: ${e}]
${JSON.stringify(t, null, 2)}`), this;
  }
}, It = (e) => e.type === "beacon" ? new xl(e) : e.type === "debug" ? new Rl(e) : new lt(e), Dr = () => window.Shopify, On = () => Dr()?.customerPrivacy?.analyticsProcessingAllowed() ?? !1, Cl = class extends lt {
  config;
  tracker = null;
  pending = [];
  ready;
  constructor(e) {
    super(e), this.config = e;
    const { promise: t, resolve: n } = Promise.withResolvers();
    this.ready = t, Dr()?.loadFeatures?.([{
      name: "consent-tracking-api",
      version: "0.1"
    }], (r) => {
      const i = this.pending ?? [];
      if (this.pending = null, n(), !r)
        for (const [s, a] of i) this.dispatch(s, a);
    });
  }
  async context() {
    if (this.pending && await Promise.race([this.ready, new Promise((e) => setTimeout(e, 300))]), this.pending || !On()) return null;
    try {
      return this.tracker ??= It(this.config), await this.tracker.context();
    } catch (e) {
      return console.warn("[TRACKER]", e), null;
    }
  }
  dispatch(e, t) {
    if (this.pending)
      return this.pending.push([e, t]), this;
    if (!On()) return this;
    try {
      this.tracker ??= It(this.config), this.tracker.dispatch(e, t);
    } catch (n) {
      console.warn("[TRACKER]", n);
    }
    return this;
  }
}, Ll = (e) => (t) => {
  const n = e.type === "beacon" ? new Cl(e) : It(e);
  t.$tracking = n, t.magic("tracking", () => n);
}, kl = {
  AutocompleteRender: (e, t) => e.events.autocomplete.render({ data: t }),
  AutocompleteImpression: (e, t) => e.events.autocomplete.impression({ data: t }),
  AutocompleteClickThrough: (e, t) => e.events.autocomplete.clickThrough({ data: t }),
  AutocompleteAddToCart: (e, t) => e.events.autocomplete.addToCart({ data: t }),
  AutocompleteRedirect: (e, t) => e.events.autocomplete.redirect({ data: t }),
  SearchRender: (e, t) => e.events.search.render({ data: t }),
  SearchImpression: (e, t) => e.events.search.impression({ data: t }),
  SearchClickThrough: (e, t) => e.events.search.clickThrough({ data: t }),
  SearchAddToCart: (e, t) => e.events.search.addToCart({ data: t }),
  SearchRedirect: (e, t) => e.events.search.redirect({ data: t }),
  CategoryRender: (e, t) => e.events.category.render({ data: t }),
  CategoryImpression: (e, t) => e.events.category.impression({ data: t }),
  CategoryClickThrough: (e, t) => e.events.category.clickThrough({ data: t }),
  CategoryAddToCart: (e, t) => e.events.category.addToCart({ data: t }),
  RecommendationsRender: (e, t) => e.events.recommendations.render({ data: t }),
  RecommendationsImpression: (e, t) => e.events.recommendations.impression({ data: t }),
  RecommendationsClickThrough: (e, t) => e.events.recommendations.clickThrough({ data: t }),
  RecommendationsAddToCart: (e, t) => e.events.recommendations.addToCart({ data: t }),
  ProductView: (e, t) => e.events.product.pageView({ data: t }),
  CartAdd: (e, t) => e.events.cart.add({ data: t }),
  CartRemove: (e, t) => e.events.cart.remove({ data: t }),
  CustomerLogin: (e, t) => e.events.shopper.login({ data: t })
}, Pl = Po;
export {
  Po as Alpine,
  Ll as Tracking,
  Pl as default
};
